import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  SerializedBoolean: { input: any; output: any; }
};

export type ActivateEbmsIdentityPayload = {
  readonly __typename?: 'ActivateEbmsIdentityPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly person: Maybe<Person>;
};

export const enum ApplicantSalutation {
  Formal = 'formal',
  Informal = 'informal'
};

export type ApplicationQuestion = {
  readonly __typename?: 'ApplicationQuestion';
  readonly answerType: Maybe<JobsApplicationQuestionAnswerTypeEnum>;
  readonly answers: Maybe<Scalars['JSON']['output']>;
  readonly filterEnabled: Scalars['Boolean']['output'];
  readonly filterKeywords: Maybe<Scalars['String']['output']>;
  readonly filterLocations: Maybe<Scalars['String']['output']>;
  readonly filterSubJobTypes: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly organisationId: Maybe<Scalars['ID']['output']>;
  readonly questionDe: Maybe<Scalars['String']['output']>;
  readonly questionEn: Maybe<Scalars['String']['output']>;
  readonly remoteId: Maybe<Scalars['String']['output']>;
  readonly screenerEnabled: Scalars['Boolean']['output'];
  readonly screenerRejectionFeedbackDe: Maybe<Scalars['String']['output']>;
  readonly screenerRejectionFeedbackEn: Maybe<Scalars['String']['output']>;
  readonly visibleByWatchers: Scalars['Boolean']['output'];
};

export type ApplicationStatistic = {
  readonly __typename?: 'ApplicationStatistic';
  readonly allowedReference: Maybe<Scalars['Boolean']['output']>;
  readonly applicantSessionHash: Maybe<Scalars['String']['output']>;
  readonly applicationIdentifier: Maybe<Scalars['String']['output']>;
  readonly coworkrRecommender: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isUnsolicited: Scalars['Boolean']['output'];
  readonly jobNummer: Maybe<Scalars['String']['output']>;
  readonly jobOrganisation: Maybe<Scalars['String']['output']>;
  readonly jobTitle: Maybe<Scalars['String']['output']>;
  readonly organisation: Maybe<Scalars['String']['output']>;
  readonly origin: Scalars['String']['output'];
  readonly recommendationType: Maybe<Recommendation>;
  readonly recommendedBy: Maybe<Scalars['String']['output']>;
  readonly refcode: Maybe<Scalars['String']['output']>;
  readonly senddate: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ApplyAttributes = {
  readonly id: Scalars['ID']['input'];
  readonly userApplicationEmpfehlungsbundCount: InputMaybe<Scalars['Float']['input']>;
  readonly userApplicationTotalCount: InputMaybe<Scalars['Float']['input']>;
  readonly userHiredEmpfehlungsbundCount: InputMaybe<Scalars['Float']['input']>;
  readonly userHiredTotalCount: InputMaybe<Scalars['Float']['input']>;
};

export type ApplyOptionAttributes = {
  readonly applicationQuestionIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly ebmsScreenerEnabled: InputMaybe<Scalars['Boolean']['input']>;
  readonly files: InputMaybe<ApplyOptionEnabledEnum>;
  readonly firstName: InputMaybe<ApplyOptionEnabledEnum>;
  readonly gender: InputMaybe<ApplyOptionEnabledEnum>;
  readonly id: InputMaybe<Scalars['ID']['input']>;
  readonly lastName: InputMaybe<ApplyOptionEnabledEnum>;
  readonly postalAddress: InputMaybe<ApplyOptionEnabledEnum>;
  readonly requiredDocumentsDe: InputMaybe<Scalars['String']['input']>;
  readonly requiredDocumentsEn: InputMaybe<Scalars['String']['input']>;
  readonly screenerActive: InputMaybe<Scalars['Boolean']['input']>;
  readonly screenerKeepForDays: InputMaybe<Scalars['Int']['input']>;
  readonly screenerTemplateDe: InputMaybe<Scalars['String']['input']>;
  readonly screenerTemplateEn: InputMaybe<Scalars['String']['input']>;
  readonly telephone: InputMaybe<ApplyOptionEnabledEnum>;
};

export const enum ApplyOptionEnabledEnum {
  EnabledAndOptional = 'enabled_and_optional',
  EnabledAndRequired = 'enabled_and_required',
  Hidden = 'hidden'
};

export type ApplySettingsPayload = {
  readonly __typename?: 'ApplySettingsPayload';
  readonly applyOption: Maybe<OrganisationApplyOption>;
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export const enum AvailableLanguages {
  De = 'de',
  En = 'en'
};

export type BaAction = {
  readonly __typename?: 'BaAction';
  readonly action: Scalars['String']['output'];
  readonly baId: Scalars['String']['output'];
  readonly conUrl: Maybe<Scalars['String']['output']>;
  readonly confirmedByBa: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly error: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isOnline: Scalars['Boolean']['output'];
  readonly translatedAction: Scalars['String']['output'];
};

export type BannerGeneratorBanner = {
  readonly __typename?: 'BannerGeneratorBanner';
  readonly contentHash: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly layout: BannerGeneratorLayout;
  readonly quality: Maybe<ImageQualityResult>;
  readonly ready: Scalars['Boolean']['output'];
  readonly slots: ReadonlyArray<BannerGeneratorSlot>;
  readonly url: Maybe<Scalars['String']['output']>;
};

export type BannerGeneratorImage = {
  readonly __typename?: 'BannerGeneratorImage';
  readonly id: Scalars['ID']['output'];
  readonly nativeResolution: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
};

export type BannerGeneratorLayout = {
  readonly __typename?: 'BannerGeneratorLayout';
  readonly id: Scalars['ID']['output'];
  readonly resolution: Scalars['String']['output'];
  readonly slots: ReadonlyArray<BannerGeneratorSlotConfig>;
  readonly title: Scalars['String']['output'];
};

export type BannerGeneratorSlot = {
  readonly __typename?: 'BannerGeneratorSlot';
  readonly id: Scalars['ID']['output'];
  readonly image: BannerGeneratorImage;
  readonly position: Scalars['Int']['output'];
};

export type BannerGeneratorSlotConfig = {
  readonly __typename?: 'BannerGeneratorSlotConfig';
  readonly aspect: Maybe<Scalars['Float']['output']>;
  readonly height: Scalars['Int']['output'];
  readonly position: Maybe<Scalars['Int']['output']>;
  readonly slots: Maybe<ReadonlyArray<BannerGeneratorSlotConfig>>;
  readonly width: Scalars['Int']['output'];
};

export type BannerUpdateInput = {
  readonly layoutId: InputMaybe<Scalars['ID']['input']>;
  readonly slots: ReadonlyArray<SlotInput>;
};

export type BenefitsPayload = {
  readonly __typename?: 'BenefitsPayload';
  readonly benefits: Maybe<ReadonlyArray<JobsBenefit>>;
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type Beruf = {
  readonly __typename?: 'Beruf';
  readonly ausbildung: Scalars['Boolean']['output'];
  readonly deprecated: Scalars['Boolean']['output'];
  readonly displayName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

export type BmsShortIdentity = {
  readonly __typename?: 'BmsShortIdentity';
  readonly email: Scalars['String']['output'];
  readonly fullName: Scalars['String']['output'];
  readonly listNameWithPosition: Scalars['String']['output'];
};

export type BmsStatePayload = {
  readonly __typename?: 'BmsStatePayload';
  readonly bmsState: Scalars['String']['output'];
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type BmsTeam = {
  readonly __typename?: 'BmsTeam';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type CpcProvider = {
  readonly __typename?: 'CPCProvider';
  readonly description: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly logoUrl: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
};

export type ChangeTierLevelPayload = {
  readonly __typename?: 'ChangeTierLevelPayload';
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
  readonly tier: Maybe<TierAbility>;
};

export type ChangeUserNamePayload = {
  readonly __typename?: 'ChangeUserNamePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly organisation: Organisation;
};

export type ClicksStatistic = {
  readonly __typename?: 'ClicksStatistic';
  /** @deprecated Use `count` instead */
  readonly clicksCount: Scalars['Int']['output'];
  readonly count: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly jobDomain: Maybe<Scalars['String']['output']>;
  readonly jobNummer: Maybe<Scalars['String']['output']>;
  readonly jobTitle: Maybe<Scalars['String']['output']>;
  readonly onlineDays: Maybe<Scalars['String']['output']>;
};

export type CommunityManager = {
  readonly __typename?: 'CommunityManager';
  readonly assistant: Maybe<CommunityManager>;
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly image: Maybe<Scalars['String']['output']>;
  readonly ldapLogin: Maybe<Scalars['String']['output']>;
  readonly name: CommunityManagerName;
  readonly teamsBookingsUrl: Maybe<Scalars['String']['output']>;
  readonly telephone: Maybe<Scalars['String']['output']>;
};

export type CommunityManagerName = {
  readonly __typename?: 'CommunityManagerName';
  readonly displayName: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly lastName: Scalars['String']['output'];
};

export type CommunityQuote = {
  readonly __typename?: 'CommunityQuote';
  readonly author: Maybe<Person>;
  readonly communityQuoteRelevance: Maybe<CommunityQuoteCommunityQuoteRelevanceEnum>;
  readonly id: Scalars['ID']['output'];
  readonly quote: Maybe<Scalars['String']['output']>;
};


export type CommunityQuoteQuoteArgs = {
  lang: InputMaybe<AvailableLanguages>;
};

export type CommunityQuoteAttributes = {
  readonly communityQuoteRelevance: InputMaybe<Scalars['String']['input']>;
  readonly id: InputMaybe<Scalars['ID']['input']>;
  readonly organisationId: Scalars['ID']['input'];
  readonly personId: InputMaybe<Scalars['ID']['input']>;
  readonly quote: InputMaybe<Scalars['String']['input']>;
  readonly quoteEn: InputMaybe<Scalars['String']['input']>;
};

export const enum CommunityQuoteCommunityQuoteRelevanceEnum {
  Neutral = 'neutral',
  Positive = 'positive',
  Promotional = 'promotional'
};

export const enum CommunityQuoteEnum {
  All = 'all',
  PositiveOrAbove = 'positive_or_above',
  Promotional = 'promotional'
};

export type CommunityQuotePayload = {
  readonly __typename?: 'CommunityQuotePayload';
  readonly communityQuote: Maybe<CommunityQuote>;
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type Competence = {
  readonly __typename?: 'Competence';
  readonly id: Scalars['ID']['output'];
  /** @deprecated Use `words` instead */
  readonly keywords: ReadonlyArray<Scalars['String']['output']>;
  readonly mainWord: Scalars['String']['output'];
  readonly portalTypes: Maybe<ReadonlyArray<PortalType>>;
  readonly words: ReadonlyArray<CompetenceWord>;
};


export type CompetenceKeywordsArgs = {
  locale: InputMaybe<AvailableLanguages>;
};

export const enum CompetenceCategory {
  Occupation = 'occupation',
  Position = 'position',
  Sector = 'sector',
  Tool = 'tool'
};

export type CompetenceWord = {
  readonly __typename?: 'CompetenceWord';
  readonly competenceTypes: ReadonlyArray<CompetenceCategory>;
  readonly id: Scalars['ID']['output'];
  readonly keywords: ReadonlyArray<Scalars['String']['output']>;
  readonly keywordsDe: ReadonlyArray<Scalars['String']['output']>;
  readonly keywordsEn: ReadonlyArray<Scalars['String']['output']>;
  readonly main: Scalars['String']['output'];
};

export type CoworkrStatePayload = {
  readonly __typename?: 'CoworkrStatePayload';
  readonly coworkrState: Scalars['String']['output'];
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type CreateDepartmentPayload = {
  readonly __typename?: 'CreateDepartmentPayload';
  readonly department: Maybe<EmployeeSurveysDepartment>;
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type CreateJobInput = {
  readonly applicantServiceBureaucracyService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceFamilyService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceGermanEducation: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceHousingService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceRecognitionService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceSocialService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceVideoUsed: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceVisaService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceVisitPossible: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServices: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly applicationQuestionIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly autoRefresh: InputMaybe<Scalars['Boolean']['input']>;
  readonly baBerufId: InputMaybe<Scalars['Int']['input']>;
  readonly baBerufeIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly baHandicap: InputMaybe<Scalars['String']['input']>;
  readonly baIgnore: InputMaybe<Scalars['Boolean']['input']>;
  readonly benefitIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly bewerbungsweg: Scalars['String']['input'];
  readonly blobId: InputMaybe<Scalars['String']['input']>;
  readonly blobUrl: InputMaybe<Scalars['String']['input']>;
  readonly bmsTeamId: InputMaybe<Scalars['Int']['input']>;
  readonly bundesweit: InputMaybe<Scalars['Boolean']['input']>;
  readonly customWeight: InputMaybe<Scalars['String']['input']>;
  readonly deleteDocument: InputMaybe<Scalars['Boolean']['input']>;
  readonly deleteOgImage: InputMaybe<Scalars['Boolean']['input']>;
  readonly description: InputMaybe<Scalars['String']['input']>;
  readonly divisionIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly experienceLevelIntermediate: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelJunior: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelQuereinstieg: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelSenior: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelUngelernt: InputMaybe<Scalars['Boolean']['input']>;
  readonly expirationDate: InputMaybe<Scalars['String']['input']>;
  readonly externalJobboardSettings: InputMaybe<Scalars['JSON']['input']>;
  readonly extraOrt: InputMaybe<Scalars['String']['input']>;
  readonly fid: InputMaybe<Scalars['Int']['input']>;
  readonly headerImageBlobId: InputMaybe<Scalars['String']['input']>;
  readonly headerImageId: InputMaybe<Scalars['Int']['input']>;
  readonly internal: InputMaybe<Scalars['Boolean']['input']>;
  readonly jobGptId: InputMaybe<Scalars['String']['input']>;
  readonly jobGptType: InputMaybe<Scalars['String']['input']>;
  readonly jobSharing: InputMaybe<Scalars['Boolean']['input']>;
  readonly languageLevelEnglish: InputMaybe<Scalars['String']['input']>;
  readonly languageLevelGerman: InputMaybe<Scalars['String']['input']>;
  readonly languageLevelOther: InputMaybe<Scalars['String']['input']>;
  readonly languageOther: InputMaybe<Scalars['String']['input']>;
  readonly link: Scalars['String']['input'];
  readonly masterJobId: InputMaybe<Scalars['Int']['input']>;
  readonly nummer: Scalars['String']['input'];
  readonly ogImageBlobId: InputMaybe<Scalars['String']['input']>;
  readonly ogImageId: InputMaybe<Scalars['Int']['input']>;
  readonly parentJobId: InputMaybe<Scalars['Int']['input']>;
  readonly personIds: ReadonlyArray<Scalars['Int']['input']>;
  readonly portalType: Scalars['String']['input'];
  readonly pubdate: InputMaybe<Scalars['String']['input']>;
  readonly relocationSupport: InputMaybe<Scalars['String']['input']>;
  readonly relocationSupportDescription: InputMaybe<Scalars['String']['input']>;
  readonly remoteCountryList: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly remoteType: InputMaybe<Scalars['String']['input']>;
  readonly salaryInterval: InputMaybe<Scalars['String']['input']>;
  readonly salaryMax: InputMaybe<Scalars['Float']['input']>;
  readonly salaryMin: InputMaybe<Scalars['Float']['input']>;
  readonly subJobType: Scalars['String']['input'];
  readonly subprofileId: InputMaybe<Scalars['Int']['input']>;
  readonly tags: InputMaybe<Scalars['String']['input']>;
  readonly targetAudienceCountry: InputMaybe<Scalars['String']['input']>;
  readonly targetAudienceWorkPermit: InputMaybe<Scalars['String']['input']>;
  readonly tarifvertragId: InputMaybe<Scalars['ID']['input']>;
  readonly tarifvertragLevelMaxId: InputMaybe<Scalars['ID']['input']>;
  readonly tarifvertragLevelMinId: InputMaybe<Scalars['ID']['input']>;
  readonly tarifvertragSalaryGroup: InputMaybe<Scalars['String']['input']>;
  readonly temporary: InputMaybe<Scalars['Boolean']['input']>;
  readonly temporaryConversionToPermanentPossible: InputMaybe<Scalars['Boolean']['input']>;
  readonly temporaryEnd: InputMaybe<Scalars['String']['input']>;
  readonly title: InputMaybe<Scalars['String']['input']>;
  readonly translatedContents: InputMaybe<ReadonlyArray<TranslatedContentInput>>;
  readonly userAddressIds: ReadonlyArray<Scalars['Int']['input']>;
  readonly vacationMax: InputMaybe<Scalars['Int']['input']>;
  readonly vacationMin: InputMaybe<Scalars['Int']['input']>;
  readonly visible: InputMaybe<Scalars['Boolean']['input']>;
  readonly workingTime: InputMaybe<Scalars['String']['input']>;
  readonly workingTimeHoursMax: InputMaybe<Scalars['Float']['input']>;
  readonly workingTimeHoursMin: InputMaybe<Scalars['Float']['input']>;
};

export type CreateJobPayload = {
  readonly __typename?: 'CreateJobPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly manualJob: Maybe<JobsManualJob>;
};

export type CreateMetascoreProfilePayload = {
  readonly __typename?: 'CreateMetascoreProfilePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly metascoreProfile: Maybe<FkMetascoreProfile>;
};

export type CreateOrganisationAddressPayload = {
  readonly __typename?: 'CreateOrganisationAddressPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly organisationAddress: Maybe<UserAddress>;
};

export type CreateParticipantPayload = {
  readonly __typename?: 'CreateParticipantPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly participant: Maybe<EmployeeSurveysParticipant>;
};

export type CreatePersonPayload = {
  readonly __typename?: 'CreatePersonPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly person: Maybe<Person>;
};

export type DashboardLayout = {
  readonly __typename?: 'DashboardLayout';
  readonly collapsed: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly faved: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type DashboardLayoutAttributes = {
  readonly collapsed: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly faved: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type DeleteDepartmentPayload = {
  readonly __typename?: 'DeleteDepartmentPayload';
  readonly department: Maybe<EmployeeSurveysDepartment>;
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type DeleteJobPayload = {
  readonly __typename?: 'DeleteJobPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly manualJob: Maybe<JobsManualJob>;
};

export type DeleteMetascoreProfilePayload = {
  readonly __typename?: 'DeleteMetascoreProfilePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly success: Scalars['Boolean']['output'];
};

export type DeleteParticipantPayload = {
  readonly __typename?: 'DeleteParticipantPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly participant: Maybe<EmployeeSurveysParticipant>;
};

export type DepartmentInput = {
  readonly name: Scalars['String']['input'];
  readonly parentId: InputMaybe<Scalars['ID']['input']>;
};

export type DepartmentSelectionArgument = {
  readonly departmentId: Scalars['Int']['input'];
  readonly departmentName: InputMaybe<Scalars['String']['input']>;
  readonly displayName: InputMaybe<Scalars['String']['input']>;
  readonly name: InputMaybe<Scalars['String']['input']>;
  readonly weight: Scalars['Int']['input'];
};

export type DepartmentSelectionsPayload = {
  readonly __typename?: 'DepartmentSelectionsPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type DispositionUpdateInput = {
  readonly indeedApplicantId: Scalars['ID']['input'];
  readonly rawDispositionDetails: InputMaybe<Scalars['String']['input']>;
  readonly rawDispositionStatus: Scalars['String']['input'];
  readonly status: IndeedApplicantStatusEnum;
  readonly statusChangeDateTime: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type DivisionAttributes = {
  readonly id: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly nameEn: InputMaybe<Scalars['String']['input']>;
  readonly organisationId: Scalars['ID']['input'];
};

export type DivisionsPayload = {
  readonly __typename?: 'DivisionsPayload';
  readonly divisions: Maybe<ReadonlyArray<JobsDivision>>;
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type DomainActivationsPayload = {
  readonly __typename?: 'DomainActivationsPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly organisation: Organisation;
};

export type DomainBase = {
  readonly __typename?: 'DomainBase';
  readonly accentColor: Maybe<Scalars['String']['output']>;
  readonly bereich: Maybe<Scalars['String']['output']>;
  readonly bereichKomplett: Maybe<Scalars['String']['output']>;
  readonly bereichKurz: Maybe<Scalars['String']['output']>;
  readonly branchen: Maybe<Scalars['String']['output']>;
  readonly cities: Maybe<Scalars['String']['output']>;
  readonly deutschlandkarte: Scalars['String']['output'];
  readonly favicon: Scalars['String']['output'];
  readonly filterTags: ReadonlyArray<Scalars['String']['output']>;
  readonly hostname: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly importLocations: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly key: Scalars['String']['output'];
  readonly lightPortal: Maybe<Scalars['Boolean']['output']>;
  readonly linkColor: Maybe<Scalars['String']['output']>;
  readonly logo: Scalars['String']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly portalType: PortalType;
  readonly region: Maybe<Scalars['String']['output']>;
  readonly slogan: Maybe<Scalars['String']['output']>;
  readonly thirdColor: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
};


export type DomainBaseBereichArgs = {
  lang: InputMaybe<AvailableLanguages>;
};


export type DomainBaseBereichKomplettArgs = {
  lang: InputMaybe<AvailableLanguages>;
};


export type DomainBaseBereichKurzArgs = {
  lang: InputMaybe<AvailableLanguages>;
};


export type DomainBaseBranchenArgs = {
  lang: InputMaybe<AvailableLanguages>;
};


export type DomainBaseCitiesArgs = {
  lang: InputMaybe<AvailableLanguages>;
};


export type DomainBaseDeutschlandkarteArgs = {
  variant: InputMaybe<DomainBaseDeutschlandkarteVariantsEnum>;
};


export type DomainBaseFaviconArgs = {
  variant: InputMaybe<DomainBaseFaviconVariantsEnum>;
};


export type DomainBaseLogoArgs = {
  variant: InputMaybe<DomainBaseLogoVariantsEnum>;
};


export type DomainBaseSloganArgs = {
  lang: InputMaybe<AvailableLanguages>;
};

export const enum DomainBaseDeutschlandkarteVariantsEnum {
  Medium = 'medium',
  Original = 'original'
};

export const enum DomainBaseFaviconVariantsEnum {
  Medium = 'medium',
  Original = 'original'
};

export const enum DomainBaseLogoVariantsEnum {
  Icon = 'icon',
  Large = 'large',
  Medium = 'medium',
  Original = 'original',
  SameHeight = 'same_height',
  Thumb = 'thumb'
};

export type DomainDeactivation = {
  readonly __typename?: 'DomainDeactivation';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly domain: DomainBase;
  readonly id: Scalars['Int']['output'];
  readonly membership: Maybe<Membership>;
};

export type DomainDeactivationsPayload = {
  readonly __typename?: 'DomainDeactivationsPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly organisation: Organisation;
};

export type Empfehlungscode = {
  readonly __typename?: 'Empfehlungscode';
  readonly code: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly title: Maybe<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
};

export type EmployeeCountAttributes = {
  readonly employeeCount: Scalars['Int']['input'];
  readonly employeeCountForBilling: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeCountPayload = {
  readonly __typename?: 'EmployeeCountPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly organisation: Maybe<Organisation>;
};

export type EmployeeStatistic = {
  readonly __typename?: 'EmployeeStatistic';
  readonly canUpdate: Scalars['Boolean']['output'];
  readonly createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly employeeCount: Maybe<Scalars['Int']['output']>;
  readonly employeeCountForBilling: Maybe<Scalars['Int']['output']>;
  readonly hasBillingCount: Scalars['Boolean']['output'];
};

export type EmployeeSurveysAnswerOption = {
  readonly __typename?: 'EmployeeSurveysAnswerOption';
  readonly de: Scalars['String']['output'];
  readonly en: Scalars['String']['output'];
  readonly value: Maybe<Scalars['String']['output']>;
};

export type EmployeeSurveysAnswerOptionLocalized = {
  readonly __typename?: 'EmployeeSurveysAnswerOptionLocalized';
  readonly text: Scalars['String']['output'];
  readonly value: Scalars['JSON']['output'];
};

export type EmployeeSurveysDepartment = {
  readonly __typename?: 'EmployeeSurveysDepartment';
  readonly ancestors: ReadonlyArray<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly nameWithPath: Scalars['String']['output'];
  readonly parent: Maybe<EmployeeSurveysDepartment>;
  readonly parentId: Maybe<Scalars['ID']['output']>;
  readonly subDepartments: ReadonlyArray<EmployeeSurveysDepartment>;
};

export type EmployeeSurveysModel = {
  readonly __typename?: 'EmployeeSurveysModel';
  readonly asHtml: Scalars['String']['output'];
  readonly author: Maybe<Scalars['String']['output']>;
  readonly critics: Maybe<Scalars['String']['output']>;
  readonly description: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly instrument: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly shortCode: Scalars['String']['output'];
  readonly updatedYear: Maybe<Scalars['Int']['output']>;
  readonly validityAndReliability: Maybe<Scalars['String']['output']>;
  readonly variables: Maybe<Scalars['String']['output']>;
  readonly year: Maybe<Scalars['Int']['output']>;
};

export type EmployeeSurveysOrganisationSurvey = {
  readonly __typename?: 'EmployeeSurveysOrganisationSurvey';
  readonly ageGroupOptions: ReadonlyArray<FormOption>;
  readonly configuration: Maybe<Scalars['JSON']['output']>;
  readonly departments: ReadonlyArray<EmployeeSurveysDepartment>;
  readonly genderOptions: ReadonlyArray<FormOption>;
  readonly greeting: Maybe<Scalars['String']['output']>;
  readonly id: Maybe<Scalars['ID']['output']>;
  readonly internalName: Scalars['String']['output'];
  readonly locationOptions: ReadonlyArray<FormOption>;
  readonly participants: ReadonlyArray<EmployeeSurveysParticipant>;
  readonly parts: ReadonlyArray<EmployeeSurveysSurveyPart>;
  readonly person: Maybe<Person>;
  readonly seniorityOptions: ReadonlyArray<FormOption>;
};


export type EmployeeSurveysOrganisationSurveyPartsArgs = {
  forParticipantId: InputMaybe<Scalars['ID']['input']>;
};

export type EmployeeSurveysParticipant = {
  readonly __typename?: 'EmployeeSurveysParticipant';
  readonly ageGroup: Maybe<Scalars['String']['output']>;
  readonly code: Scalars['String']['output'];
  readonly department: Maybe<EmployeeSurveysDepartment>;
  readonly departmentId: Maybe<Scalars['ID']['output']>;
  readonly gender: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly location: Maybe<Scalars['String']['output']>;
  readonly seniority: Maybe<Scalars['String']['output']>;
  readonly status: Maybe<EmployeeSurveysParticipantStatusEnum>;
};

export const enum EmployeeSurveysParticipantStatusEnum {
  Completed = 'completed',
  Started = 'started',
  Untouched = 'untouched'
};

export type EmployeeSurveysQuestion = {
  readonly __typename?: 'EmployeeSurveysQuestion';
  readonly answerOptions: Maybe<ReadonlyArray<EmployeeSurveysAnswerOption>>;
  readonly answerOptionsLocalized: ReadonlyArray<EmployeeSurveysAnswerOptionLocalized>;
  readonly answerType: Maybe<EmployeeSurveysQuestionAnswerTypeEnum>;
  readonly id: Scalars['ID']['output'];
  readonly modelCode: Maybe<Scalars['String']['output']>;
  readonly position: Scalars['Int']['output'];
  readonly readOnly: Scalars['Boolean']['output'];
  readonly text: Scalars['String']['output'];
  readonly textDe: Scalars['String']['output'];
  readonly textEn: Scalars['String']['output'];
};


export type EmployeeSurveysQuestionTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export const enum EmployeeSurveysQuestionAnswerTypeEnum {
  CheckBoxes = 'check_boxes',
  Likert = 'likert',
  RadioButtons = 'radio_buttons',
  String = 'string',
  Text = 'text'
};

export type EmployeeSurveysStatePayload = {
  readonly __typename?: 'EmployeeSurveysStatePayload';
  readonly employeeSurveysState: Scalars['String']['output'];
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type EmployeeSurveysSurveyPart = {
  readonly __typename?: 'EmployeeSurveysSurveyPart';
  readonly description: Maybe<Scalars['String']['output']>;
  readonly descriptionDe: Maybe<Scalars['String']['output']>;
  readonly descriptionEn: Maybe<Scalars['String']['output']>;
  readonly explanation: Maybe<Scalars['String']['output']>;
  readonly global: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly organisationId: Maybe<Scalars['Int']['output']>;
  readonly position: Maybe<Scalars['Int']['output']>;
  readonly questions: ReadonlyArray<EmployeeSurveysQuestion>;
  readonly subject: Maybe<EmployeeSurveysSurveyPartSubjectEnum>;
  readonly surveyPartType: Maybe<EmployeeSurveysSurveyPartSurveyPartTypeEnum>;
  readonly title: Maybe<Scalars['String']['output']>;
  readonly titleDe: Maybe<Scalars['String']['output']>;
};


export type EmployeeSurveysSurveyPartDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeSurveysSurveyPartQuestionsArgs = {
  forParticipantId: InputMaybe<Scalars['ID']['input']>;
};


export type EmployeeSurveysSurveyPartTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export const enum EmployeeSurveysSurveyPartSubjectEnum {
  Self = 'self',
  Work = 'work'
};

export const enum EmployeeSurveysSurveyPartSurveyPartTypeEnum {
  Demographic = 'demographic',
  EbOptional = 'eb_optional',
  EbRequired = 'eb_required',
  UserSupplied = 'user_supplied'
};

export type EmployerRatingPlatform = {
  readonly __typename?: 'EmployerRatingPlatform';
  readonly id: Scalars['ID']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly organisationId: Scalars['ID']['output'];
  readonly url: Maybe<Scalars['String']['output']>;
};

export type EmployerRatingPlatformAttributes = {
  readonly id: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly organisationId: Scalars['ID']['input'];
  readonly url: Scalars['String']['input'];
};

export type EmployerRatingPlatformsPayload = {
  readonly __typename?: 'EmployerRatingPlatformsPayload';
  readonly employerRatingPlatforms: Maybe<ReadonlyArray<EmployerRatingPlatform>>;
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type ExternalJobboardParticipation = {
  readonly __typename?: 'ExternalJobboardParticipation';
  readonly active: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['ISO8601Date']['output'];
  readonly data: Maybe<Scalars['JSON']['output']>;
  readonly description: Maybe<Scalars['String']['output']>;
  readonly iconPath: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly logoPath: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601Date']['output'];
};

export type FkMetascoreProfile = {
  readonly __typename?: 'FKMetascoreProfile';
  readonly bestRating: Maybe<Scalars['Float']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly lastRetrievedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly ratingValue: Maybe<Scalars['Float']['output']>;
  readonly reviewCount: Maybe<Scalars['Int']['output']>;
  readonly source: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
  readonly url: Maybe<Scalars['String']['output']>;
};

export type FkOrganisationSetting = {
  readonly __typename?: 'FKOrganisationSetting';
  readonly companyEmailDomains: Maybe<Scalars['String']['output']>;
  readonly doesNotTakePartInFeedbackProcess: Scalars['Boolean']['output'];
  readonly feedbackActive: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly metascore: Maybe<Scalars['Float']['output']>;
  readonly quote: Maybe<Scalars['String']['output']>;
  readonly quoteAuthor: Maybe<Scalars['String']['output']>;
  readonly ratingsCount: Maybe<Scalars['Int']['output']>;
  readonly separateSites: Scalars['Boolean']['output'];
};

export type FairekarriereStatePayload = {
  readonly __typename?: 'FairekarriereStatePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly fairekarriereState: Scalars['String']['output'];
};

export type FeatureBasicInfo = {
  readonly __typename?: 'FeatureBasicInfo';
  readonly description: Scalars['String']['output'];
  readonly key: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
};

export type FeatureCategories = {
  readonly __typename?: 'FeatureCategories';
  readonly internalFeatures: FeatureCategory;
  readonly pageFeatures: FeatureCategory;
  readonly services: FeatureCategory;
};

export type FeatureCategory = {
  readonly __typename?: 'FeatureCategory';
  readonly features: ReadonlyArray<FeatureBasicInfo>;
  readonly label: Scalars['String']['output'];
};

export type FeatureInfo = {
  readonly __typename?: 'FeatureInfo';
  readonly category: Scalars['String']['output'];
  readonly key: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
  readonly possibleValues: ReadonlyArray<Scalars['String']['output']>;
  readonly type: Scalars['String']['output'];
};

export type FederalState = {
  readonly __typename?: 'FederalState';
  readonly name: Scalars['String']['output'];
  readonly shortcut: Scalars['String']['output'];
};

export type FormOption = {
  readonly __typename?: 'FormOption';
  readonly text: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
};

export type GptObjectInterface = {
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly gptObjectType: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly inputDescription: Maybe<Scalars['String']['output']>;
  readonly inputFiles: Maybe<ReadonlyArray<JobGptFile>>;
  readonly inputUrls: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly runs: ReadonlyArray<JobGptTaskRun>;
  readonly tasks: ReadonlyArray<JobGptTask>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Identity = {
  readonly __typename?: 'Identity';
  readonly email: Scalars['String']['output'];
  readonly hasEbmsIdentity: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly lastLogin: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly locale: Scalars['String']['output'];
  readonly person: Maybe<Person>;
  readonly verified: Scalars['Boolean']['output'];
};

export type IdentityInput = {
  readonly locale: InputMaybe<Scalars['String']['input']>;
};

export type ImageQualityResult = {
  readonly __typename?: 'ImageQualityResult';
  readonly messages: ReadonlyArray<ImageQualityResultMessage>;
  readonly quality: Scalars['Int']['output'];
};

export type ImageQualityResultMessage = {
  readonly __typename?: 'ImageQualityResultMessage';
  readonly icon: Scalars['String']['output'];
  readonly message: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly quality: Scalars['Int']['output'];
};

export const enum ImageVariant {
  Medium = 'medium',
  Original = 'original',
  Resized = 'resized',
  ResizedRetina = 'resized_retina',
  Thumb = 'thumb'
};

export const enum IndeedApplicantStatusEnum {
  AssessQualifications = 'ASSESS_QUALIFICATIONS',
  BackgroundCheck = 'BACKGROUND_CHECK',
  Contacted = 'CONTACTED',
  Hired = 'HIRED',
  Incomplete = 'INCOMPLETE',
  Interview = 'INTERVIEW',
  JobClosed = 'JOB_CLOSED',
  JobInactive = 'JOB_INACTIVE',
  Liked = 'LIKED',
  New = 'NEW',
  NotSelected = 'NOT_SELECTED',
  OfferDeclined = 'OFFER_DECLINED',
  OfferMade = 'OFFER_MADE',
  Onboarded = 'ONBOARDED',
  PositivelyScreened = 'POSITIVELY_SCREENED',
  Review = 'REVIEW',
  Screen = 'SCREEN',
  UnableToMap = 'UNABLE_TO_MAP',
  VerifyEligibility = 'VERIFY_ELIGIBILITY',
  Withdrawn = 'WITHDRAWN'
};

export type InternationalsAttributes = {
  readonly bureaucracyService: InputMaybe<Scalars['Boolean']['input']>;
  readonly bureaucracyServiceDescriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly bureaucracyServiceDescriptionEn: InputMaybe<Scalars['String']['input']>;
  readonly companyLanguages: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly companyLanguagesDescriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly companyLanguagesDescriptionEn: InputMaybe<Scalars['String']['input']>;
  readonly familyService: InputMaybe<Scalars['Boolean']['input']>;
  readonly familyServiceDescriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly familyServiceDescriptionEn: InputMaybe<Scalars['String']['input']>;
  readonly germanEducation: InputMaybe<Scalars['Boolean']['input']>;
  readonly germanEducationDescriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly germanEducationDescriptionEn: InputMaybe<Scalars['String']['input']>;
  readonly housingService: InputMaybe<Scalars['Boolean']['input']>;
  readonly housingServiceDescriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly housingServiceDescriptionEn: InputMaybe<Scalars['String']['input']>;
  readonly personId: InputMaybe<Scalars['ID']['input']>;
  readonly recognitionService: InputMaybe<Scalars['Boolean']['input']>;
  readonly recognitionServiceDescriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly recognitionServiceDescriptionEn: InputMaybe<Scalars['String']['input']>;
  readonly socialService: InputMaybe<Scalars['Boolean']['input']>;
  readonly socialServiceDescriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly socialServiceDescriptionEn: InputMaybe<Scalars['String']['input']>;
  readonly videoUsed: InputMaybe<Scalars['Boolean']['input']>;
  readonly videoUsedDescriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly videoUsedDescriptionEn: InputMaybe<Scalars['String']['input']>;
  readonly visaService: InputMaybe<Scalars['Boolean']['input']>;
  readonly visaServiceDescriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly visaServiceDescriptionEn: InputMaybe<Scalars['String']['input']>;
  readonly visitPossible: InputMaybe<Scalars['Boolean']['input']>;
  readonly visitPossibleDescriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly visitPossibleDescriptionEn: InputMaybe<Scalars['String']['input']>;
};

export type InternationalsPayload = {
  readonly __typename?: 'InternationalsPayload';
  readonly applicantService: Maybe<OrganisationApplicantService>;
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type JobGptFile = {
  readonly __typename?: 'JobGptFile';
  readonly contentType: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly fileableType: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly openaiFileId: Maybe<Scalars['String']['output']>;
  readonly size: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly url: Scalars['String']['output'];
};

export type JobGptJob = GptObjectInterface & {
  readonly __typename?: 'JobGptJob';
  readonly additionalAttributes: Maybe<Scalars['String']['output']>;
  readonly benefits: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly educationRequirements: Maybe<Scalars['String']['output']>;
  readonly firstParagraph: Maybe<Scalars['String']['output']>;
  readonly gptMode: Maybe<Scalars['String']['output']>;
  readonly gptObjectType: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly inputDescription: Maybe<Scalars['String']['output']>;
  readonly inputFiles: Maybe<ReadonlyArray<JobGptFile>>;
  readonly inputUrls: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly jobDescription: Maybe<Scalars['String']['output']>;
  readonly jobType: Maybe<Scalars['String']['output']>;
  readonly keywordsCompetences: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly keywordsEducation: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly keywordsJobDescription: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly locations: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly meta: Maybe<Scalars['JSON']['output']>;
  readonly positionTitle: Maybe<Scalars['String']['output']>;
  readonly runs: ReadonlyArray<JobGptTaskRun>;
  readonly salary: Maybe<Scalars['String']['output']>;
  readonly sectors: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly seniority: Maybe<Scalars['String']['output']>;
  readonly specialCompetencies: Maybe<Scalars['String']['output']>;
  readonly tasks: ReadonlyArray<JobGptTask>;
  readonly title: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly userCompletedJobDescriptionTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userCompletedJobFirstParagraphTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userCompletedJobFromUrlTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userCompletedJobInformationTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userCompletedJobInputTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userCompletedJobKeywordsTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userCompletedJobTitlesTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly workConditions: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type JobGptJobInput = {
  readonly additionalAttributes: InputMaybe<Scalars['String']['input']>;
  readonly benefits: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly educationRequirements: InputMaybe<Scalars['String']['input']>;
  readonly firstParagraph: InputMaybe<Scalars['String']['input']>;
  readonly inputFiles: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly inputUrls: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly jobDescription: InputMaybe<Scalars['String']['input']>;
  readonly jobType: InputMaybe<Scalars['String']['input']>;
  readonly keywordsCompetences: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly keywordsEducation: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly keywordsJobDescription: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly locations: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly meta: InputMaybe<Scalars['JSON']['input']>;
  readonly positionTitle: InputMaybe<Scalars['String']['input']>;
  readonly salary: InputMaybe<Scalars['String']['input']>;
  readonly sectors: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly seniority: InputMaybe<Scalars['String']['input']>;
  readonly specialCompetencies: InputMaybe<Scalars['String']['input']>;
  readonly title: InputMaybe<Scalars['String']['input']>;
  readonly uploadedFiles: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly userCompletedJobDescriptionTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly userCompletedJobFirstParagraphTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly userCompletedJobFromUrlTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly userCompletedJobInformationTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly userCompletedJobInputTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly userCompletedJobKeywordsTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly userCompletedJobTitlesTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly workConditions: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type JobGptOrganisation = GptObjectInterface & {
  readonly __typename?: 'JobGptOrganisation';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly gptObjectType: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly inputDescription: Maybe<Scalars['String']['output']>;
  readonly inputFiles: Maybe<ReadonlyArray<JobGptFile>>;
  readonly inputUrls: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly missionStatement: Maybe<Scalars['String']['output']>;
  readonly numbersStatement: Maybe<Scalars['String']['output']>;
  readonly organisationName: Maybe<Scalars['String']['output']>;
  readonly runs: ReadonlyArray<JobGptTaskRun>;
  readonly tasks: ReadonlyArray<JobGptTask>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type JobGptOrganisationInput = {
  readonly inputDescription: InputMaybe<Scalars['String']['input']>;
  readonly inputFiles: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly inputUrls: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly missionStatement: InputMaybe<Scalars['String']['input']>;
  readonly numbersStatement: InputMaybe<Scalars['String']['input']>;
  readonly organisationName: InputMaybe<Scalars['String']['input']>;
  readonly uploadedFiles: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type JobGptResetJobPayload = {
  readonly __typename?: 'JobGptResetJobPayload';
  readonly gpt: JobGptJob;
};

export type JobGptResetPayload = {
  readonly __typename?: 'JobGptResetPayload';
  readonly gpt: GptObjectInterface;
};

export type JobGptResetTaskPayload = {
  readonly __typename?: 'JobGptResetTaskPayload';
  readonly gpt: GptObjectInterface;
};

export type JobGptRunTaskPayload = {
  readonly __typename?: 'JobGptRunTaskPayload';
  readonly gpt: GptObjectInterface;
  readonly taskRun: JobGptTaskRun;
};

export type JobGptSubmitFeedbackPayload = {
  readonly __typename?: 'JobGptSubmitFeedbackPayload';
  readonly success: Scalars['Boolean']['output'];
  readonly taskRun: JobGptTaskRun;
};

export type JobGptTask = {
  readonly __typename?: 'JobGptTask';
  readonly id: Scalars['ID']['output'];
  readonly jobGptText: Maybe<Scalars['String']['output']>;
  readonly key: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
  readonly loadingTexts: ReadonlyArray<Scalars['String']['output']>;
  readonly prompt: Scalars['String']['output'];
  readonly selectableGptAttributes: ReadonlyArray<Scalars['String']['output']>;
  readonly userInputAttributes: ReadonlyArray<Scalars['String']['output']>;
};

export type JobGptTaskRun = {
  readonly __typename?: 'JobGptTaskRun';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly feedbackAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly feedbackRating: Maybe<Scalars['Int']['output']>;
  readonly feedbackText: Maybe<Scalars['String']['output']>;
  readonly gptObject: GptObjectInterface;
  readonly gptObjectId: Scalars['ID']['output'];
  readonly gptObjectType: Scalars['String']['output'];
  readonly hasFeedback: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly key: Maybe<Scalars['String']['output']>;
  readonly label: Maybe<Scalars['String']['output']>;
  readonly openaiResponse: Maybe<Scalars['JSON']['output']>;
  readonly request: Maybe<Scalars['JSON']['output']>;
  readonly response: Maybe<Scalars['JSON']['output']>;
  readonly task: Maybe<JobGptTask>;
  readonly taskId: Scalars['ID']['output'];
  readonly usage: Maybe<Scalars['JSON']['output']>;
  readonly userInputs: Maybe<Scalars['JSON']['output']>;
};

export type JobGptUpdateJobPayload = {
  readonly __typename?: 'JobGptUpdateJobPayload';
  readonly gpt: JobGptJob;
};

export type JobGptUpdateOrganisationPayload = {
  readonly __typename?: 'JobGptUpdateOrganisationPayload';
  readonly gpt: JobGptOrganisation;
};

export type JobGptUpdateVariantMultiStepPayload = {
  readonly __typename?: 'JobGptUpdateVariantMultiStepPayload';
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly gpt: Maybe<JobGptVariantMultiStep>;
};

export type JobGptUpdateVariantPayload = {
  readonly __typename?: 'JobGptUpdateVariantPayload';
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly gpt: Maybe<JobGptVariant>;
};

export type JobGptVariant = GptObjectInterface & {
  readonly __typename?: 'JobGptVariant';
  readonly aiIntensity: Maybe<Scalars['Int']['output']>;
  readonly benefits: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly gptObjectType: Scalars['String']['output'];
  readonly homeofficeType: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly inputDescription: Maybe<Scalars['String']['output']>;
  readonly inputFiles: Maybe<ReadonlyArray<JobGptFile>>;
  readonly inputUrls: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly jobDescription: Maybe<Scalars['String']['output']>;
  readonly jobType: Maybe<Scalars['String']['output']>;
  readonly keywords: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly locations: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly manualJob: JobsManualJob;
  readonly manualJobId: Maybe<Scalars['ID']['output']>;
  readonly masterDescription: Maybe<Scalars['String']['output']>;
  readonly masterKeywords: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly masterTitle: Maybe<Scalars['String']['output']>;
  readonly missionStatement: Maybe<Scalars['String']['output']>;
  readonly numbersStatement: Maybe<Scalars['String']['output']>;
  readonly organisation: Organisation;
  readonly organisationId: Scalars['ID']['output'];
  readonly organisationName: Maybe<Scalars['String']['output']>;
  readonly refineDescription: Maybe<Scalars['Boolean']['output']>;
  readonly refineFirstParagraph: Maybe<Scalars['Boolean']['output']>;
  readonly refineKeywords: Maybe<Scalars['Boolean']['output']>;
  readonly refineTitle: Maybe<Scalars['Boolean']['output']>;
  readonly runs: ReadonlyArray<JobGptTaskRun>;
  readonly seniority: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly tasks: ReadonlyArray<JobGptTask>;
  readonly title: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly userCompletedVariantInputTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userInputs: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly workConditions: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type JobGptVariantInput = {
  readonly aiIntensity: InputMaybe<Scalars['Int']['input']>;
  readonly jobDescription: InputMaybe<Scalars['String']['input']>;
  readonly keywords: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly refineDescription: InputMaybe<Scalars['Boolean']['input']>;
  readonly refineFirstParagraph: InputMaybe<Scalars['Boolean']['input']>;
  readonly refineKeywords: InputMaybe<Scalars['Boolean']['input']>;
  readonly refineTitle: InputMaybe<Scalars['Boolean']['input']>;
  readonly title: InputMaybe<Scalars['String']['input']>;
  readonly userCompletedVariantInputTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly userInputs: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

export type JobGptVariantMultiStep = GptObjectInterface & {
  readonly __typename?: 'JobGptVariantMultiStep';
  readonly aiIntensity: Maybe<Scalars['Int']['output']>;
  readonly benefits: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly generatedFirstParagraph: Maybe<Scalars['String']['output']>;
  readonly generatedJobDescription: Maybe<Scalars['String']['output']>;
  readonly generatedJobDescriptionWithoutFirstParagraph: Maybe<Scalars['String']['output']>;
  readonly generatedKeywords: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly gptObjectType: Scalars['String']['output'];
  readonly homeofficeType: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly inputDescription: Maybe<Scalars['String']['output']>;
  readonly inputFiles: Maybe<ReadonlyArray<JobGptFile>>;
  readonly inputUrls: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly jobType: Maybe<Scalars['String']['output']>;
  readonly locations: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly manualJob: JobsManualJob;
  readonly manualJobId: Maybe<Scalars['ID']['output']>;
  readonly masterDescription: Maybe<Scalars['String']['output']>;
  readonly masterDescriptionWithoutFirstParagraph: Maybe<Scalars['String']['output']>;
  readonly masterFirstParagraph: Maybe<Scalars['String']['output']>;
  readonly masterKeywords: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly masterTitle: Maybe<Scalars['String']['output']>;
  readonly missionStatement: Maybe<Scalars['String']['output']>;
  readonly numbersStatement: Maybe<Scalars['String']['output']>;
  readonly organisation: Organisation;
  readonly organisationCareerPageUrl: Maybe<Scalars['String']['output']>;
  readonly organisationDescription: Maybe<Scalars['String']['output']>;
  readonly organisationId: Scalars['ID']['output'];
  readonly organisationName: Maybe<Scalars['String']['output']>;
  readonly runs: ReadonlyArray<JobGptTaskRun>;
  readonly salary: Maybe<Scalars['String']['output']>;
  readonly sectors: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly selectedFields: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly selectedTitle: Maybe<Scalars['String']['output']>;
  readonly seniority: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly tasks: ReadonlyArray<JobGptTask>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly userCompletedVariantFirstParagraphTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userCompletedVariantJobDescriptionTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userCompletedVariantKeywordsTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userCompletedVariantTitleTaskAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly workConditions: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type JobGptVariantMultiStepInput = {
  readonly aiIntensity: InputMaybe<Scalars['Int']['input']>;
  readonly generatedFirstParagraph: InputMaybe<Scalars['String']['input']>;
  readonly generatedJobDescriptionWithoutFirstParagraph: InputMaybe<Scalars['String']['input']>;
  readonly generatedKeywords: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly selectedFields: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly selectedTitle: InputMaybe<Scalars['String']['input']>;
  readonly userCompletedVariantFirstParagraphTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly userCompletedVariantJobDescriptionTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly userCompletedVariantKeywordsTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly userCompletedVariantTitleTaskAt: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export const enum JobIntegration {
  CompanyFeed = 'company_feed',
  Crawler = 'crawler',
  Hybrid = 'hybrid',
  Manual = 'manual'
};

export const enum JobsApplicationQuestionAnswerTypeEnum {
  CheckBoxes = 'check_boxes',
  Date = 'date',
  Number = 'number',
  RadioButtons = 'radio_buttons',
  Select = 'select',
  TextArea = 'text_area'
};

export type JobsBenefit = {
  readonly __typename?: 'JobsBenefit';
  readonly id: Scalars['ID']['output'];
  readonly manualJobIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly titleDe: Scalars['String']['output'];
  readonly titleEn: Maybe<Scalars['String']['output']>;
};

export type JobsCompetenceInfo = {
  readonly __typename?: 'JobsCompetenceInfo';
  readonly automaticCompetenceWords: ReadonlyArray<CompetenceWord>;
  readonly deactivatedCompetences: ReadonlyArray<Scalars['ID']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly jobId: Scalars['ID']['output'];
  readonly userCompetenceWords: ReadonlyArray<CompetenceWord>;
};

export type JobsDivision = {
  readonly __typename?: 'JobsDivision';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly nameEn: Maybe<Scalars['String']['output']>;
  readonly organisationId: Scalars['ID']['output'];
};

export type JobsDocument = {
  readonly __typename?: 'JobsDocument';
  readonly filename: Maybe<Scalars['String']['output']>;
  readonly size: Maybe<Scalars['Int']['output']>;
  readonly url: Maybe<Scalars['String']['output']>;
};

export type JobsImportResult = {
  readonly __typename?: 'JobsImportResult';
  readonly fields: Maybe<Scalars['JSON']['output']>;
  readonly importErrors: Maybe<Scalars['JSON']['output']>;
  readonly importInfo: Maybe<Scalars['JSON']['output']>;
  readonly importWarnings: Maybe<Scalars['JSON']['output']>;
  readonly importedOn: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly status: Scalars['String']['output'];
};

export type JobsKeywordInfo = {
  readonly __typename?: 'JobsKeywordInfo';
  readonly addSuggestions: Scalars['Boolean']['output'];
  readonly addedSuggestions: ReadonlyArray<JobsKeywordSuggestion>;
  readonly feedType: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly keywordSuggestions: ReadonlyArray<JobsKeywordSuggestion>;
  readonly masterJobId: Scalars['ID']['output'];
  readonly maxKeywordCount: Scalars['Int']['output'];
  readonly minKeywordCount: Scalars['Int']['output'];
  readonly suggestDisabled: Scalars['Boolean']['output'];
  readonly suggestRunAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly userKeywords: ReadonlyArray<JobsUserKeyword>;
  readonly userKeywordsEnough: Scalars['Boolean']['output'];
  readonly userKeywordsStrong: Scalars['Boolean']['output'];
  readonly visibleKeywords: ReadonlyArray<Scalars['String']['output']>;
};

export type JobsKeywordSuggestion = {
  readonly __typename?: 'JobsKeywordSuggestion';
  readonly hiddenByUser: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly keywordResultId: Maybe<Scalars['ID']['output']>;
  readonly name: Scalars['String']['output'];
  readonly searchCount: Scalars['Int']['output'];
  readonly searchLevel: Maybe<Scalars['Int']['output']>;
  readonly source: Scalars['String']['output'];
};

export type JobsLinkedinStatus = {
  readonly __typename?: 'JobsLinkedinStatus';
  readonly fetchedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly includedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type JobsManualJob = {
  readonly __typename?: 'JobsManualJob';
  readonly applicantServiceBureaucracyService: Maybe<Scalars['Boolean']['output']>;
  readonly applicantServiceFamilyService: Maybe<Scalars['Boolean']['output']>;
  readonly applicantServiceGermanEducation: Maybe<Scalars['Boolean']['output']>;
  readonly applicantServiceHousingService: Maybe<Scalars['Boolean']['output']>;
  readonly applicantServiceRecognitionService: Maybe<Scalars['Boolean']['output']>;
  readonly applicantServiceSocialService: Maybe<Scalars['Boolean']['output']>;
  readonly applicantServiceVideoUsed: Maybe<Scalars['Boolean']['output']>;
  readonly applicantServiceVisaService: Maybe<Scalars['Boolean']['output']>;
  readonly applicantServiceVisitPossible: Maybe<Scalars['Boolean']['output']>;
  readonly applicantServices: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly applicationQuestionIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly applicationQuestions: ReadonlyArray<ApplicationQuestion>;
  readonly autoRefresh: Scalars['Boolean']['output'];
  readonly baBeruf: Maybe<Beruf>;
  readonly baBerufId: Maybe<Scalars['Int']['output']>;
  readonly baBerufe: ReadonlyArray<Beruf>;
  readonly baBerufeIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly baHandicap: Maybe<JobsManualJobBaHandicapEnum>;
  readonly baIgnore: Maybe<Scalars['Boolean']['output']>;
  readonly benefitIds: Maybe<ReadonlyArray<Scalars['Int']['output']>>;
  readonly bewerbungsweg: Maybe<Scalars['String']['output']>;
  readonly bmsTeam: Maybe<BmsTeam>;
  readonly bmsTeamId: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use remote_type instead */
  readonly bundesweit: Maybe<Scalars['Boolean']['output']>;
  readonly customWeight: JobsManualJobCustomWeightEnum;
  readonly description: Maybe<Scalars['String']['output']>;
  readonly divisionIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly divisions: ReadonlyArray<JobsDivision>;
  readonly document: Maybe<JobsDocument>;
  readonly experienceLevelIntermediate: Maybe<Scalars['Boolean']['output']>;
  readonly experienceLevelJunior: Maybe<Scalars['Boolean']['output']>;
  readonly experienceLevelQuereinstieg: Maybe<Scalars['Boolean']['output']>;
  readonly experienceLevelSenior: Maybe<Scalars['Boolean']['output']>;
  readonly experienceLevelUngelernt: Maybe<Scalars['Boolean']['output']>;
  readonly expirationDate: Maybe<Scalars['ISO8601Date']['output']>;
  readonly externalJobboardSettings: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Extra Ort not supported anymore */
  readonly extraOrt: Maybe<Scalars['String']['output']>;
  readonly fid: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly importStatus: JobsManualJobImportStatusEnum;
  readonly internal: Scalars['Boolean']['output'];
  readonly isSupplemental: Maybe<Scalars['Boolean']['output']>;
  readonly jobSharing: Maybe<Scalars['Boolean']['output']>;
  readonly languageLevelEnglish: Maybe<JobsManualJobLanguageLevelEnglishEnum>;
  readonly languageLevelGerman: Maybe<JobsManualJobLanguageLevelGermanEnum>;
  readonly languageLevelOther: Maybe<JobsManualJobLanguageLevelOtherEnum>;
  readonly languageOther: Maybe<Scalars['String']['output']>;
  readonly lastImportResult: Maybe<Scalars['String']['output']>;
  readonly link: Maybe<Scalars['String']['output']>;
  readonly masterJob: Maybe<JobsMasterJob>;
  readonly nummer: Maybe<Scalars['String']['output']>;
  readonly nummerWithParentPrefix: Maybe<Scalars['String']['output']>;
  readonly organisation: Organisation;
  readonly parentJob: Maybe<JobsManualJob>;
  readonly people: ReadonlyArray<Person>;
  readonly personIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly portalType: Maybe<Scalars['String']['output']>;
  readonly pubdate: Maybe<Scalars['ISO8601Date']['output']>;
  readonly remoteCountryList: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly remoteType: Maybe<Scalars['String']['output']>;
  readonly salaryInterval: Maybe<Scalars['String']['output']>;
  readonly salaryMax: Maybe<Scalars['Float']['output']>;
  readonly salaryMin: Maybe<Scalars['Float']['output']>;
  readonly subJobType: Maybe<JobsManualJobSubJobTypeEnum>;
  readonly subprofile: Maybe<Subprofile>;
  readonly subprofileId: Maybe<Scalars['Int']['output']>;
  readonly tags: Maybe<Scalars['String']['output']>;
  readonly targetAudienceCountry: Maybe<JobsManualJobTargetAudienceCountryEnum>;
  readonly targetAudienceWorkPermit: Maybe<JobsManualJobTargetAudienceWorkPermitEnum>;
  readonly tarifvertragId: Maybe<Scalars['Int']['output']>;
  readonly tarifvertragLevelMax: Maybe<Scalars['Int']['output']>;
  readonly tarifvertragLevelMin: Maybe<Scalars['Int']['output']>;
  readonly tarifvertragSalaryGroup: Maybe<Scalars['String']['output']>;
  readonly temporary: Maybe<Scalars['Boolean']['output']>;
  readonly temporaryConversionToPermanentPossible: Maybe<Scalars['Boolean']['output']>;
  readonly temporaryEnd: Maybe<Scalars['String']['output']>;
  readonly title: Maybe<Scalars['String']['output']>;
  readonly userAddressIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly userAddresses: ReadonlyArray<UserAddress>;
  readonly vacationMax: Maybe<Scalars['Int']['output']>;
  readonly vacationMin: Maybe<Scalars['Int']['output']>;
  readonly visible: Maybe<Scalars['Boolean']['output']>;
  readonly workingTime: Maybe<JobsManualJobWorkingTimeEnum>;
  readonly workingTimeHoursMax: Maybe<Scalars['Float']['output']>;
  readonly workingTimeHoursMin: Maybe<Scalars['Float']['output']>;
};

export const enum JobsManualJobBaHandicapEnum {
  HandicapNotSpecified = 'handicap_not_specified',
  HandicapSuitable = 'handicap_suitable',
  OnlyHandicap = 'only_handicap'
};

export const enum JobsManualJobCustomWeightEnum {
  High = 'high',
  Low = 'low',
  MediumHigh = 'medium_high',
  MediumLow = 'medium_low',
  Normal = 'normal'
};

export const enum JobsManualJobImportStatusEnum {
  Error = 'error',
  ImportedSuccessful = 'imported_successful',
  ImportedSuccessfulPending = 'imported_successful_pending',
  ImportedWarning = 'imported_warning',
  ImportedWarningPending = 'imported_warning_pending',
  NotImported = 'not_imported'
};

export const enum JobsManualJobLanguageLevelEnglishEnum {
  A1A2 = 'a1_a2',
  B1B2 = 'b1_b2',
  C1 = 'c1',
  C2Native = 'c2_native',
  None = 'none'
};

export const enum JobsManualJobLanguageLevelGermanEnum {
  A1A2 = 'a1_a2',
  B1B2 = 'b1_b2',
  C1 = 'c1',
  C2Native = 'c2_native',
  None = 'none'
};

export const enum JobsManualJobLanguageLevelOtherEnum {
  A1A2 = 'a1_a2',
  B1B2 = 'b1_b2',
  C1 = 'c1',
  C2Native = 'c2_native',
  None = 'none'
};

export const enum JobsManualJobSubJobTypeEnum {
  Ausbildung = 'ausbildung',
  DualesStudium = 'duales_studium',
  Fachkraft = 'fachkraft',
  Freelancer = 'freelancer',
  Fuehrungskraft = 'fuehrungskraft',
  Hilfskraft = 'hilfskraft',
  Praktikum = 'praktikum',
  Volunteer = 'volunteer',
  Weiterbildung = 'weiterbildung',
  Werkstudent = 'werkstudent'
};

export const enum JobsManualJobTargetAudienceCountryEnum {
  Eu = 'eu',
  Germany = 'germany',
  International = 'international'
};

export const enum JobsManualJobTargetAudienceWorkPermitEnum {
  GermanyEu = 'germany_eu',
  None = 'none'
};

export const enum JobsManualJobWorkingTimeEnum {
  Fixed = 'fixed',
  Flexible = 'flexible',
  Shift = 'shift'
};

export type JobsMasterJob = {
  readonly __typename?: 'JobsMasterJob';
  readonly baIgnoreErrors: Scalars['Boolean']['output'];
  readonly baStatus: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly fid: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly lastBaAction: Maybe<BaAction>;
  readonly lastContentUpdate: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly lastImportResult: Maybe<JobsImportResult>;
  readonly linkedinStatus: Maybe<JobsLinkedinStatus>;
  readonly nummer: Scalars['Int']['output'];
  readonly portalJobs: ReadonlyArray<JobsPortalJob>;
  readonly title: Scalars['String']['output'];
  readonly userAddresses: ReadonlyArray<UserAddress>;
  readonly visible: Scalars['Boolean']['output'];
};


export type JobsMasterJobPortalJobsArgs = {
  visible: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobsPortalJob = {
  readonly __typename?: 'JobsPortalJob';
  readonly domain: DomainBase;
  readonly domainName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly people: ReadonlyArray<Person>;
  readonly title: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
  readonly userAddresses: ReadonlyArray<UserAddress>;
  readonly visible: Scalars['Boolean']['output'];
};

export type JobsUserKeyword = {
  readonly __typename?: 'JobsUserKeyword';
  readonly name: Scalars['String']['output'];
  readonly position: Scalars['Int']['output'];
  readonly searchCount: Maybe<Scalars['Int']['output']>;
  readonly searchLevel: Maybe<Scalars['Int']['output']>;
};

export type JobwertStatePayload = {
  readonly __typename?: 'JobwertStatePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly jobwertState: ServiceState;
};

export type KanaleoDepartment = {
  readonly __typename?: 'KanaleoDepartment';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly nameWithGroup: Scalars['String']['output'];
  readonly parent: Maybe<KanaleoDepartment>;
  readonly parentHierarchy: Maybe<Scalars['String']['output']>;
};


export type KanaleoDepartmentNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type KanaleoDepartmentOrganisation = {
  readonly __typename?: 'KanaleoDepartmentOrganisation';
  readonly department: KanaleoDepartment;
  readonly departmentId: Scalars['Int']['output'];
  readonly departmentName: Scalars['String']['output'];
  readonly displayName: Scalars['String']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly weight: Maybe<Scalars['Int']['output']>;
};

export type KanaleoServiceProvider = {
  readonly __typename?: 'KanaleoServiceProvider';
  readonly countsAsOtherChannel: Scalars['Boolean']['output'];
  readonly defaultChannel: Scalars['Boolean']['output'];
  readonly description: Maybe<Scalars['String']['output']>;
  readonly empfehlungsbundCooperationClassification: Scalars['String']['output'];
  readonly hidden: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly matchingKeywords: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly parent: Maybe<KanaleoServiceProvider>;
};


export type KanaleoServiceProviderDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};


export type KanaleoServiceProviderNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
};

export type KanaleoStatePayload = {
  readonly __typename?: 'KanaleoStatePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly kanaleoState: ServiceState;
};

export type KanaleoSurveySetting = {
  readonly __typename?: 'KanaleoSurveySetting';
  readonly applicantSalutationType: Scalars['String']['output'];
  readonly cssBackground: Maybe<Scalars['String']['output']>;
  readonly cssColor: Maybe<Scalars['String']['output']>;
  readonly cssLink: Maybe<Scalars['String']['output']>;
  readonly cxpActive: Scalars['Boolean']['output'];
  readonly cxpIntroTextDe: Maybe<Scalars['String']['output']>;
  readonly cxpIntroTextEn: Maybe<Scalars['String']['output']>;
  readonly feedbackTextDe: Maybe<Scalars['String']['output']>;
  readonly feedbackTextEn: Maybe<Scalars['String']['output']>;
  readonly feedbackThanksDe: Maybe<Scalars['String']['output']>;
  readonly feedbackThanksEn: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly recruitTextDe: Maybe<Scalars['String']['output']>;
  readonly recruitTextEn: Maybe<Scalars['String']['output']>;
  readonly recruitThanksDe: Maybe<Scalars['String']['output']>;
  readonly recruitThanksEn: Maybe<Scalars['String']['output']>;
  readonly redirectUrl: Maybe<Scalars['String']['output']>;
  readonly surveyActive: Scalars['Boolean']['output'];
};

export type Membership = {
  readonly __typename?: 'Membership';
  readonly anuLimited: Maybe<Scalars['Boolean']['output']>;
  readonly applicationAddressId: Maybe<Scalars['ID']['output']>;
  readonly applicationEntryMail: Maybe<Scalars['String']['output']>;
  readonly bmsUrl: Maybe<Scalars['String']['output']>;
  readonly careerPageUrl: Maybe<Scalars['String']['output']>;
  readonly careerPageUrlEn: Maybe<Scalars['String']['output']>;
  readonly communityPortalProfileVisible: Maybe<Scalars['Boolean']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly customerPageDisplayPriority: Maybe<Scalars['Int']['output']>;
  readonly domain: DomainBase;
  readonly feedimportActive: Maybe<Scalars['Boolean']['output']>;
  readonly hideRelatedJobs: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly lastSuccessfulJobSyncAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly lastSuccessfulProfileSyncAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly unsolicitedApplicationAllowed: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly banners: MutationBanners;
  readonly changeTierLevel: Maybe<ChangeTierLevelPayload>;
  /** @deprecated Use jobMutations.create */
  readonly createJob: Maybe<CreateJobPayload>;
  readonly createOrganisationAddress: Maybe<CreateOrganisationAddressPayload>;
  /** @deprecated Use peopleMutations.create */
  readonly createPerson: Maybe<CreatePersonPayload>;
  /** @deprecated Use jobMutations.delete */
  readonly deleteJob: Maybe<DeleteJobPayload>;
  readonly employeeSurveysCreateDepartment: Maybe<CreateDepartmentPayload>;
  readonly employeeSurveysCreateParticipant: Maybe<CreateParticipantPayload>;
  readonly employeeSurveysDeleteDepartment: Maybe<DeleteDepartmentPayload>;
  readonly employeeSurveysDeleteParticipant: Maybe<DeleteParticipantPayload>;
  readonly employeeSurveysUpdateDepartment: Maybe<UpdateDepartmentPayload>;
  readonly employeeSurveysUpdateParticipant: Maybe<UpdateParticipantPayload>;
  readonly fkMutations: MutationFkMutations;
  readonly jobGptReset: Maybe<JobGptResetPayload>;
  /** @deprecated Use jobGptReset instead */
  readonly jobGptResetJob: Maybe<JobGptResetJobPayload>;
  readonly jobGptResetTask: Maybe<JobGptResetTaskPayload>;
  readonly jobGptRunTask: Maybe<JobGptRunTaskPayload>;
  readonly jobGptSubmitFeedback: Maybe<JobGptSubmitFeedbackPayload>;
  readonly jobGptUpdateJob: Maybe<JobGptUpdateJobPayload>;
  readonly jobGptUpdateOrganisation: Maybe<JobGptUpdateOrganisationPayload>;
  readonly jobGptUpdateVariant: Maybe<JobGptUpdateVariantPayload>;
  readonly jobGptUpdateVariantMultiStep: Maybe<JobGptUpdateVariantMultiStepPayload>;
  readonly jobMutations: MutationJobMutations;
  readonly kanaleoSurveySettingUpdateAttribute: Maybe<SurveySettingUpdateAttributePayload>;
  readonly organisationSurveyUpdateQuestions: Maybe<OrganisationSurveyUpdateQuestionsPayload>;
  readonly peopleMutations: MutationPeopleMutations;
  /** @deprecated Use jobMutations.preview */
  readonly previewJob: Maybe<PreviewJobPayload>;
  readonly profileFormsApplySettings: Maybe<ApplySettingsPayload>;
  readonly profileFormsBenefits: Maybe<BenefitsPayload>;
  readonly profileFormsBmsState: Maybe<BmsStatePayload>;
  readonly profileFormsChangeUserName: Maybe<ChangeUserNamePayload>;
  readonly profileFormsCommunityManagementDomainActivations: Maybe<DomainActivationsPayload>;
  readonly profileFormsCommunityManagementDomainDeactivations: Maybe<DomainDeactivationsPayload>;
  readonly profileFormsCommunityQuote: Maybe<CommunityQuotePayload>;
  readonly profileFormsCoworkrState: Maybe<CoworkrStatePayload>;
  readonly profileFormsDivisions: Maybe<DivisionsPayload>;
  readonly profileFormsEmployeeCount: Maybe<EmployeeCountPayload>;
  readonly profileFormsEmployeeSurveysState: Maybe<EmployeeSurveysStatePayload>;
  readonly profileFormsEmployerRatingPlatforms: Maybe<EmployerRatingPlatformsPayload>;
  readonly profileFormsFairekarriereState: Maybe<FairekarriereStatePayload>;
  readonly profileFormsInternationals: Maybe<InternationalsPayload>;
  readonly profileFormsJobwertState: Maybe<JobwertStatePayload>;
  readonly profileFormsKanaleoDepartmentSelections: Maybe<DepartmentSelectionsPayload>;
  readonly profileFormsKanaleoServiceProviders: Maybe<ServiceProvidersPayload>;
  readonly profileFormsKanaleoState: Maybe<KanaleoStatePayload>;
  readonly profileFormsPageFeatureAccess: Maybe<PageFeatureAccessPayload>;
  readonly profileFormsQuoteRelevance: Maybe<QuoteRelevancePayload>;
  readonly profileFormsRewards: Maybe<RewardsPayload>;
  readonly profileFormsServiceStates: Maybe<ServiceStatesPayload>;
  readonly profileFormsSmartclickSettingUpdateAttribute: Maybe<SmartclickSettingUpdateAttributePayload>;
  readonly profileFormsSocialNetworks: Maybe<SocialNetworksPayload>;
  readonly profileFormsTalentsState: Maybe<TalentsStatePayload>;
  readonly profileFormsTierAbilityUpdateAttribute: Maybe<UpdateTierAbilityAttributePayload>;
  readonly profileFormsUpdateAttribute: Maybe<UpdateAttributePayload>;
  readonly profileFormsVideo: Maybe<VideoPayload>;
  readonly updateApplyStatistics: Maybe<UpdateApplyStatisticsPayload>;
  readonly updateDashboardLayout: Maybe<UpdateLayoutPayload>;
  readonly updateEmployeeCount: Maybe<UpdateEmployeeCountPayload>;
  readonly updateIndeedDispositionStatus: Maybe<UpdateDispositionStatusPayload>;
  /** @deprecated Use jobMutations.update */
  readonly updateJob: Maybe<UpdateJobPayload>;
  /** @deprecated Use peopleMutations.update */
  readonly updatePerson: Maybe<UpdatePersonPayload>;
};


export type MutationChangeTierLevelArgs = {
  organisationId: Scalars['ID']['input'];
  toTier: Scalars['String']['input'];
};


export type MutationCreateJobArgs = {
  input: CreateJobInput;
};


export type MutationCreateOrganisationAddressArgs = {
  input: OrganisationAddressAttributes;
};


export type MutationCreatePersonArgs = {
  input: PersonFormInput;
};


export type MutationDeleteJobArgs = {
  id: Scalars['Int']['input'];
};


export type MutationEmployeeSurveysCreateDepartmentArgs = {
  input: DepartmentInput;
  organisationSurveyId: Scalars['ID']['input'];
};


export type MutationEmployeeSurveysCreateParticipantArgs = {
  input: ParticipantInput;
  organisationSurveyId: Scalars['ID']['input'];
};


export type MutationEmployeeSurveysDeleteDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
};


export type MutationEmployeeSurveysDeleteParticipantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmployeeSurveysUpdateDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  input: DepartmentInput;
};


export type MutationEmployeeSurveysUpdateParticipantArgs = {
  id: Scalars['ID']['input'];
  input: UpdateParticipantInput;
};


export type MutationJobGptResetArgs = {
  gptObjectId: Scalars['ID']['input'];
  gptObjectType: Scalars['String']['input'];
};


export type MutationJobGptResetJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJobGptResetTaskArgs = {
  gptObjectId: Scalars['ID']['input'];
  gptObjectType: Scalars['String']['input'];
  taskKey: Scalars['String']['input'];
};


export type MutationJobGptRunTaskArgs = {
  gptObjectId: InputMaybe<Scalars['ID']['input']>;
  gptObjectType: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
  userInputs: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};


export type MutationJobGptSubmitFeedbackArgs = {
  rating: Scalars['Int']['input'];
  taskRunId: Scalars['ID']['input'];
  text: InputMaybe<Scalars['String']['input']>;
};


export type MutationJobGptUpdateJobArgs = {
  id: Scalars['ID']['input'];
  input: JobGptJobInput;
};


export type MutationJobGptUpdateOrganisationArgs = {
  input: JobGptOrganisationInput;
};


export type MutationJobGptUpdateVariantArgs = {
  id: Scalars['ID']['input'];
  input: JobGptVariantInput;
};


export type MutationJobGptUpdateVariantMultiStepArgs = {
  id: Scalars['ID']['input'];
  input: JobGptVariantMultiStepInput;
};


export type MutationKanaleoSurveySettingUpdateAttributeArgs = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};


export type MutationOrganisationSurveyUpdateQuestionsArgs = {
  adminMode?: InputMaybe<Scalars['Boolean']['input']>;
  parts: ReadonlyArray<PartInput>;
  surveyId: Scalars['ID']['input'];
  surveyInput: InputMaybe<OrganisationSurveyUpdateInput>;
};


export type MutationPreviewJobArgs = {
  id: InputMaybe<Scalars['Int']['input']>;
  input: PreviewJobInput;
};


export type MutationProfileFormsApplySettingsArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ApplyOptionAttributes;
};


export type MutationProfileFormsBenefitsArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ReadonlyArray<Scalars['ID']['input']>;
};


export type MutationProfileFormsBmsStateArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfileFormsChangeUserNameArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};


export type MutationProfileFormsCommunityManagementDomainActivationsArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfileFormsCommunityManagementDomainDeactivationsArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfileFormsCommunityQuoteArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: CommunityQuoteAttributes;
};


export type MutationProfileFormsCoworkrStateArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfileFormsDivisionsArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ReadonlyArray<DivisionAttributes>;
};


export type MutationProfileFormsEmployeeCountArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: EmployeeCountAttributes;
};


export type MutationProfileFormsEmployeeSurveysStateArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfileFormsEmployerRatingPlatformsArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ReadonlyArray<EmployerRatingPlatformAttributes>;
};


export type MutationProfileFormsFairekarriereStateArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfileFormsInternationalsArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: InternationalsAttributes;
};


export type MutationProfileFormsJobwertStateArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ServiceState;
};


export type MutationProfileFormsKanaleoDepartmentSelectionsArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ReadonlyArray<DepartmentSelectionArgument>;
};


export type MutationProfileFormsKanaleoServiceProvidersArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ReadonlyArray<Scalars['Int']['input']>;
};


export type MutationProfileFormsKanaleoStateArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ServiceState;
};


export type MutationProfileFormsPageFeatureAccessArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};


export type MutationProfileFormsQuoteRelevanceArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};


export type MutationProfileFormsRewardsArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ReadonlyArray<RewardAttributes>;
};


export type MutationProfileFormsServiceStatesArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ServiceStatesAttributes;
};


export type MutationProfileFormsSmartclickSettingUpdateAttributeArgs = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};


export type MutationProfileFormsSocialNetworksArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: ReadonlyArray<SocialNetworkAttributes>;
};


export type MutationProfileFormsTalentsStateArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfileFormsTierAbilityUpdateAttributeArgs = {
  key: Scalars['String']['input'];
  membershipIds: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  value: Scalars['JSON']['input'];
};


export type MutationProfileFormsUpdateAttributeArgs = {
  key: Scalars['String']['input'];
  membershipIds: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  value: Scalars['JSON']['input'];
};


export type MutationProfileFormsVideoArgs = {
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateApplyStatisticsArgs = {
  input: ReadonlyArray<ApplyAttributes>;
};


export type MutationUpdateDashboardLayoutArgs = {
  input: DashboardLayoutAttributes;
};


export type MutationUpdateEmployeeCountArgs = {
  employeeCount: Scalars['Int']['input'];
  employeeCountForBilling: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateIndeedDispositionStatusArgs = {
  input: DispositionUpdateInput;
};


export type MutationUpdateJobArgs = {
  id: Scalars['Int']['input'];
  input: UpdateJobInput;
};


export type MutationUpdatePersonArgs = {
  id: Scalars['Int']['input'];
  input: PersonFormInput;
};

export type MutationBanners = {
  readonly __typename?: 'MutationBanners';
  readonly update: Maybe<UpdateBannerPayload>;
};


export type MutationBannersUpdateArgs = {
  bannerId: Scalars['ID']['input'];
  input: BannerUpdateInput;
};

export type MutationFkMutations = {
  readonly __typename?: 'MutationFKMutations';
  readonly createMetascoreProfile: Maybe<CreateMetascoreProfilePayload>;
  readonly deleteMetascoreProfile: Maybe<DeleteMetascoreProfilePayload>;
  readonly updateMetascoreProfile: Maybe<UpdateMetascoreProfilePayload>;
  readonly updateOrganisationSetting: Maybe<UpdateOrganisationSettingPayload>;
};


export type MutationFkMutationsCreateMetascoreProfileArgs = {
  ratingValue: InputMaybe<Scalars['Float']['input']>;
  reviewCount: InputMaybe<Scalars['Int']['input']>;
  source: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationFkMutationsDeleteMetascoreProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFkMutationsUpdateMetascoreProfileArgs = {
  id: Scalars['ID']['input'];
  ratingValue: InputMaybe<Scalars['Float']['input']>;
  refresh: InputMaybe<Scalars['Boolean']['input']>;
  reviewCount: InputMaybe<Scalars['Int']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
};


export type MutationFkMutationsUpdateOrganisationSettingArgs = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type MutationJobMutations = {
  readonly __typename?: 'MutationJobMutations';
  readonly create: Maybe<CreateJobPayload>;
  readonly delete: Maybe<DeleteJobPayload>;
  readonly preview: Maybe<PreviewJobPayload>;
  readonly update: Maybe<UpdateJobPayload>;
};


export type MutationJobMutationsCreateArgs = {
  input: CreateJobInput;
};


export type MutationJobMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationJobMutationsPreviewArgs = {
  id: InputMaybe<Scalars['Int']['input']>;
  input: PreviewJobInput;
};


export type MutationJobMutationsUpdateArgs = {
  id: Scalars['Int']['input'];
  input: UpdateJobInput;
};

export type MutationPeopleMutations = {
  readonly __typename?: 'MutationPeopleMutations';
  readonly activateEbmsIdentity: Maybe<ActivateEbmsIdentityPayload>;
  readonly create: Maybe<CreatePersonPayload>;
  readonly update: Maybe<UpdatePersonPayload>;
};


export type MutationPeopleMutationsActivateEbmsIdentityArgs = {
  ebmsIdentityType: Scalars['String']['input'];
  personId: Scalars['Int']['input'];
};


export type MutationPeopleMutationsCreateArgs = {
  input: PersonFormInput;
};


export type MutationPeopleMutationsUpdateArgs = {
  id: Scalars['Int']['input'];
  input: PersonFormInput;
};

export type Name = {
  readonly __typename?: 'Name';
  readonly firstName: Maybe<Scalars['String']['output']>;
  readonly formalSalutation: Scalars['String']['output'];
  readonly fullName: Scalars['String']['output'];
  readonly initials: Maybe<Scalars['String']['output']>;
  readonly lastName: Maybe<Scalars['String']['output']>;
  readonly salutation: Maybe<Scalars['String']['output']>;
  readonly title: Maybe<Scalars['String']['output']>;
};

export type NewRewardInput = {
  readonly group: Scalars['String']['input'];
  readonly link: Scalars['String']['input'];
  readonly logoBase64: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
};

export type Notification = {
  readonly __typename?: 'Notification';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly expiresAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly identifier: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
  readonly personId: Maybe<Scalars['ID']['output']>;
  readonly quickAction: Maybe<Scalars['JSON']['output']>;
  readonly read: Scalars['Boolean']['output'];
  readonly sentAt: Scalars['ISO8601DateTime']['output'];
  readonly severity: Scalars['String']['output'];
  readonly subject: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Organisation = {
  readonly __typename?: 'Organisation';
  readonly addresses: ReadonlyArray<UserAddress>;
  readonly addressesAccess: Maybe<Scalars['String']['output']>;
  readonly aliasSuggestions: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly allowImportingAllJobs: Scalars['Boolean']['output'];
  readonly allowSupplementJobs: Scalars['Boolean']['output'];
  readonly allowedHostsInJobs: Maybe<Scalars['String']['output']>;
  readonly anuLimited: Maybe<Scalars['Boolean']['output']>;
  readonly applicantSalutationType: ApplicantSalutation;
  readonly applicantService: OrganisationApplicantService;
  readonly applicationAddressId: Maybe<Scalars['ID']['output']>;
  readonly applicationEntryMail: Maybe<Scalars['String']['output']>;
  readonly applicationMailType: OrganisationApplicationMailTypeEnum;
  readonly applicationQuestions: ReadonlyArray<ApplicationQuestion>;
  readonly applicationStatistics: ReadonlyArray<ApplicationStatistic>;
  readonly applyBenefitsToAllJobs: Scalars['Boolean']['output'];
  readonly applyOption: OrganisationApplyOption;
  readonly availableRoles: ReadonlyArray<PersonRole>;
  readonly baBranche: Maybe<Scalars['String']['output']>;
  readonly baIgnored: Maybe<Scalars['Boolean']['output']>;
  readonly backlinksAccess: Maybe<Scalars['String']['output']>;
  readonly bannerAccess: Maybe<Scalars['String']['output']>;
  readonly banners: ReadonlyArray<BannerGeneratorBanner>;
  readonly benefitIds: Maybe<ReadonlyArray<Scalars['Int']['output']>>;
  readonly benefits: Maybe<ReadonlyArray<JobsBenefit>>;
  readonly benefitsAccess: Maybe<Scalars['String']['output']>;
  readonly bmsActivationLevel: Scalars['String']['output'];
  readonly bmsActive: Scalars['Boolean']['output'];
  readonly bmsApplicationRouting: OrganisationBmsApplicationRoutingEnum;
  readonly bmsRecruiterIdentities: ReadonlyArray<BmsShortIdentity>;
  readonly bmsState: Maybe<ServiceState>;
  readonly bmsTeams: ReadonlyArray<BmsTeam>;
  readonly bmsUrl: Maybe<Scalars['String']['output']>;
  readonly careerPageUrl: Maybe<Scalars['String']['output']>;
  readonly careerPageUrlEn: Maybe<Scalars['String']['output']>;
  readonly certificateAccess: Scalars['Boolean']['output'];
  readonly certificateActive: Scalars['Boolean']['output'];
  readonly clicksStatistics: ReadonlyArray<ClicksStatistic>;
  readonly codesAccess: Maybe<Scalars['String']['output']>;
  readonly communityManager: CommunityManager;
  readonly communityPortalProfileVisible: Maybe<Scalars['Boolean']['output']>;
  readonly communityQuote: Maybe<CommunityQuote>;
  readonly companyColor: Maybe<Scalars['String']['output']>;
  readonly competences: Maybe<ReadonlyArray<Competence>>;
  readonly competencesAccess: Maybe<Scalars['String']['output']>;
  readonly cooperationSettingsAccess: Maybe<Scalars['String']['output']>;
  readonly coworkrActive: Maybe<Scalars['Boolean']['output']>;
  readonly coworkrState: Maybe<ServiceState>;
  readonly currentTierAbility: Maybe<TierAbility>;
  readonly customerPageDisplayPriority: Maybe<Scalars['Int']['output']>;
  readonly ddfSponsor: Maybe<Scalars['Boolean']['output']>;
  readonly defaultBaHandicap: Maybe<OrganisationDefaultBaHandicapEnum>;
  readonly defaultLanguageLevelGerman: Maybe<Scalars['String']['output']>;
  readonly departmentsAccess: Maybe<Scalars['String']['output']>;
  readonly description: Maybe<Scalars['String']['output']>;
  readonly descriptionPercentage: Maybe<Scalars['Float']['output']>;
  readonly designAccess: Maybe<Scalars['String']['output']>;
  readonly divisions: Maybe<ReadonlyArray<JobsDivision>>;
  readonly domainDeactivations: ReadonlyArray<DomainDeactivation>;
  readonly domains: Maybe<ReadonlyArray<DomainBase>>;
  readonly ebMemberSince: Scalars['ISO8601DateTime']['output'];
  readonly empfehlungscodes: Maybe<ReadonlyArray<Empfehlungscode>>;
  readonly employeeSurveys: Maybe<EmployeeSurveysOrganisationSurvey>;
  readonly employeeSurveysActive: Maybe<Scalars['Boolean']['output']>;
  readonly employeeSurveysState: Maybe<ServiceState>;
  readonly employerRatingPlatforms: Maybe<ReadonlyArray<EmployerRatingPlatform>>;
  readonly euresExportBlocked: Scalars['Boolean']['output'];
  readonly externalBmsHandling: OrganisationExternalBmsHandlingEnum;
  readonly externalJobboardParticipations: ReadonlyArray<ExternalJobboardParticipation>;
  readonly fairekarriereActive: Maybe<Scalars['Boolean']['output']>;
  readonly fairekarriereState: Maybe<ServiceState>;
  readonly feedMailInterval: OrganisationFeedMailIntervalEnum;
  readonly feedexportActive: Maybe<Scalars['Boolean']['output']>;
  readonly feedexportAlias: Maybe<Scalars['String']['output']>;
  readonly feedimportActive: Maybe<Scalars['Boolean']['output']>;
  readonly fkMetascoreProfiles: ReadonlyArray<FkMetascoreProfile>;
  readonly fkOrganisationSetting: Maybe<FkOrganisationSetting>;
  readonly gpt: Maybe<JobGptOrganisation>;
  /** @deprecated Use has_external_bms_delivery instead */
  readonly hasApplicationMethod: Scalars['Boolean']['output'];
  /** @deprecated Use bms_active or widget_active instead */
  readonly hasBms: Scalars['Boolean']['output'];
  readonly hasExternalBmsDelivery: Scalars['Boolean']['output'];
  readonly hasSupport: Scalars['Boolean']['output'];
  readonly hideKanaleoAward: Scalars['Boolean']['output'];
  readonly hideRelatedJobs: Scalars['Boolean']['output'];
  readonly homeofficeByDefault: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly impressionStatistics: ReadonlyArray<ClicksStatistic>;
  readonly indeedAlias: Maybe<Scalars['String']['output']>;
  readonly indeedAtsActive: Maybe<Scalars['Boolean']['output']>;
  readonly internationalsAccess: Maybe<Scalars['String']['output']>;
  readonly jobExportCooperationsAccess: Maybe<Scalars['String']['output']>;
  readonly jobImportAccess: Maybe<Scalars['String']['output']>;
  readonly jobIntegrationType: JobIntegration;
  readonly jobSettingsAccess: Maybe<Scalars['String']['output']>;
  readonly jobStatistics: ReadonlyArray<StatisticApply>;
  readonly jobgptAccess: Scalars['Boolean']['output'];
  readonly jobsTableAccess: Maybe<Scalars['String']['output']>;
  readonly jobsWidgetsAccess: Maybe<Scalars['String']['output']>;
  readonly jobwertActive: Maybe<Scalars['Boolean']['output']>;
  readonly jobwertState: Maybe<ServiceState>;
  /** @deprecated Use surveyState.survey_enabeld instead */
  readonly kanaleoActive: Maybe<Scalars['Boolean']['output']>;
  readonly kanaleoDepartmentSelections: Maybe<ReadonlyArray<KanaleoDepartmentOrganisation>>;
  readonly kanaleoServiceProviders: Maybe<ReadonlyArray<KanaleoServiceProvider>>;
  readonly kanaleoState: Maybe<ServiceState>;
  readonly kanaleoSurveySetting: KanaleoSurveySetting;
  readonly karmaHistory: ReadonlyArray<Scalars['JSON']['output']>;
  readonly lastEmployeeStatistic: EmployeeStatistic;
  readonly limitedMembership: Scalars['Boolean']['output'];
  readonly linkedinCompanyId: Maybe<Scalars['String']['output']>;
  readonly linkedinExportEnabled: Maybe<Scalars['Boolean']['output']>;
  readonly linkedinPostJobsToEbCompany: Maybe<Scalars['Boolean']['output']>;
  readonly logo: Maybe<Scalars['String']['output']>;
  readonly logoDark: Maybe<Scalars['String']['output']>;
  readonly logoDarkQuality: Maybe<ImageQualityResult>;
  readonly logoQuality: Maybe<ImageQualityResult>;
  readonly mainUserAddressId: Maybe<Scalars['ID']['output']>;
  readonly manualJobs: ReadonlyArray<JobsManualJob>;
  readonly memberships: Maybe<ReadonlyArray<Membership>>;
  readonly name: Maybe<Scalars['String']['output']>;
  readonly newsfeed: Maybe<OrganisationNewsfeed>;
  readonly newsfeedUrl: Maybe<Scalars['String']['output']>;
  readonly notifications: ReadonlyArray<Notification>;
  readonly organizationType: Maybe<OrganisationOrganizationTypeEnum>;
  readonly partnerEvents: ReadonlyArray<PartnerEvent>;
  readonly people: ReadonlyArray<Person>;
  readonly personalforumMember: Maybe<Scalars['Boolean']['output']>;
  readonly portalTypes: Maybe<ReadonlyArray<PortalType>>;
  readonly profileNotes: Maybe<Scalars['String']['output']>;
  readonly pronoun: OrganisationPronounEnum;
  readonly receivesNoMails: Maybe<Scalars['Boolean']['output']>;
  readonly recommendationReceivers: Maybe<ReadonlyArray<RecommendationReceiver>>;
  readonly rewardUsers: Maybe<ReadonlyArray<RewardUser>>;
  readonly sectorIds: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  readonly sectors: Maybe<ReadonlyArray<Sector>>;
  readonly settingsAccess: Maybe<Scalars['String']['output']>;
  readonly showDescription: Maybe<Scalars['Boolean']['output']>;
  readonly showJobProgress: Maybe<Scalars['Boolean']['output']>;
  readonly showOnboarding: Maybe<Scalars['Boolean']['output']>;
  readonly sisaxProfileUrl: Maybe<Scalars['String']['output']>;
  readonly smartclickSetting: Maybe<SmartclickSetting>;
  readonly smartclicks: Scalars['Int']['output'];
  readonly smartlinkFeedbackEntries: ReadonlyArray<SmartlinkFeedbackEntry>;
  readonly socialNetworkNames: Maybe<Scalars['JSON']['output']>;
  readonly socialNetworks: Maybe<ReadonlyArray<SocialNetwork>>;
  readonly statement: Maybe<Scalars['String']['output']>;
  readonly subprofiles: ReadonlyArray<Subprofile>;
  readonly subprofilesAccess: Maybe<Scalars['String']['output']>;
  readonly subprofilesActive: Maybe<Scalars['Boolean']['output']>;
  readonly subtitle: Maybe<Scalars['String']['output']>;
  readonly talentsAccess: Scalars['Boolean']['output'];
  readonly talentsState: Maybe<ServiceState>;
  readonly tierLevel: Scalars['String']['output'];
  readonly tour: Maybe<Tour>;
  readonly unsolicitedApplicationAllowed: Maybe<Scalars['Boolean']['output']>;
  readonly unsolicitedApplicationLink: Maybe<Scalars['String']['output']>;
  readonly uploadedBannerImages: ReadonlyArray<BannerGeneratorImage>;
  readonly usedCodes: ReadonlyArray<ApplicationStatistic>;
  readonly userEvents: Maybe<ReadonlyArray<UserEvent>>;
  readonly userName: Scalars['String']['output'];
  readonly usesExternalBms: Scalars['Boolean']['output'];
  readonly utmString: Maybe<Scalars['String']['output']>;
  readonly video: Maybe<Scalars['String']['output']>;
  readonly warnEmailInJobDescription: Scalars['Boolean']['output'];
  readonly weight: Maybe<Scalars['Int']['output']>;
  readonly widgetActive: Scalars['Boolean']['output'];
  readonly widgetEmbeddedOnCareerPage: Maybe<Scalars['Boolean']['output']>;
  readonly widgetNotUsed: Maybe<Scalars['Boolean']['output']>;
};


export type OrganisationAddressesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganisationApplicationStatisticsArgs = {
  from: Scalars['ISO8601Date']['input'];
  onlyCoworkr: InputMaybe<Scalars['Boolean']['input']>;
  onlyRecommended: InputMaybe<Scalars['Boolean']['input']>;
  onlyUnsolicited: InputMaybe<Scalars['Boolean']['input']>;
  to: InputMaybe<Scalars['ISO8601Date']['input']>;
  widget: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganisationBannersArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
};


export type OrganisationBmsUrlArgs = {
  lang: InputMaybe<AvailableLanguages>;
};


export type OrganisationCareerPageUrlArgs = {
  lang: InputMaybe<AvailableLanguages>;
};


export type OrganisationClicksStatisticsArgs = {
  from: Scalars['ISO8601Date']['input'];
  to: InputMaybe<Scalars['ISO8601Date']['input']>;
  widget: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganisationDescriptionArgs = {
  lang: InputMaybe<AvailableLanguages>;
};


export type OrganisationEmpfehlungscodesArgs = {
  active: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganisationEmployeeSurveysArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
};


export type OrganisationImpressionStatisticsArgs = {
  from: Scalars['ISO8601Date']['input'];
  to: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type OrganisationJobStatisticsArgs = {
  from: InputMaybe<Scalars['ISO8601Date']['input']>;
  to: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type OrganisationKarmaHistoryArgs = {
  from: InputMaybe<Scalars['ISO8601Date']['input']>;
  to: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type OrganisationLogoArgs = {
  variant: InputMaybe<ImageVariant>;
};


export type OrganisationLogoDarkArgs = {
  variant: InputMaybe<ImageVariant>;
};


export type OrganisationManualJobsArgs = {
  bmsTeamId: InputMaybe<Scalars['Int']['input']>;
  bmsTeamIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  visible: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganisationMembershipsArgs = {
  communitiesOnly: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganisationPartnerEventsArgs = {
  future?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganisationPeopleArgs = {
  ids: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  roleJobs: InputMaybe<Scalars['Boolean']['input']>;
  sorted?: Scalars['Boolean']['input'];
};


export type OrganisationSmartclicksArgs = {
  from: Scalars['ISO8601Date']['input'];
  to: InputMaybe<Scalars['ISO8601Date']['input']>;
  type: SmartClick;
};


export type OrganisationStatementArgs = {
  lang: InputMaybe<AvailableLanguages>;
};


export type OrganisationTourArgs = {
  type: Scalars['String']['input'];
};


export type OrganisationUsedCodesArgs = {
  from: Scalars['ISO8601Date']['input'];
  to: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type OrganisationAddressAttributes = {
  readonly city: Scalars['String']['input'];
  readonly countryCode: Scalars['String']['input'];
  readonly displayName: InputMaybe<Scalars['String']['input']>;
  readonly federalStateId: InputMaybe<Scalars['ID']['input']>;
  readonly hidden: InputMaybe<Scalars['Boolean']['input']>;
  readonly postcode: Scalars['String']['input'];
  readonly street: InputMaybe<Scalars['String']['input']>;
  readonly streetNumber: InputMaybe<Scalars['String']['input']>;
};

export type OrganisationApplicantService = {
  readonly __typename?: 'OrganisationApplicantService';
  readonly bureaucracyService: Maybe<Scalars['Boolean']['output']>;
  readonly bureaucracyServiceDescriptionDe: Maybe<Scalars['String']['output']>;
  readonly bureaucracyServiceDescriptionEn: Maybe<Scalars['String']['output']>;
  readonly companyLanguages: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly companyLanguagesDescriptionDe: Maybe<Scalars['String']['output']>;
  readonly companyLanguagesDescriptionEn: Maybe<Scalars['String']['output']>;
  readonly familyService: Maybe<Scalars['Boolean']['output']>;
  readonly familyServiceDescriptionDe: Maybe<Scalars['String']['output']>;
  readonly familyServiceDescriptionEn: Maybe<Scalars['String']['output']>;
  readonly germanEducation: Maybe<Scalars['Boolean']['output']>;
  readonly germanEducationDescriptionDe: Maybe<Scalars['String']['output']>;
  readonly germanEducationDescriptionEn: Maybe<Scalars['String']['output']>;
  readonly housingService: Maybe<Scalars['Boolean']['output']>;
  readonly housingServiceDescriptionDe: Maybe<Scalars['String']['output']>;
  readonly housingServiceDescriptionEn: Maybe<Scalars['String']['output']>;
  readonly id: Maybe<Scalars['ID']['output']>;
  readonly personId: Maybe<Scalars['Int']['output']>;
  readonly recognitionService: Maybe<Scalars['Boolean']['output']>;
  readonly recognitionServiceDescriptionDe: Maybe<Scalars['String']['output']>;
  readonly recognitionServiceDescriptionEn: Maybe<Scalars['String']['output']>;
  readonly socialService: Maybe<Scalars['Boolean']['output']>;
  readonly socialServiceDescriptionDe: Maybe<Scalars['String']['output']>;
  readonly socialServiceDescriptionEn: Maybe<Scalars['String']['output']>;
  readonly videoUsed: Maybe<Scalars['Boolean']['output']>;
  readonly videoUsedDescriptionDe: Maybe<Scalars['String']['output']>;
  readonly videoUsedDescriptionEn: Maybe<Scalars['String']['output']>;
  readonly visaService: Maybe<Scalars['Boolean']['output']>;
  readonly visaServiceDescriptionDe: Maybe<Scalars['String']['output']>;
  readonly visaServiceDescriptionEn: Maybe<Scalars['String']['output']>;
  readonly visitPossible: Maybe<Scalars['Boolean']['output']>;
  readonly visitPossibleDescriptionDe: Maybe<Scalars['String']['output']>;
  readonly visitPossibleDescriptionEn: Maybe<Scalars['String']['output']>;
};

export const enum OrganisationApplicationMailTypeEnum {
  From = 'from',
  NoApplicantEmailInMail = 'no_applicant_email_in_mail',
  None = 'none',
  Replyto = 'replyto'
};

export type OrganisationApplyOption = {
  readonly __typename?: 'OrganisationApplyOption';
  readonly applicationQuestionIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly applicationQuestions: ReadonlyArray<ApplicationQuestion>;
  readonly ebmsScreenerEnabled: Scalars['Boolean']['output'];
  readonly files: ApplyOptionEnabledEnum;
  readonly firstName: ApplyOptionEnabledEnum;
  readonly gender: ApplyOptionEnabledEnum;
  readonly id: Scalars['ID']['output'];
  readonly jobsWithDifferentApplicationQuestions: ReadonlyArray<JobsManualJob>;
  readonly lastName: ApplyOptionEnabledEnum;
  readonly postalAddress: ApplyOptionEnabledEnum;
  readonly requiredDocumentsDe: Maybe<Scalars['String']['output']>;
  readonly requiredDocumentsEn: Maybe<Scalars['String']['output']>;
  readonly screenerActive: Scalars['Boolean']['output'];
  readonly screenerKeepForDays: Maybe<Scalars['Int']['output']>;
  readonly screenerTemplateDe: Maybe<Scalars['String']['output']>;
  readonly screenerTemplateEn: Maybe<Scalars['String']['output']>;
  readonly telephone: ApplyOptionEnabledEnum;
};

export const enum OrganisationBmsApplicationRoutingEnum {
  All = 'all',
  EbOnly = 'eb_only',
  None = 'none',
  WidgetOnly = 'widget_only'
};

export const enum OrganisationDefaultBaHandicapEnum {
  HandicapNotSpecified = 'handicap_not_specified',
  HandicapSuitable = 'handicap_suitable',
  OnlyHandicap = 'only_handicap'
};

export const enum OrganisationExternalBmsHandlingEnum {
  Full = 'full',
  Hybrid = 'hybrid',
  Legacy = 'legacy',
  Link = 'link'
};

export const enum OrganisationFeedMailIntervalEnum {
  Daily = 'daily',
  Monthly = 'monthly',
  Never = 'never',
  Weekly = 'weekly'
};

export type OrganisationNewsfeed = {
  readonly __typename?: 'OrganisationNewsfeed';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly error: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly items: ReadonlyArray<OrganisationNewsfeedItem>;
  readonly lastRefresh: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly status: Maybe<OrganisationNewsfeedStatusEnum>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly url: Scalars['String']['output'];
};


export type OrganisationNewsfeedItemsArgs = {
  limit?: Scalars['Int']['input'];
  visible?: Scalars['Boolean']['input'];
};

export type OrganisationNewsfeedItem = {
  readonly __typename?: 'OrganisationNewsfeedItem';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly description: Maybe<Scalars['String']['output']>;
  readonly guid: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly link: Maybe<Scalars['String']['output']>;
  readonly localPostImagePath: Maybe<Scalars['String']['output']>;
  readonly postImageUrl: Maybe<Scalars['String']['output']>;
  readonly publishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly visible: Scalars['Boolean']['output'];
};

export const enum OrganisationNewsfeedStatusEnum {
  Error = 'error',
  Pending = 'pending',
  Success = 'success'
};

export const enum OrganisationOrganizationTypeEnum {
  AdvertisingPartner = 'advertising_partner',
  Association = 'association',
  Company = 'company',
  EducationInstitution = 'education_institution',
  PersonnelServiceProvider = 'personnel_service_provider',
  Press = 'press',
  PublicInstitution = 'public_institution',
  Recruiter = 'recruiter',
  State = 'state'
};

export const enum OrganisationPronounEnum {
  Das = 'das',
  Der = 'der',
  Die = 'die'
};

export const enum OrganisationStatus {
  All = 'all',
  Foerderer = 'foerderer',
  Partner = 'partner'
};

export type OrganisationSurveyUpdateInput = {
  readonly greetingDe: Scalars['String']['input'];
  readonly greetingEn: Scalars['String']['input'];
  readonly internalName: Scalars['String']['input'];
};

export type OrganisationSurveyUpdateQuestionsPayload = {
  readonly __typename?: 'OrganisationSurveyUpdateQuestionsPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly survey: Maybe<EmployeeSurveysOrganisationSurvey>;
};

export type PageFeatureAccessPayload = {
  readonly __typename?: 'PageFeatureAccessPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly feature: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
};

export type PartInput = {
  readonly _id: InputMaybe<Scalars['String']['input']>;
  readonly descriptionDe: InputMaybe<Scalars['String']['input']>;
  readonly descriptionEn: InputMaybe<Scalars['String']['input']>;
  readonly explanation: InputMaybe<Scalars['String']['input']>;
  readonly explanationText: InputMaybe<Scalars['String']['input']>;
  readonly global: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: InputMaybe<Scalars['ID']['input']>;
  readonly position: InputMaybe<Scalars['Int']['input']>;
  readonly questions: InputMaybe<ReadonlyArray<QuestionInput>>;
  readonly subject: InputMaybe<Scalars['String']['input']>;
  readonly surveyPartType: InputMaybe<Scalars['String']['input']>;
  readonly title: InputMaybe<Scalars['String']['input']>;
};

export type ParticipantInput = {
  readonly ageGroup: InputMaybe<Scalars['String']['input']>;
  readonly code: Scalars['String']['input'];
  readonly departmentId: InputMaybe<Scalars['ID']['input']>;
  readonly departmentName: InputMaybe<Scalars['String']['input']>;
  readonly gender: InputMaybe<Scalars['String']['input']>;
  readonly location: InputMaybe<Scalars['String']['input']>;
  readonly seniority: InputMaybe<Scalars['String']['input']>;
};

export type PartnerEvent = {
  readonly __typename?: 'PartnerEvent';
  readonly address: Maybe<Scalars['String']['output']>;
  readonly body: Maybe<Scalars['String']['output']>;
  readonly eventType: Maybe<PartnerEventEventTypeEnum>;
  readonly from: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly image: Maybe<Scalars['String']['output']>;
  readonly latitude: Maybe<Scalars['Float']['output']>;
  readonly link: Maybe<Scalars['String']['output']>;
  readonly longitude: Maybe<Scalars['Float']['output']>;
  readonly organisation: Organisation;
  readonly title: Scalars['String']['output'];
  readonly to: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type PartnerEventImageArgs = {
  variant: InputMaybe<ImageVariant>;
};

export const enum PartnerEventEventTypeEnum {
  Hr = 'hr',
  Profession = 'profession',
  Recruiting = 'recruiting'
};

export type Person = {
  readonly __typename?: 'Person';
  readonly applicationAddress: Maybe<UserAddress>;
  readonly applicationAddressId: Maybe<Scalars['Int']['output']>;
  readonly displayFormat: Maybe<Scalars['String']['output']>;
  readonly displayName: Maybe<Scalars['String']['output']>;
  readonly domainIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly email: Maybe<Scalars['String']['output']>;
  readonly firstName: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly identity: Maybe<Identity>;
  readonly lastName: Maybe<Scalars['String']['output']>;
  readonly linkedinUrl: Maybe<Scalars['String']['output']>;
  readonly membershipIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly name: Maybe<Name>;
  readonly office: Maybe<UserAddress>;
  readonly officeId: Maybe<Scalars['Int']['output']>;
  readonly organisation: Maybe<Organisation>;
  readonly photo: Maybe<Scalars['String']['output']>;
  readonly position: Maybe<Scalars['String']['output']>;
  readonly profileUrl: Maybe<Scalars['String']['output']>;
  readonly publicEmail: Maybe<Scalars['String']['output']>;
  readonly roleCrmContactable: Maybe<Scalars['Boolean']['output']>;
  readonly roleEmployeeSurveys: Maybe<Scalars['Boolean']['output']>;
  readonly roleFallback: Maybe<Scalars['Boolean']['output']>;
  readonly roleFkNotifications: Maybe<Scalars['Boolean']['output']>;
  readonly roleJobs: Maybe<Scalars['Boolean']['output']>;
  readonly roleManageBmsWidget: Maybe<Scalars['Boolean']['output']>;
  readonly roleManageCoworkr: Maybe<Scalars['Boolean']['output']>;
  readonly roleManageFairekarriere: Maybe<Scalars['Boolean']['output']>;
  readonly roleManageInvoice: Maybe<Scalars['Boolean']['output']>;
  readonly roleManageJobs: Maybe<Scalars['Boolean']['output']>;
  readonly roleManageJobwert: Maybe<Scalars['Boolean']['output']>;
  readonly roleManageKanaleo: Maybe<Scalars['Boolean']['output']>;
  readonly roleManageProfile: Maybe<Scalars['Boolean']['output']>;
  readonly roleManageTalents: Maybe<Scalars['Boolean']['output']>;
  readonly roleOrganisationAdmin: Maybe<Scalars['Boolean']['output']>;
  readonly roleProfile: Maybe<Scalars['Boolean']['output']>;
  readonly roleTechnical: Maybe<Scalars['Boolean']['output']>;
  readonly roleUnreadNotifications: Maybe<Scalars['Boolean']['output']>;
  readonly roles: ReadonlyArray<PersonRole>;
  readonly salutation: Maybe<Salutation>;
  readonly socialNetworkProfiles: ReadonlyArray<SocialNetwork>;
  readonly sortPriority: Maybe<Scalars['Int']['output']>;
  readonly subprofileId: Maybe<Scalars['Int']['output']>;
  readonly telephone: Maybe<Scalars['String']['output']>;
  readonly title: Maybe<Scalars['String']['output']>;
  readonly translatedSalutation: Maybe<Scalars['String']['output']>;
  readonly xingUrl: Maybe<Scalars['String']['output']>;
};


export type PersonPhotoArgs = {
  variant: InputMaybe<PersonPhotoVariantsEnum>;
};


export type PersonRolesArgs = {
  type: InputMaybe<PersonRoleType>;
};

export type PersonFormInput = {
  readonly applicationAddressId: InputMaybe<Scalars['Int']['input']>;
  readonly createIdentity: InputMaybe<Scalars['Boolean']['input']>;
  readonly displayFormat: InputMaybe<Scalars['String']['input']>;
  readonly ebmsIdentityType: InputMaybe<Scalars['String']['input']>;
  readonly email: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly id: InputMaybe<Scalars['Int']['input']>;
  readonly identity: InputMaybe<IdentityInput>;
  readonly lastName: Scalars['String']['input'];
  readonly linkedinUrl: InputMaybe<Scalars['String']['input']>;
  readonly membershipIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly officeId: InputMaybe<Scalars['Int']['input']>;
  readonly photoBase64: InputMaybe<Scalars['String']['input']>;
  readonly position: Scalars['String']['input'];
  readonly publicEmail: InputMaybe<Scalars['String']['input']>;
  readonly roles: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly salutation: Scalars['String']['input'];
  readonly sortPriority: InputMaybe<Scalars['Int']['input']>;
  readonly subprofileId: InputMaybe<Scalars['Int']['input']>;
  readonly telephone: InputMaybe<Scalars['String']['input']>;
  readonly title: InputMaybe<Scalars['String']['input']>;
  readonly xingUrl: InputMaybe<Scalars['String']['input']>;
};

export const enum PersonPhotoVariantsEnum {
  BmsLarge = 'bms_large',
  Medium = 'medium',
  Original = 'original',
  Portal = 'portal',
  Small = 'small'
};

export type PersonRole = {
  readonly __typename?: 'PersonRole';
  readonly available: Maybe<Scalars['Boolean']['output']>;
  readonly description: Maybe<Scalars['String']['output']>;
  readonly key: Scalars['String']['output'];
  readonly short: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly type: PersonRoleType;
  readonly validation: Scalars['Boolean']['output'];
  readonly validationText: Maybe<Scalars['String']['output']>;
};

export const enum PersonRoleType {
  Communication = 'communication',
  Display = 'display',
  Functional = 'functional'
};

export type PludoniService = {
  readonly __typename?: 'PludoniService';
  readonly colorDark: Maybe<Scalars['String']['output']>;
  readonly colorGreyDark: Maybe<Scalars['String']['output']>;
  readonly colorGreyLight: Maybe<Scalars['String']['output']>;
  readonly colorGreyMedium: Maybe<Scalars['String']['output']>;
  readonly colorLight: Maybe<Scalars['String']['output']>;
  readonly colorMedium: Maybe<Scalars['String']['output']>;
  readonly host: Maybe<Scalars['String']['output']>;
  readonly iconUrl: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly key: Maybe<Scalars['String']['output']>;
  readonly logoWithIconUrl: Maybe<Scalars['String']['output']>;
  readonly name: Maybe<Scalars['String']['output']>;
  readonly urlName: Maybe<Scalars['String']['output']>;
};

export type PortalType = {
  readonly __typename?: 'PortalType';
  readonly competences: Maybe<ReadonlyArray<Competence>>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly tagline: Maybe<Scalars['String']['output']>;
  readonly upcase: Scalars['String']['output'];
};

export type PreviewJobInput = {
  readonly applicantServiceBureaucracyService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceFamilyService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceGermanEducation: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceHousingService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceRecognitionService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceSocialService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceVideoUsed: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceVisaService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceVisitPossible: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServices: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly applicationQuestionIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly autoRefresh: InputMaybe<Scalars['Boolean']['input']>;
  readonly baBerufId: InputMaybe<Scalars['Int']['input']>;
  readonly baBerufeIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly baHandicap: InputMaybe<Scalars['String']['input']>;
  readonly baIgnore: InputMaybe<Scalars['Boolean']['input']>;
  readonly benefitIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly bewerbungsweg: InputMaybe<Scalars['String']['input']>;
  readonly blobId: InputMaybe<Scalars['String']['input']>;
  readonly blobUrl: InputMaybe<Scalars['String']['input']>;
  readonly bmsTeamId: InputMaybe<Scalars['Int']['input']>;
  readonly bundesweit: InputMaybe<Scalars['Boolean']['input']>;
  readonly customWeight: InputMaybe<Scalars['String']['input']>;
  readonly deleteDocument: InputMaybe<Scalars['Boolean']['input']>;
  readonly deleteOgImage: InputMaybe<Scalars['Boolean']['input']>;
  readonly description: InputMaybe<Scalars['String']['input']>;
  readonly divisionIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly experienceLevelIntermediate: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelJunior: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelQuereinstieg: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelSenior: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelUngelernt: InputMaybe<Scalars['Boolean']['input']>;
  readonly expirationDate: InputMaybe<Scalars['String']['input']>;
  readonly externalJobboardSettings: InputMaybe<Scalars['JSON']['input']>;
  readonly extraOrt: InputMaybe<Scalars['String']['input']>;
  readonly fid: InputMaybe<Scalars['Int']['input']>;
  readonly headerImageBlobId: InputMaybe<Scalars['String']['input']>;
  readonly headerImageId: InputMaybe<Scalars['Int']['input']>;
  readonly internal: InputMaybe<Scalars['Boolean']['input']>;
  readonly jobGptId: InputMaybe<Scalars['String']['input']>;
  readonly jobGptType: InputMaybe<Scalars['String']['input']>;
  readonly jobSharing: InputMaybe<Scalars['Boolean']['input']>;
  readonly languageLevelEnglish: InputMaybe<Scalars['String']['input']>;
  readonly languageLevelGerman: InputMaybe<Scalars['String']['input']>;
  readonly languageLevelOther: InputMaybe<Scalars['String']['input']>;
  readonly languageOther: InputMaybe<Scalars['String']['input']>;
  readonly link: InputMaybe<Scalars['String']['input']>;
  readonly masterJobId: InputMaybe<Scalars['Int']['input']>;
  readonly nummer: InputMaybe<Scalars['String']['input']>;
  readonly ogImageBlobId: InputMaybe<Scalars['String']['input']>;
  readonly ogImageId: InputMaybe<Scalars['Int']['input']>;
  readonly parentJobId: InputMaybe<Scalars['Int']['input']>;
  readonly personIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly portalType: InputMaybe<Scalars['String']['input']>;
  readonly pubdate: InputMaybe<Scalars['String']['input']>;
  readonly relocationSupport: InputMaybe<Scalars['String']['input']>;
  readonly relocationSupportDescription: InputMaybe<Scalars['String']['input']>;
  readonly remoteCountryList: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly remoteType: InputMaybe<Scalars['String']['input']>;
  readonly salaryInterval: InputMaybe<Scalars['String']['input']>;
  readonly salaryMax: InputMaybe<Scalars['Float']['input']>;
  readonly salaryMin: InputMaybe<Scalars['Float']['input']>;
  readonly subJobType: InputMaybe<Scalars['String']['input']>;
  readonly subprofileId: InputMaybe<Scalars['Int']['input']>;
  readonly tags: InputMaybe<Scalars['String']['input']>;
  readonly targetAudienceCountry: InputMaybe<Scalars['String']['input']>;
  readonly targetAudienceWorkPermit: InputMaybe<Scalars['String']['input']>;
  readonly tarifvertragId: InputMaybe<Scalars['ID']['input']>;
  readonly tarifvertragLevelMaxId: InputMaybe<Scalars['ID']['input']>;
  readonly tarifvertragLevelMinId: InputMaybe<Scalars['ID']['input']>;
  readonly tarifvertragSalaryGroup: InputMaybe<Scalars['String']['input']>;
  readonly temporary: InputMaybe<Scalars['Boolean']['input']>;
  readonly temporaryConversionToPermanentPossible: InputMaybe<Scalars['Boolean']['input']>;
  readonly temporaryEnd: InputMaybe<Scalars['String']['input']>;
  readonly title: InputMaybe<Scalars['String']['input']>;
  readonly translatedContents: InputMaybe<ReadonlyArray<TranslatedContentInput>>;
  readonly userAddressIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly vacationMax: InputMaybe<Scalars['Int']['input']>;
  readonly vacationMin: InputMaybe<Scalars['Int']['input']>;
  readonly visible: InputMaybe<Scalars['Boolean']['input']>;
  readonly workingTime: InputMaybe<Scalars['String']['input']>;
  readonly workingTimeHoursMax: InputMaybe<Scalars['Float']['input']>;
  readonly workingTimeHoursMin: InputMaybe<Scalars['Float']['input']>;
};

export type PreviewJobPayload = {
  readonly __typename?: 'PreviewJobPayload';
  readonly html: Maybe<Scalars['String']['output']>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly allCompetences: ReadonlyArray<Competence>;
  readonly allEmployerRatingPlatforms: ReadonlyArray<Scalars['String']['output']>;
  readonly allPortalTypes: ReadonlyArray<PortalType>;
  readonly allRewardGroups: ReadonlyArray<Scalars['String']['output']>;
  readonly allRewards: ReadonlyArray<Reward>;
  readonly allSectors: ReadonlyArray<Sector>;
  readonly allSocialNetworks: ReadonlyArray<Scalars['String']['output']>;
  readonly applicationQuestions: ReadonlyArray<ApplicationQuestion>;
  readonly banners: QueryBanners;
  readonly berufe: ReadonlyArray<Beruf>;
  readonly competenceInfo: Maybe<JobsCompetenceInfo>;
  readonly cpcProviders: ReadonlyArray<CpcProvider>;
  readonly domains: ReadonlyArray<DomainBase>;
  readonly employeeSurveyModels: ReadonlyArray<EmployeeSurveysModel>;
  readonly generateRejectionFeedback: Maybe<TranslatedTextResult>;
  readonly getOrganisationSurvey: Maybe<EmployeeSurveysOrganisationSurvey>;
  readonly globalSurveys: Maybe<ReadonlyArray<EmployeeSurveysOrganisationSurvey>>;
  readonly gptObject: GptObjectInterface;
  readonly identityByEmail: Maybe<Identity>;
  readonly kanaleo: QueryKanaleo;
  readonly keywordInfo: Maybe<JobsKeywordInfo>;
  readonly keywordSuggestions: ReadonlyArray<JobsKeywordSuggestion>;
  readonly manualJob: Maybe<JobsManualJob>;
  readonly matchingJobsForQuestionFilter: Scalars['JSON']['output'];
  readonly me: Maybe<User>;
  readonly organisations: ReadonlyArray<Organisation>;
  readonly personRoles: ReadonlyArray<PersonRole>;
  readonly pludoniServices: ReadonlyArray<PludoniService>;
  readonly tarifvertraege: ReadonlyArray<Tarifvertrag>;
  readonly tier: Maybe<TierAbility>;
  readonly tierFeatureMatrix: Maybe<TierFeatureMatrix>;
  readonly tierHistory: Maybe<ReadonlyArray<TierAbility>>;
  readonly tierSettings: Maybe<TierSettings>;
  readonly translate: Maybe<Scalars['String']['output']>;
};


export type QueryBerufeArgs = {
  ids: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: InputMaybe<Scalars['String']['input']>;
  subJobType: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompetenceInfoArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryDomainsArgs = {
  notEmpfehlungsbund: InputMaybe<Scalars['Boolean']['input']>;
  visible: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGenerateRejectionFeedbackArgs = {
  answers: InputMaybe<Scalars['JSON']['input']>;
  questionDe: Scalars['String']['input'];
  questionEn: Scalars['String']['input'];
};


export type QueryGetOrganisationSurveyArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGptObjectArgs = {
  gptObjectId: Scalars['ID']['input'];
  gptObjectType: Scalars['String']['input'];
};


export type QueryIdentityByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryKeywordInfoArgs = {
  masterJobId: Scalars['ID']['input'];
};


export type QueryKeywordSuggestionsArgs = {
  masterJobId: Scalars['ID']['input'];
  source: InputMaybe<Scalars['String']['input']>;
};


export type QueryManualJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchingJobsForQuestionFilterArgs = {
  filterKeywords: InputMaybe<Scalars['String']['input']>;
  filterLocations: InputMaybe<Scalars['String']['input']>;
  filterSubJobTypes: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};


export type QueryOrganisationsArgs = {
  ebmsUsers: InputMaybe<Scalars['Boolean']['input']>;
  organisationType: InputMaybe<Scalars['String']['input']>;
  portalType: InputMaybe<Scalars['String']['input']>;
  sectorId: InputMaybe<Scalars['Int']['input']>;
  type: InputMaybe<OrganisationStatus>;
  withQuote: InputMaybe<CommunityQuoteEnum>;
};


export type QueryPludoniServicesArgs = {
  keys: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};


export type QueryTierHistoryArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryTierSettingsArgs = {
  organisationId: Scalars['ID']['input'];
  tierType: Scalars['String']['input'];
};


export type QueryTranslateArgs = {
  engine?: InputMaybe<TranslationEngine>;
  from?: InputMaybe<Scalars['String']['input']>;
  isHtml?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type QueryBanners = {
  readonly __typename?: 'QueryBanners';
  readonly layouts: ReadonlyArray<BannerGeneratorLayout>;
};

export type QueryKanaleo = {
  readonly __typename?: 'QueryKanaleo';
  readonly departments: ReadonlyArray<KanaleoDepartment>;
  readonly serviceProviders: ReadonlyArray<KanaleoServiceProvider>;
};

export type QuestionInput = {
  readonly _id: InputMaybe<Scalars['String']['input']>;
  readonly answerOptions: InputMaybe<Scalars['JSON']['input']>;
  readonly answerType: Scalars['String']['input'];
  readonly id: InputMaybe<Scalars['ID']['input']>;
  readonly modelCode: InputMaybe<Scalars['String']['input']>;
  readonly position: InputMaybe<Scalars['Int']['input']>;
  readonly readOnly: InputMaybe<Scalars['Boolean']['input']>;
  readonly textDe: Scalars['String']['input'];
  readonly textEn: Scalars['String']['input'];
};

export type QuoteRelevancePayload = {
  readonly __typename?: 'QuoteRelevancePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly quoteRelevance: Scalars['String']['output'];
};

export const enum Recommendation {
  Strong = 'strong',
  Weak = 'weak'
};

export type RecommendationReceiver = {
  readonly __typename?: 'RecommendationReceiver';
  readonly createdAt: Scalars['ISO8601Date']['output'];
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type Reward = {
  readonly __typename?: 'Reward';
  readonly description: Scalars['String']['output'];
  readonly group: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly link: Maybe<Scalars['String']['output']>;
  readonly logo: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly userLinkOptional: Scalars['Boolean']['output'];
  readonly year: Maybe<Scalars['String']['output']>;
};


export type RewardLogoArgs = {
  variant: InputMaybe<ImageVariant>;
};

export type RewardAttributes = {
  readonly id: InputMaybe<Scalars['ID']['input']>;
  readonly link: InputMaybe<Scalars['String']['input']>;
  readonly newReward: InputMaybe<NewRewardInput>;
  readonly organisationId: Scalars['ID']['input'];
  readonly rewardId: InputMaybe<Scalars['ID']['input']>;
  readonly year: InputMaybe<Scalars['String']['input']>;
};

export type RewardUser = {
  readonly __typename?: 'RewardUser';
  readonly badge: Maybe<Scalars['String']['output']>;
  readonly hidden: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly link: Maybe<Scalars['String']['output']>;
  readonly organisationId: Scalars['ID']['output'];
  readonly reward: Reward;
  readonly rewardId: Scalars['ID']['output'];
  readonly year: Maybe<Scalars['String']['output']>;
};


export type RewardUserBadgeArgs = {
  variant: InputMaybe<ImageVariant>;
};

export type RewardsPayload = {
  readonly __typename?: 'RewardsPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly rewardUsers: Maybe<ReadonlyArray<RewardUser>>;
};

export const enum Salutation {
  Female = 'female',
  Male = 'male',
  None = 'none'
};

export type Sector = {
  readonly __typename?: 'Sector';
  readonly description: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
};

export type ServiceProvidersPayload = {
  readonly __typename?: 'ServiceProvidersPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly serviceProviders: ReadonlyArray<KanaleoServiceProvider>;
};

export const enum ServiceState {
  Base = 'base',
  Deactivated = 'deactivated',
  Full = 'full'
};

export type ServiceStatesAttributes = {
  readonly bms: InputMaybe<ServiceState>;
  readonly coworkr: InputMaybe<ServiceState>;
  readonly fairekarriere: InputMaybe<ServiceState>;
  readonly jobwert: InputMaybe<ServiceState>;
  readonly kanaleo: InputMaybe<ServiceState>;
};

export type ServiceStatesPayload = {
  readonly __typename?: 'ServiceStatesPayload';
  readonly bmsState: ServiceState;
  readonly coworkrState: ServiceState;
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly fairekarriereState: ServiceState;
  readonly jobwertState: ServiceState;
  readonly kanaleoState: ServiceState;
};

export type SlotInput = {
  readonly imageId: InputMaybe<Scalars['ID']['input']>;
  readonly position: Scalars['Int']['input'];
  readonly signedBlobId: InputMaybe<Scalars['String']['input']>;
};

export const enum SmartClick {
  All = 'ALL',
  Strong = 'STRONG',
  Weak = 'WEAK'
};

export type SmartclickSetting = {
  readonly __typename?: 'SmartclickSetting';
  readonly boostActive: Scalars['Boolean']['output'];
  readonly comment: Maybe<Scalars['String']['output']>;
  readonly communityManagerActivityBoost: Maybe<Scalars['Int']['output']>;
  readonly feedimportMax: Maybe<Scalars['Int']['output']>;
  readonly ignore: Scalars['Boolean']['output'];
  readonly ignoreUntil: Maybe<Scalars['ISO8601Date']['output']>;
  readonly statisticUnreliable: Scalars['Boolean']['output'];
};

export type SmartclickSettingUpdateAttributePayload = {
  readonly __typename?: 'SmartclickSettingUpdateAttributePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly smartclickSetting: Maybe<SmartclickSetting>;
};

export type SmartlinkFeedbackEntry = {
  readonly __typename?: 'SmartlinkFeedbackEntry';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly date: Maybe<Scalars['ISO8601Date']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly recipients: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly severity: Maybe<Scalars['String']['output']>;
  readonly status: Scalars['String']['output'];
  readonly subtitle: Maybe<Scalars['String']['output']>;
  readonly title: Maybe<Scalars['String']['output']>;
};

export type SocialNetwork = {
  readonly __typename?: 'SocialNetwork';
  readonly icon: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Maybe<Scalars['String']['output']>;
  readonly organisationId: Scalars['ID']['output'];
  readonly regex: Maybe<Scalars['String']['output']>;
  readonly url: Maybe<Scalars['String']['output']>;
};

export type SocialNetworkAttributes = {
  readonly icon: InputMaybe<Scalars['String']['input']>;
  readonly id: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly organisationId: Scalars['ID']['input'];
  readonly url: Scalars['String']['input'];
};

export type SocialNetworksPayload = {
  readonly __typename?: 'SocialNetworksPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly socialNetworks: Maybe<ReadonlyArray<SocialNetwork>>;
};

export type StatisticApply = {
  readonly __typename?: 'StatisticApply';
  readonly applicationCount: Maybe<Scalars['Int']['output']>;
  readonly applicationCoworkrCount: Maybe<Scalars['Int']['output']>;
  readonly applicationRecommendedCount: Maybe<Scalars['Int']['output']>;
  readonly applicationUnsolicitedCount: Maybe<Scalars['Int']['output']>;
  readonly applicationWidgetCount: Maybe<Scalars['Int']['output']>;
  readonly clicksCount: Maybe<Scalars['Int']['output']>;
  readonly computedApplicationEmpfehlungsbundCount: Maybe<Scalars['Int']['output']>;
  readonly computedApplicationTotalCount: Maybe<Scalars['Int']['output']>;
  readonly computedHiredEmpfehlungsbundCount: Maybe<Scalars['Int']['output']>;
  readonly computedHiredTotalCount: Maybe<Scalars['Int']['output']>;
  readonly coworkrClicks: Maybe<Scalars['Int']['output']>;
  readonly coworkrEventsPerJob: Maybe<ReadonlyArray<StatisticCoworkrEventsPerJob>>;
  readonly coworkrOpenedMails: Maybe<Scalars['Int']['output']>;
  readonly coworkrReceivedMails: Maybe<Scalars['Int']['output']>;
  readonly coworkrSubscribersCount: Maybe<Scalars['Int']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly date: Maybe<Scalars['ISO8601Date']['output']>;
  readonly estimatedApplicationEmpfehlungsbundCount: Maybe<Scalars['Int']['output']>;
  readonly estimatedApplicationTotalCount: Maybe<Scalars['Int']['output']>;
  readonly estimatedHiredEmpfehlungsbundCount: Maybe<Scalars['Float']['output']>;
  readonly estimatedHiredTotalCount: Maybe<Scalars['Float']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly impressionsCount: Maybe<Scalars['Int']['output']>;
  readonly internCount: Maybe<Scalars['Int']['output']>;
  readonly isEditable: Scalars['Boolean']['output'];
  readonly isUntouched: Scalars['Boolean']['output'];
  readonly jobsCount: Maybe<Scalars['Int']['output']>;
  readonly month: Maybe<Scalars['Int']['output']>;
  readonly shouldWarnMissingData: Scalars['Boolean']['output'];
  readonly smartclicks: Maybe<Scalars['Int']['output']>;
  readonly smartclicksCompliant: Maybe<Scalars['Boolean']['output']>;
  readonly smartclicksPerApplications: Maybe<Scalars['Float']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly usedCodesCount: Maybe<Scalars['Int']['output']>;
  readonly userApplicationEmpfehlungsbundCount: Maybe<Scalars['Float']['output']>;
  readonly userApplicationTotalCount: Maybe<Scalars['Float']['output']>;
  readonly userHiredEmpfehlungsbundCount: Maybe<Scalars['Float']['output']>;
  readonly userHiredTotalCount: Maybe<Scalars['Float']['output']>;
  readonly widgetClicks: Maybe<Scalars['Int']['output']>;
  readonly year: Maybe<Scalars['Int']['output']>;
};

export type StatisticCoworkrEventsPerJob = {
  readonly __typename?: 'StatisticCoworkrEventsPerJob';
  readonly clicks: Scalars['Int']['output'];
  readonly nummer: Scalars['String']['output'];
  readonly shares: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
};

export type Subprofile = {
  readonly __typename?: 'Subprofile';
  readonly addresses: UserAddress;
  readonly banner: Maybe<Scalars['String']['output']>;
  readonly customBanner: Scalars['Boolean']['output'];
  readonly customDescription: Scalars['Boolean']['output'];
  readonly customLogo: Scalars['Boolean']['output'];
  readonly customStatement: Scalars['Boolean']['output'];
  readonly description: Scalars['String']['output'];
  readonly descriptionEn: Scalars['String']['output'];
  readonly domains: DomainBase;
  readonly id: Scalars['ID']['output'];
  readonly includeMainProfileName: Scalars['Boolean']['output'];
  readonly logo: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly statement: Maybe<Scalars['String']['output']>;
  readonly statementEn: Maybe<Scalars['String']['output']>;
  readonly subtitle: Maybe<Scalars['String']['output']>;
};


export type SubprofileBannerArgs = {
  variant: InputMaybe<ImageVariant>;
};


export type SubprofileLogoArgs = {
  variant: InputMaybe<ImageVariant>;
};

export type SurveySettingUpdateAttributePayload = {
  readonly __typename?: 'SurveySettingUpdateAttributePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly surveySetting: Maybe<KanaleoSurveySetting>;
};

export type TalentsStatePayload = {
  readonly __typename?: 'TalentsStatePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly talentsState: Scalars['String']['output'];
};

export type Tarifvertrag = {
  readonly __typename?: 'Tarifvertrag';
  readonly availableFrom: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly availableUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly tarifvertragSalaryEntries: ReadonlyArray<TarifvertragEntry>;
  readonly year: Scalars['Int']['output'];
};

export type TarifvertragEntry = {
  readonly __typename?: 'TarifvertragEntry';
  readonly id: Scalars['ID']['output'];
  readonly level: Scalars['String']['output'];
  readonly salary: Scalars['Float']['output'];
  readonly salaryGroup: Scalars['String']['output'];
  readonly tarifvertragId: Scalars['ID']['output'];
};

export type TierAbility = {
  readonly __typename?: 'TierAbility';
  readonly active: Scalars['Boolean']['output'];
  readonly addressesAccess: Scalars['String']['output'];
  readonly backlinksAccess: Scalars['String']['output'];
  readonly bannerAccess: Scalars['String']['output'];
  readonly benefitsAccess: Scalars['String']['output'];
  readonly bmsState: Scalars['String']['output'];
  readonly certificateAccess: Scalars['Boolean']['output'];
  readonly codesAccess: Scalars['String']['output'];
  readonly communityPortalProfileVisible: Scalars['Boolean']['output'];
  readonly competencesAccess: Scalars['String']['output'];
  readonly cooperationSettingsAccess: Scalars['String']['output'];
  readonly coworkrState: Scalars['String']['output'];
  readonly currentAbilitySince: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly departmentsAccess: Scalars['String']['output'];
  readonly designAccess: Scalars['String']['output'];
  readonly diff: Maybe<ReadonlyArray<TierDiff>>;
  readonly employeeSurveysState: Scalars['String']['output'];
  readonly events: Maybe<ReadonlyArray<TierEvent>>;
  readonly fairekarriereState: Scalars['String']['output'];
  readonly feedexportActive: Scalars['Boolean']['output'];
  readonly feedimportActive: Scalars['Boolean']['output'];
  readonly hideRelatedJobs: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly internationalsAccess: Scalars['String']['output'];
  readonly jobExportCooperationsAccess: Scalars['String']['output'];
  readonly jobImportAccess: Scalars['String']['output'];
  readonly jobSettingsAccess: Scalars['String']['output'];
  readonly jobsTableAccess: Scalars['String']['output'];
  readonly jobsWidgetsAccess: Scalars['String']['output'];
  readonly jobwertState: Scalars['String']['output'];
  readonly kanaleoState: Scalars['String']['output'];
  readonly latestEvent: Maybe<TierEvent>;
  readonly organisation: Organisation;
  readonly settingsAccess: Scalars['String']['output'];
  readonly subprofilesAccess: Scalars['String']['output'];
  readonly talentsState: Scalars['String']['output'];
  readonly tierLevel: Scalars['String']['output'];
  readonly tierLevelKey: Scalars['String']['output'];
};

export type TierDiff = {
  readonly __typename?: 'TierDiff';
  readonly changed: Scalars['Boolean']['output'];
  readonly current: Scalars['String']['output'];
  readonly currentLabel: Scalars['String']['output'];
  readonly default: Scalars['String']['output'];
  readonly defaultLabel: Scalars['String']['output'];
  readonly displayClass: Scalars['String']['output'];
  readonly displayIcon: Scalars['String']['output'];
  readonly displayValue: Scalars['String']['output'];
  readonly hint: Maybe<Scalars['String']['output']>;
  readonly itemKey: Scalars['String']['output'];
  readonly key: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
};

export type TierEvent = {
  readonly __typename?: 'TierEvent';
  readonly admin: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly fromAbility: Maybe<TierAbility>;
  readonly id: Scalars['ID']['output'];
  readonly identity: Maybe<Identity>;
  readonly payload: Maybe<Scalars['JSON']['output']>;
  readonly toAbility: Maybe<TierAbility>;
  readonly triggeredBy: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
  readonly typeLabel: Scalars['String']['output'];
};

export type TierFeatureMatrix = {
  readonly __typename?: 'TierFeatureMatrix';
  readonly allFeatures: ReadonlyArray<FeatureInfo>;
  readonly featureCategories: FeatureCategories;
  readonly tierLevels: ReadonlyArray<TierLevelInfo>;
};

export type TierLevelInfo = {
  readonly __typename?: 'TierLevelInfo';
  readonly description: Scalars['String']['output'];
  readonly features: Scalars['JSON']['output'];
  readonly key: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
};

export type TierSettingItem = {
  readonly __typename?: 'TierSettingItem';
  readonly changed: Scalars['Boolean']['output'];
  readonly currentValue: Scalars['String']['output'];
  readonly defaultValue: Scalars['String']['output'];
  readonly displayClass: Scalars['String']['output'];
  readonly displayIcon: Scalars['String']['output'];
  readonly displayValue: Scalars['String']['output'];
  readonly hint: Maybe<Scalars['String']['output']>;
  readonly isIndividual: Scalars['Boolean']['output'];
  readonly key: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
  readonly newValue: Scalars['String']['output'];
};

export type TierSettings = {
  readonly __typename?: 'TierSettings';
  readonly hasExisting: Scalars['Boolean']['output'];
  readonly settings: ReadonlyArray<TierSettingItem>;
};

export type Tour = {
  readonly __typename?: 'Tour';
  readonly items: ReadonlyArray<TourItem>;
  readonly type: Scalars['String']['output'];
};

export type TourItem = {
  readonly __typename?: 'TourItem';
  readonly attachTo: Scalars['JSON']['output'];
  readonly description: Maybe<Scalars['String']['output']>;
  readonly key: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
};

export type TranslatedContentInput = {
  readonly description: Scalars['String']['input'];
  readonly locale: Scalars['String']['input'];
  readonly tags: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type TranslatedTextResult = {
  readonly __typename?: 'TranslatedTextResult';
  readonly de: Maybe<Scalars['String']['output']>;
  readonly en: Maybe<Scalars['String']['output']>;
};

export const enum TranslationEngine {
  Deepl = 'DEEPL',
  Google = 'GOOGLE'
};

export type UpdateApplyStatisticsPayload = {
  readonly __typename?: 'UpdateApplyStatisticsPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly jobStatistics: Maybe<ReadonlyArray<StatisticApply>>;
};

export type UpdateAttributePayload = {
  readonly __typename?: 'UpdateAttributePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly organisation: Maybe<Organisation>;
};

export type UpdateBannerPayload = {
  readonly __typename?: 'UpdateBannerPayload';
  readonly banner: Maybe<BannerGeneratorBanner>;
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type UpdateDepartmentPayload = {
  readonly __typename?: 'UpdateDepartmentPayload';
  readonly department: Maybe<EmployeeSurveysDepartment>;
  readonly errors: ReadonlyArray<ValidationErrors>;
};

export type UpdateDispositionStatusPayload = {
  readonly __typename?: 'UpdateDispositionStatusPayload';
  readonly success: Scalars['Boolean']['output'];
};

export type UpdateEmployeeCountPayload = {
  readonly __typename?: 'UpdateEmployeeCountPayload';
  readonly organisation: Maybe<Organisation>;
};

export type UpdateJobInput = {
  readonly applicantServiceBureaucracyService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceFamilyService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceGermanEducation: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceHousingService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceRecognitionService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceSocialService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceVideoUsed: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceVisaService: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServiceVisitPossible: InputMaybe<Scalars['Boolean']['input']>;
  readonly applicantServices: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly applicationQuestionIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly autoRefresh: InputMaybe<Scalars['Boolean']['input']>;
  readonly baBerufId: InputMaybe<Scalars['Int']['input']>;
  readonly baBerufeIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly baHandicap: InputMaybe<Scalars['String']['input']>;
  readonly baIgnore: InputMaybe<Scalars['Boolean']['input']>;
  readonly benefitIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly bewerbungsweg: InputMaybe<Scalars['String']['input']>;
  readonly blobId: InputMaybe<Scalars['String']['input']>;
  readonly blobUrl: InputMaybe<Scalars['String']['input']>;
  readonly bmsTeamId: InputMaybe<Scalars['Int']['input']>;
  readonly bundesweit: InputMaybe<Scalars['Boolean']['input']>;
  readonly customWeight: InputMaybe<Scalars['String']['input']>;
  readonly deleteDocument: InputMaybe<Scalars['Boolean']['input']>;
  readonly deleteOgImage: InputMaybe<Scalars['Boolean']['input']>;
  readonly description: InputMaybe<Scalars['String']['input']>;
  readonly divisionIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly experienceLevelIntermediate: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelJunior: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelQuereinstieg: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelSenior: InputMaybe<Scalars['Boolean']['input']>;
  readonly experienceLevelUngelernt: InputMaybe<Scalars['Boolean']['input']>;
  readonly expirationDate: InputMaybe<Scalars['String']['input']>;
  readonly externalJobboardSettings: InputMaybe<Scalars['JSON']['input']>;
  readonly extraOrt: InputMaybe<Scalars['String']['input']>;
  readonly fid: InputMaybe<Scalars['Int']['input']>;
  readonly headerImageBlobId: InputMaybe<Scalars['String']['input']>;
  readonly headerImageId: InputMaybe<Scalars['Int']['input']>;
  readonly internal: InputMaybe<Scalars['Boolean']['input']>;
  readonly jobGptId: InputMaybe<Scalars['String']['input']>;
  readonly jobGptType: InputMaybe<Scalars['String']['input']>;
  readonly jobSharing: InputMaybe<Scalars['Boolean']['input']>;
  readonly languageLevelEnglish: InputMaybe<Scalars['String']['input']>;
  readonly languageLevelGerman: InputMaybe<Scalars['String']['input']>;
  readonly languageLevelOther: InputMaybe<Scalars['String']['input']>;
  readonly languageOther: InputMaybe<Scalars['String']['input']>;
  readonly link: InputMaybe<Scalars['String']['input']>;
  readonly masterJobId: InputMaybe<Scalars['Int']['input']>;
  readonly nummer: InputMaybe<Scalars['String']['input']>;
  readonly ogImageBlobId: InputMaybe<Scalars['String']['input']>;
  readonly ogImageId: InputMaybe<Scalars['Int']['input']>;
  readonly parentJobId: InputMaybe<Scalars['Int']['input']>;
  readonly personIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly portalType: InputMaybe<Scalars['String']['input']>;
  readonly pubdate: InputMaybe<Scalars['String']['input']>;
  readonly relocationSupport: InputMaybe<Scalars['String']['input']>;
  readonly relocationSupportDescription: InputMaybe<Scalars['String']['input']>;
  readonly remoteCountryList: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly remoteType: InputMaybe<Scalars['String']['input']>;
  readonly salaryInterval: InputMaybe<Scalars['String']['input']>;
  readonly salaryMax: InputMaybe<Scalars['Float']['input']>;
  readonly salaryMin: InputMaybe<Scalars['Float']['input']>;
  readonly subJobType: InputMaybe<Scalars['String']['input']>;
  readonly subprofileId: InputMaybe<Scalars['Int']['input']>;
  readonly tags: InputMaybe<Scalars['String']['input']>;
  readonly targetAudienceCountry: InputMaybe<Scalars['String']['input']>;
  readonly targetAudienceWorkPermit: InputMaybe<Scalars['String']['input']>;
  readonly tarifvertragId: InputMaybe<Scalars['ID']['input']>;
  readonly tarifvertragLevelMaxId: InputMaybe<Scalars['ID']['input']>;
  readonly tarifvertragLevelMinId: InputMaybe<Scalars['ID']['input']>;
  readonly tarifvertragSalaryGroup: InputMaybe<Scalars['String']['input']>;
  readonly temporary: InputMaybe<Scalars['Boolean']['input']>;
  readonly temporaryConversionToPermanentPossible: InputMaybe<Scalars['Boolean']['input']>;
  readonly temporaryEnd: InputMaybe<Scalars['String']['input']>;
  readonly title: InputMaybe<Scalars['String']['input']>;
  readonly translatedContents: InputMaybe<ReadonlyArray<TranslatedContentInput>>;
  readonly userAddressIds: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly vacationMax: InputMaybe<Scalars['Int']['input']>;
  readonly vacationMin: InputMaybe<Scalars['Int']['input']>;
  readonly visible: InputMaybe<Scalars['Boolean']['input']>;
  readonly workingTime: InputMaybe<Scalars['String']['input']>;
  readonly workingTimeHoursMax: InputMaybe<Scalars['Float']['input']>;
  readonly workingTimeHoursMin: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateJobPayload = {
  readonly __typename?: 'UpdateJobPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly manualJob: Maybe<JobsManualJob>;
};

export type UpdateLayoutPayload = {
  readonly __typename?: 'UpdateLayoutPayload';
  readonly layout: Maybe<DashboardLayout>;
};

export type UpdateMetascoreProfilePayload = {
  readonly __typename?: 'UpdateMetascoreProfilePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly metascoreProfile: Maybe<FkMetascoreProfile>;
};

export type UpdateOrganisationSettingPayload = {
  readonly __typename?: 'UpdateOrganisationSettingPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly fkOrganisationSetting: Maybe<FkOrganisationSetting>;
};

export type UpdateParticipantInput = {
  readonly ageGroup: InputMaybe<Scalars['String']['input']>;
  readonly code: InputMaybe<Scalars['String']['input']>;
  readonly departmentId: InputMaybe<Scalars['ID']['input']>;
  readonly gender: InputMaybe<Scalars['String']['input']>;
  readonly location: InputMaybe<Scalars['String']['input']>;
  readonly seniority: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantPayload = {
  readonly __typename?: 'UpdateParticipantPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly participant: Maybe<EmployeeSurveysParticipant>;
};

export type UpdatePersonPayload = {
  readonly __typename?: 'UpdatePersonPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly person: Maybe<Person>;
};

export type UpdateTierAbilityAttributePayload = {
  readonly __typename?: 'UpdateTierAbilityAttributePayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly tierAbility: Maybe<TierAbility>;
};

export type User = {
  readonly __typename?: 'User';
  readonly id: Scalars['ID']['output'];
  readonly organisation: Maybe<Organisation>;
  readonly username: Scalars['String']['output'];
};

export type UserAddress = {
  readonly __typename?: 'UserAddress';
  readonly city: Scalars['String']['output'];
  readonly countryCode: Maybe<Scalars['String']['output']>;
  readonly displayName: Scalars['String']['output'];
  readonly domainIds: ReadonlyArray<Scalars['Int']['output']>;
  readonly federalState: Maybe<FederalState>;
  readonly fullDisplayName: Scalars['String']['output'];
  readonly hidden: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['Int']['output'];
  readonly latitude: Maybe<Scalars['Float']['output']>;
  readonly location: Maybe<Scalars['String']['output']>;
  readonly longitude: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use city instead */
  readonly ort: Scalars['String']['output'];
  readonly postcode: Maybe<Scalars['String']['output']>;
  readonly publicPhone: Maybe<Scalars['String']['output']>;
  readonly region: Maybe<Scalars['String']['output']>;
  readonly shortName: Scalars['String']['output'];
  readonly street: Maybe<Scalars['String']['output']>;
  readonly streetNumber: Maybe<Scalars['String']['output']>;
  readonly streetWithNumber: Maybe<Scalars['String']['output']>;
  readonly subprofiles: ReadonlyArray<Subprofile>;
};

export type UserEvent = {
  readonly __typename?: 'UserEvent';
  readonly date: Scalars['ISO8601DateTime']['output'];
  readonly effective: Maybe<Scalars['Boolean']['output']>;
  readonly event: UserEventEventEnum;
  readonly eventTranslated: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
};

export const enum UserEventEventEnum {
  CtGastgeber = 'ct_gastgeber',
  CtPresentation = 'ct_presentation',
  CtTeilgenommen = 'ct_teilgenommen',
  MittlrInvited = 'mittlr_invited',
  MysteryApplicantFailed = 'mystery_applicant_failed',
  MysteryApplicantPassed = 'mystery_applicant_passed',
  PartnerGewonnen = 'partner_gewonnen',
  Review = 'review'
};

export type ValidationErrors = {
  readonly __typename?: 'ValidationErrors';
  readonly field: Scalars['String']['output'];
  readonly message: Scalars['String']['output'];
};

export type VideoPayload = {
  readonly __typename?: 'VideoPayload';
  readonly errors: ReadonlyArray<ValidationErrors>;
  readonly video: Maybe<Scalars['String']['output']>;
};

export type ChangeTierLevelMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  toTier: Scalars['String']['input'];
}>;


export type ChangeTierLevelMutation = { readonly __typename?: 'Mutation', readonly changeTierLevel: { readonly __typename?: 'ChangeTierLevelPayload', readonly success: boolean, readonly errors: ReadonlyArray<string>, readonly tier: { readonly __typename?: 'TierAbility', readonly id: string, readonly tierLevel: string, readonly currentAbilitySince: any | null } | null } | null };

export type GetCmBubblePeopleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCmBubblePeopleQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly id: string, readonly organisation: { readonly __typename?: 'Organisation', readonly id: string, readonly people: ReadonlyArray<{ readonly __typename?: 'Person', readonly id: string, readonly telephone: string | null, readonly email: string | null, readonly name: string | null }> } | null } | null };

export type GetDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDomainsQuery = { readonly __typename?: 'Query', readonly domains: ReadonlyArray<{ readonly __typename?: 'DomainBase', readonly id: string, readonly name: string | null, readonly linkColor: string | null, readonly logo: string }> };

export type UpdateDashboardLayoutMutationVariables = Exact<{
  input: DashboardLayoutAttributes;
}>;


export type UpdateDashboardLayoutMutation = { readonly __typename?: 'Mutation', readonly updateDashboardLayout: { readonly __typename?: 'UpdateLayoutPayload', readonly layout: { readonly __typename?: 'DashboardLayout', readonly faved: ReadonlyArray<string> | null, readonly collapsed: ReadonlyArray<string> | null } | null } | null };

export type FkCreateMetascoreProfileMutationVariables = Exact<{
  source: Scalars['String']['input'];
  url: Scalars['String']['input'];
  ratingValue: InputMaybe<Scalars['Float']['input']>;
  reviewCount: InputMaybe<Scalars['Int']['input']>;
}>;


export type FkCreateMetascoreProfileMutation = { readonly __typename?: 'Mutation', readonly fkCreateMetascoreProfile: { readonly __typename?: 'MutationFKMutations', readonly createMetascoreProfile: { readonly __typename?: 'CreateMetascoreProfilePayload', readonly metascoreProfile: { readonly __typename?: 'FKMetascoreProfile', readonly id: string, readonly source: string, readonly url: string | null, readonly ratingValue: number | null, readonly bestRating: number | null, readonly reviewCount: number | null, readonly status: string, readonly lastRetrievedAt: any | null } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null } };

export type FkDeleteMetascoreProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FkDeleteMetascoreProfileMutation = { readonly __typename?: 'Mutation', readonly fkDeleteMetascoreProfile: { readonly __typename?: 'MutationFKMutations', readonly deleteMetascoreProfile: { readonly __typename?: 'DeleteMetascoreProfilePayload', readonly success: boolean, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null } };

export type FkUpdateMetascoreProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  url: InputMaybe<Scalars['String']['input']>;
  ratingValue: InputMaybe<Scalars['Float']['input']>;
  reviewCount: InputMaybe<Scalars['Int']['input']>;
  refresh: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FkUpdateMetascoreProfileMutation = { readonly __typename?: 'Mutation', readonly fkUpdateMetascoreProfile: { readonly __typename?: 'MutationFKMutations', readonly updateMetascoreProfile: { readonly __typename?: 'UpdateMetascoreProfilePayload', readonly metascoreProfile: { readonly __typename?: 'FKMetascoreProfile', readonly id: string, readonly source: string, readonly url: string | null, readonly ratingValue: number | null, readonly bestRating: number | null, readonly reviewCount: number | null, readonly status: string, readonly lastRetrievedAt: any | null } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null } };

export type FkUpdateOrganisationSettingMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
}>;


export type FkUpdateOrganisationSettingMutation = { readonly __typename?: 'Mutation', readonly fkUpdateOrganisationSetting: { readonly __typename?: 'MutationFKMutations', readonly updateOrganisationSetting: { readonly __typename?: 'UpdateOrganisationSettingPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly fkOrganisationSetting: { readonly __typename?: 'FKOrganisationSetting', readonly quote: string | null, readonly quoteAuthor: string | null, readonly feedbackActive: boolean, readonly separateSites: boolean, readonly doesNotTakePartInFeedbackProcess: boolean } | null } | null } };

export type GenerateRejectionFeedbackQueryVariables = Exact<{
  questionDe: Scalars['String']['input'];
  questionEn: Scalars['String']['input'];
  answers: Scalars['JSON']['input'];
}>;


export type GenerateRejectionFeedbackQuery = { readonly __typename?: 'Query', readonly generateRejectionFeedback: { readonly __typename?: 'TranslatedTextResult', readonly de: string | null, readonly en: string | null } | null };

export type GetApplyStatisticsQueryVariables = Exact<{
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
}>;


export type GetApplyStatisticsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly bmsActivationLevel: string, readonly bmsActive: boolean, readonly bmsApplicationRouting: OrganisationBmsApplicationRoutingEnum, readonly coworkrActive: boolean | null, readonly hasBms: boolean, readonly currentTierAbility: { readonly __typename?: 'TierAbility', readonly tierLevelKey: string } | null, readonly jobStatistics: ReadonlyArray<{ readonly __typename?: 'StatisticApply', readonly id: string, readonly applicationCount: number | null, readonly applicationCoworkrCount: number | null, readonly applicationRecommendedCount: number | null, readonly applicationUnsolicitedCount: number | null, readonly applicationWidgetCount: number | null, readonly clicksCount: number | null, readonly impressionsCount: number | null, readonly computedApplicationEmpfehlungsbundCount: number | null, readonly computedApplicationTotalCount: number | null, readonly computedHiredEmpfehlungsbundCount: number | null, readonly computedHiredTotalCount: number | null, readonly estimatedApplicationEmpfehlungsbundCount: number | null, readonly estimatedApplicationTotalCount: number | null, readonly estimatedHiredEmpfehlungsbundCount: number | null, readonly estimatedHiredTotalCount: number | null, readonly createdAt: any, readonly date: any | null, readonly internCount: number | null, readonly isEditable: boolean, readonly isUntouched: boolean, readonly jobsCount: number | null, readonly month: number | null, readonly smartclicks: number | null, readonly smartclicksCompliant: boolean | null, readonly smartclicksPerApplications: number | null, readonly usedCodesCount: number | null, readonly userApplicationEmpfehlungsbundCount: number | null, readonly userApplicationTotalCount: number | null, readonly userHiredEmpfehlungsbundCount: number | null, readonly userHiredTotalCount: number | null, readonly widgetClicks: number | null, readonly year: number | null, readonly coworkrClicks: number | null, readonly shouldWarnMissingData: boolean }> } | null } | null };

export type GetAppointmentReviewModalDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppointmentReviewModalDataQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly communityManager: { readonly __typename?: 'CommunityManager', readonly id: string, readonly image: string | null, readonly teamsBookingsUrl: string | null, readonly telephone: string | null, readonly email: string, readonly name: { readonly __typename?: 'CommunityManagerName', readonly displayName: string } }, readonly people: ReadonlyArray<{ readonly __typename?: 'Person', readonly displayName: string | null, readonly telephone: string | null }>, readonly addresses: ReadonlyArray<{ readonly __typename?: 'UserAddress', readonly displayName: string, readonly hidden: boolean | null }> } | null } | null };

export type GetGlobalProfileInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalProfileInfoQuery = { readonly __typename?: 'Query', readonly allRewards: ReadonlyArray<{ readonly __typename?: 'Reward', readonly id: string, readonly logo: string, readonly description: string, readonly userLinkOptional: boolean, readonly name: string, readonly year: string | null }>, readonly allCompetences: ReadonlyArray<{ readonly __typename?: 'Competence', readonly id: string, readonly mainWord: string, readonly keywords: ReadonlyArray<string>, readonly portalTypes: ReadonlyArray<{ readonly __typename?: 'PortalType', readonly id: string, readonly name: string }> | null }>, readonly allSectors: ReadonlyArray<{ readonly __typename?: 'Sector', readonly id: string, readonly name: string | null, readonly description: string | null }>, readonly domains: ReadonlyArray<{ readonly __typename?: 'DomainBase', readonly id: string, readonly name: string | null, readonly linkColor: string | null, readonly logo: string }>, readonly allPortalTypes: ReadonlyArray<{ readonly __typename?: 'PortalType', readonly id: string, readonly name: string, readonly tagline: string | null, readonly upcase: string }> };

export type GetOrganisationApplicantServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationApplicantServicesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly people: ReadonlyArray<{ readonly __typename?: 'Person', readonly displayName: string | null, readonly id: string }>, readonly applicantService: { readonly __typename?: 'OrganisationApplicantService', readonly bureaucracyService: boolean | null, readonly bureaucracyServiceDescriptionEn: string | null, readonly bureaucracyServiceDescriptionDe: string | null, readonly companyLanguages: ReadonlyArray<string> | null, readonly companyLanguagesDescriptionEn: string | null, readonly companyLanguagesDescriptionDe: string | null, readonly familyService: boolean | null, readonly familyServiceDescriptionEn: string | null, readonly familyServiceDescriptionDe: string | null, readonly germanEducation: boolean | null, readonly germanEducationDescriptionEn: string | null, readonly germanEducationDescriptionDe: string | null, readonly housingService: boolean | null, readonly housingServiceDescriptionEn: string | null, readonly housingServiceDescriptionDe: string | null, readonly id: string | null, readonly personId: number | null, readonly recognitionService: boolean | null, readonly recognitionServiceDescriptionEn: string | null, readonly recognitionServiceDescriptionDe: string | null, readonly socialService: boolean | null, readonly socialServiceDescriptionEn: string | null, readonly socialServiceDescriptionDe: string | null, readonly videoUsed: boolean | null, readonly videoUsedDescriptionEn: string | null, readonly videoUsedDescriptionDe: string | null, readonly visaService: boolean | null, readonly visaServiceDescriptionEn: string | null, readonly visaServiceDescriptionDe: string | null, readonly visitPossible: boolean | null, readonly visitPossibleDescriptionEn: string | null, readonly visitPossibleDescriptionDe: string | null } } | null } | null };

export type GetOrganisationApplyOptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationApplyOptionQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly externalBmsHandling: OrganisationExternalBmsHandlingEnum, readonly bmsActivationLevel: string, readonly hasApplicationMethod: boolean, readonly applicationQuestions: ReadonlyArray<{ readonly __typename?: 'ApplicationQuestion', readonly organisationId: string | null, readonly questionDe: string | null, readonly id: string, readonly answerType: JobsApplicationQuestionAnswerTypeEnum | null, readonly visibleByWatchers: boolean, readonly questionEn: string | null, readonly answers: any | null, readonly remoteId: string | null, readonly screenerEnabled: boolean, readonly screenerRejectionFeedbackDe: string | null, readonly screenerRejectionFeedbackEn: string | null }>, readonly applyOption: { readonly __typename?: 'OrganisationApplyOption', readonly id: string, readonly files: ApplyOptionEnabledEnum, readonly gender: ApplyOptionEnabledEnum, readonly lastName: ApplyOptionEnabledEnum, readonly firstName: ApplyOptionEnabledEnum, readonly telephone: ApplyOptionEnabledEnum, readonly applicationQuestionIds: ReadonlyArray<number>, readonly postalAddress: ApplyOptionEnabledEnum, readonly requiredDocumentsDe: string | null, readonly requiredDocumentsEn: string | null, readonly screenerActive: boolean, readonly screenerKeepForDays: number | null, readonly screenerTemplateDe: string | null, readonly screenerTemplateEn: string | null, readonly ebmsScreenerEnabled: boolean, readonly jobsWithDifferentApplicationQuestions: ReadonlyArray<{ readonly __typename?: 'JobsManualJob', readonly id: string, readonly title: string | null, readonly applicationQuestions: ReadonlyArray<{ readonly __typename?: 'ApplicationQuestion', readonly id: string, readonly questionDe: string | null }> }> } } | null } | null };

export type OrganisationGetEmployeeCountQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationGetEmployeeCountQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly lastEmployeeStatistic: { readonly __typename?: 'EmployeeStatistic', readonly employeeCount: number | null, readonly employeeCountForBilling: number | null, readonly canUpdate: boolean, readonly hasBillingCount: boolean, readonly createdAt: any | null } } | null } | null };

export type GetOrganisationForCertificateGeneratorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationForCertificateGeneratorQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly id: string, readonly organisation: { readonly __typename?: 'Organisation', readonly id: string, readonly name: string | null, readonly mainUserAddressId: string | null, readonly addresses: ReadonlyArray<{ readonly __typename?: 'UserAddress', readonly id: number, readonly location: string | null }>, readonly recommendationReceivers: ReadonlyArray<{ readonly __typename?: 'RecommendationReceiver', readonly id: string, readonly name: string, readonly email: string, readonly createdAt: any }> | null, readonly empfehlungscodes: ReadonlyArray<{ readonly __typename?: 'Empfehlungscode', readonly id: string, readonly code: string, readonly title: string | null }> | null, readonly people: ReadonlyArray<{ readonly __typename?: 'Person', readonly id: string, readonly displayName: string | null, readonly email: string | null, readonly name: { readonly __typename?: 'Name', readonly title: string | null, readonly firstName: string | null, readonly lastName: string | null } | null }>, readonly domains: ReadonlyArray<{ readonly __typename?: 'DomainBase', readonly id: string, readonly name: string | null, readonly url: string, readonly accentColor: string | null, readonly logo: string }> | null } | null } | null };

export type OrganisationKarmaHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationKarmaHistoryQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly karmaHistory: ReadonlyArray<any>, readonly smartlinkFeedbackEntries: ReadonlyArray<{ readonly __typename?: 'SmartlinkFeedbackEntry', readonly id: string, readonly status: string, readonly createdAt: any, readonly date: any | null, readonly severity: string | null, readonly title: string | null, readonly recipients: ReadonlyArray<string> | null }> } | null } | null };

export type GetOrganisationNewsfeedStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationNewsfeedStatusQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly newsfeed: { readonly __typename?: 'OrganisationNewsfeed', readonly url: string, readonly status: OrganisationNewsfeedStatusEnum | null, readonly error: string | null, readonly lastRefresh: any | null, readonly items: ReadonlyArray<{ readonly __typename?: 'OrganisationNewsfeedItem', readonly title: string, readonly link: string | null, readonly localPostImagePath: string | null, readonly publishedAt: any | null }> } | null } | null } | null };

export type OrganisationGetPortalTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationGetPortalTypesQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly portalTypes: ReadonlyArray<{ readonly __typename?: 'PortalType', readonly id: string, readonly name: string, readonly tagline: string | null, readonly upcase: string }> | null } | null } | null };

export type CreateJobMutationVariables = Exact<{
  input: CreateJobInput;
}>;


export type CreateJobMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'CreateJobPayload', readonly manualJob: { readonly __typename?: 'JobsManualJob', readonly id: string } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type CreateOrganisationAddressMutationVariables = Exact<{
  input: OrganisationAddressAttributes;
}>;


export type CreateOrganisationAddressMutation = { readonly __typename?: 'Mutation', readonly createOrganisationAddress: { readonly __typename?: 'CreateOrganisationAddressPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly organisationAddress: { readonly __typename?: 'UserAddress', readonly id: number, readonly displayName: string, readonly fullDisplayName: string, readonly domainIds: ReadonlyArray<number>, readonly latitude: number | null, readonly longitude: number | null, readonly ort: string, readonly subprofiles: ReadonlyArray<{ readonly __typename?: 'Subprofile', readonly id: string }> } | null } | null };

export type DeleteJobMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteJobMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'DeleteJobPayload', readonly manualJob: { readonly __typename?: 'JobsManualJob', readonly id: string } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type GetAllCompetencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCompetencesQuery = { readonly __typename?: 'Query', readonly allCompetences: ReadonlyArray<{ readonly __typename?: 'Competence', readonly id: string, readonly mainWord: string, readonly portalTypes: ReadonlyArray<{ readonly __typename?: 'PortalType', readonly id: string, readonly name: string }> | null, readonly words: ReadonlyArray<{ readonly __typename?: 'CompetenceWord', readonly id: string, readonly main: string, readonly keywords: ReadonlyArray<string>, readonly competenceTypes: ReadonlyArray<CompetenceCategory> }> }> };

export type GetCompetenceInfoQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type GetCompetenceInfoQuery = { readonly __typename?: 'Query', readonly competenceInfo: { readonly __typename?: 'JobsCompetenceInfo', readonly id: string, readonly jobId: string, readonly deactivatedCompetences: ReadonlyArray<string>, readonly userCompetenceWords: ReadonlyArray<{ readonly __typename?: 'CompetenceWord', readonly id: string, readonly main: string }>, readonly automaticCompetenceWords: ReadonlyArray<{ readonly __typename?: 'CompetenceWord', readonly id: string, readonly main: string, readonly competenceTypes: ReadonlyArray<CompetenceCategory> }> } | null };

export type GetJobFormDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobFormDataQuery = { readonly __typename?: 'Query', readonly tarifvertraege: ReadonlyArray<{ readonly __typename?: 'Tarifvertrag', readonly id: string, readonly name: string, readonly year: number, readonly tarifvertragSalaryEntries: ReadonlyArray<{ readonly __typename?: 'TarifvertragEntry', readonly id: string, readonly salary: number, readonly salaryGroup: string, readonly level: string }> }>, readonly domains: ReadonlyArray<{ readonly __typename?: 'DomainBase', readonly id: string, readonly name: string | null, readonly filterTags: ReadonlyArray<string>, readonly logo: string, readonly linkColor: string | null, readonly hostname: string | null, readonly bereich: string | null, readonly cities: string | null, readonly importLocations: ReadonlyArray<string> | null, readonly region: string | null }>, readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly benefitIds: ReadonlyArray<number> | null, readonly applyBenefitsToAllJobs: boolean, readonly hasBms: boolean, readonly widgetNotUsed: boolean | null, readonly jobgptAccess: boolean, readonly widgetEmbeddedOnCareerPage: boolean | null, readonly applicationEntryMail: string | null, readonly bmsActive: boolean, readonly jobwertActive: boolean | null, readonly careerPageUrl: string | null, readonly careerPageUrlEn: string | null, readonly bmsUrl: string | null, readonly remoteIdEnabled: boolean, readonly externalJobboardParticipations: ReadonlyArray<{ readonly __typename?: 'ExternalJobboardParticipation', readonly id: string, readonly title: string, readonly description: string | null, readonly active: boolean, readonly logoPath: string, readonly iconPath: string }>, readonly applicantService: { readonly __typename?: 'OrganisationApplicantService', readonly bureaucracyService: boolean | null, readonly companyLanguages: ReadonlyArray<string> | null, readonly familyService: boolean | null, readonly germanEducation: boolean | null, readonly housingService: boolean | null, readonly recognitionService: boolean | null, readonly socialService: boolean | null, readonly videoUsed: boolean | null, readonly visaService: boolean | null, readonly visitPossible: boolean | null }, readonly applyOption: { readonly __typename?: 'OrganisationApplyOption', readonly screenerActive: boolean, readonly applicationQuestionIds: ReadonlyArray<number> }, readonly bmsTeams: ReadonlyArray<{ readonly __typename?: 'BmsTeam', readonly id: string, readonly name: string }>, readonly bmsRecruiterIdentities: ReadonlyArray<{ readonly __typename?: 'BmsShortIdentity', readonly fullName: string, readonly email: string }>, readonly people: ReadonlyArray<{ readonly __typename?: 'Person', readonly displayName: string | null, readonly id: string, readonly email: string | null, readonly publicEmail: string | null, readonly roleJobs: boolean | null, readonly photo: string | null, readonly domainIds: ReadonlyArray<number>, readonly subprofileId: number | null, readonly name: { readonly __typename?: 'Name', readonly lastName: string | null, readonly firstName: string | null } | null }>, readonly subprofiles: ReadonlyArray<{ readonly __typename?: 'Subprofile', readonly id: string, readonly name: string }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'Membership', readonly domain: { readonly __typename?: 'DomainBase', readonly id: string, readonly name: string | null, readonly logo: string, readonly filterTags: ReadonlyArray<string>, readonly portalType: { readonly __typename?: 'PortalType', readonly name: string } } }> | null, readonly addresses: ReadonlyArray<{ readonly __typename?: 'UserAddress', readonly id: number, readonly displayName: string, readonly fullDisplayName: string, readonly domainIds: ReadonlyArray<number>, readonly latitude: number | null, readonly longitude: number | null, readonly ort: string, readonly subprofiles: ReadonlyArray<{ readonly __typename?: 'Subprofile', readonly id: string }> }> } | null } | null };

export type GetKeywordInfoQueryVariables = Exact<{
  masterJobId: Scalars['ID']['input'];
}>;


export type GetKeywordInfoQuery = { readonly __typename?: 'Query', readonly keywordInfo: { readonly __typename?: 'JobsKeywordInfo', readonly id: string, readonly suggestRunAt: any | null, readonly suggestDisabled: boolean, readonly visibleKeywords: ReadonlyArray<string>, readonly maxKeywordCount: number, readonly minKeywordCount: number, readonly feedType: string | null, readonly userKeywordsStrong: boolean, readonly userKeywordsEnough: boolean, readonly masterJobId: string, readonly addSuggestions: boolean, readonly userKeywords: ReadonlyArray<{ readonly __typename?: 'JobsUserKeyword', readonly name: string, readonly position: number, readonly searchCount: number | null, readonly searchLevel: number | null }>, readonly keywordSuggestions: ReadonlyArray<{ readonly __typename?: 'JobsKeywordSuggestion', readonly id: string, readonly searchCount: number, readonly searchLevel: number | null, readonly name: string, readonly source: string, readonly keywordResultId: string | null, readonly hiddenByUser: boolean }>, readonly addedSuggestions: ReadonlyArray<{ readonly __typename?: 'JobsKeywordSuggestion', readonly id: string, readonly searchCount: number, readonly searchLevel: number | null, readonly name: string, readonly source: string, readonly keywordResultId: string | null, readonly hiddenByUser: boolean }> } | null };

export type GetKeywordSuggestionsQueryVariables = Exact<{
  source: InputMaybe<Scalars['String']['input']>;
  masterJobId: Scalars['ID']['input'];
}>;


export type GetKeywordSuggestionsQuery = { readonly __typename?: 'Query', readonly keywordSuggestions: ReadonlyArray<{ readonly __typename?: 'JobsKeywordSuggestion', readonly id: string, readonly name: string, readonly searchCount: number, readonly hiddenByUser: boolean }> };

export type PreviewJobMutationVariables = Exact<{
  input: PreviewJobInput;
  id: Scalars['Int']['input'];
}>;


export type PreviewJobMutation = { readonly __typename?: 'Mutation', readonly previewJob: { readonly __typename?: 'PreviewJobPayload', readonly html: string | null } | null };

export type UpdateJobMutationVariables = Exact<{
  input: UpdateJobInput;
  id: Scalars['Int']['input'];
}>;


export type UpdateJobMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'UpdateJobPayload', readonly manualJob: { readonly __typename?: 'JobsManualJob', readonly id: string } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type GptJobFragment = { readonly __typename?: 'JobGptJob', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly positionTitle: string | null, readonly educationRequirements: string | null, readonly specialCompetencies: string | null, readonly additionalAttributes: string | null, readonly jobType: string | null, readonly seniority: string | null, readonly locations: ReadonlyArray<string> | null, readonly sectors: ReadonlyArray<string> | null, readonly keywordsEducation: ReadonlyArray<string> | null, readonly keywordsCompetences: ReadonlyArray<string> | null, readonly keywordsJobDescription: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly salary: string | null, readonly title: string | null, readonly firstParagraph: string | null, readonly jobDescription: string | null, readonly userCompletedJobInputTaskAt: any | null, readonly userCompletedJobInformationTaskAt: any | null, readonly userCompletedJobKeywordsTaskAt: any | null, readonly userCompletedJobTitlesTaskAt: any | null, readonly userCompletedJobFirstParagraphTaskAt: any | null, readonly userCompletedJobDescriptionTaskAt: any | null, readonly userCompletedJobFromUrlTaskAt: any | null, readonly gptMode: string | null, readonly meta: any | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null, readonly size: number | null }> | null };

export type JobGptResetMutationVariables = Exact<{
  gptObjectId: Scalars['ID']['input'];
  gptObjectType: Scalars['String']['input'];
}>;


export type JobGptResetMutation = { readonly __typename?: 'Mutation', readonly jobGptReset: { readonly __typename?: 'JobGptResetPayload', readonly gpt: { readonly __typename: 'JobGptJob', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly positionTitle: string | null, readonly educationRequirements: string | null, readonly specialCompetencies: string | null, readonly additionalAttributes: string | null, readonly jobType: string | null, readonly seniority: string | null, readonly locations: ReadonlyArray<string> | null, readonly sectors: ReadonlyArray<string> | null, readonly keywordsEducation: ReadonlyArray<string> | null, readonly keywordsCompetences: ReadonlyArray<string> | null, readonly keywordsJobDescription: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly salary: string | null, readonly title: string | null, readonly firstParagraph: string | null, readonly jobDescription: string | null, readonly userCompletedJobInputTaskAt: any | null, readonly userCompletedJobInformationTaskAt: any | null, readonly userCompletedJobKeywordsTaskAt: any | null, readonly userCompletedJobTitlesTaskAt: any | null, readonly userCompletedJobFirstParagraphTaskAt: any | null, readonly userCompletedJobDescriptionTaskAt: any | null, readonly userCompletedJobFromUrlTaskAt: any | null, readonly gptMode: string | null, readonly meta: any | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null, readonly size: number | null }> | null } | { readonly __typename: 'JobGptOrganisation', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly inputDescription: string | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null }> | null } | { readonly __typename: 'JobGptVariant', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly title: string | null, readonly keywords: ReadonlyArray<string> | null, readonly jobDescription: string | null, readonly userInputs: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly refineTitle: boolean | null, readonly refineKeywords: boolean | null, readonly refineFirstParagraph: boolean | null, readonly refineDescription: boolean | null, readonly userCompletedVariantInputTaskAt: any | null, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> } | { readonly __typename: 'JobGptVariantMultiStep', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly masterFirstParagraph: string | null, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly selectedFields: ReadonlyArray<string> | null, readonly selectedTitle: string | null, readonly userCompletedVariantTitleTaskAt: any | null, readonly generatedFirstParagraph: string | null, readonly masterDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantFirstParagraphTaskAt: any | null, readonly generatedJobDescription: string | null, readonly generatedJobDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantJobDescriptionTaskAt: any | null, readonly generatedKeywords: ReadonlyArray<string> | null, readonly userCompletedVariantKeywordsTaskAt: any | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly organisationDescription: string | null, readonly organisationCareerPageUrl: string | null, readonly sectors: ReadonlyArray<string> | null, readonly salary: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> } } | null };

export type JobGptResetTaskMutationVariables = Exact<{
  gptObjectId: Scalars['ID']['input'];
  gptObjectType: Scalars['String']['input'];
  taskKey: Scalars['String']['input'];
}>;


export type JobGptResetTaskMutation = { readonly __typename?: 'Mutation', readonly jobGptResetTask: { readonly __typename?: 'JobGptResetTaskPayload', readonly gpt: { readonly __typename: 'JobGptJob', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly positionTitle: string | null, readonly educationRequirements: string | null, readonly specialCompetencies: string | null, readonly additionalAttributes: string | null, readonly jobType: string | null, readonly seniority: string | null, readonly locations: ReadonlyArray<string> | null, readonly sectors: ReadonlyArray<string> | null, readonly keywordsEducation: ReadonlyArray<string> | null, readonly keywordsCompetences: ReadonlyArray<string> | null, readonly keywordsJobDescription: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly salary: string | null, readonly title: string | null, readonly firstParagraph: string | null, readonly jobDescription: string | null, readonly userCompletedJobInputTaskAt: any | null, readonly userCompletedJobInformationTaskAt: any | null, readonly userCompletedJobKeywordsTaskAt: any | null, readonly userCompletedJobTitlesTaskAt: any | null, readonly userCompletedJobFirstParagraphTaskAt: any | null, readonly userCompletedJobDescriptionTaskAt: any | null, readonly userCompletedJobFromUrlTaskAt: any | null, readonly gptMode: string | null, readonly meta: any | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null, readonly size: number | null }> | null } | { readonly __typename: 'JobGptOrganisation', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly inputDescription: string | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null }> | null } | { readonly __typename: 'JobGptVariant', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly title: string | null, readonly keywords: ReadonlyArray<string> | null, readonly jobDescription: string | null, readonly userInputs: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly refineTitle: boolean | null, readonly refineKeywords: boolean | null, readonly refineFirstParagraph: boolean | null, readonly refineDescription: boolean | null, readonly userCompletedVariantInputTaskAt: any | null, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> } | { readonly __typename: 'JobGptVariantMultiStep', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly masterFirstParagraph: string | null, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly selectedFields: ReadonlyArray<string> | null, readonly selectedTitle: string | null, readonly userCompletedVariantTitleTaskAt: any | null, readonly generatedFirstParagraph: string | null, readonly masterDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantFirstParagraphTaskAt: any | null, readonly generatedJobDescription: string | null, readonly generatedJobDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantJobDescriptionTaskAt: any | null, readonly generatedKeywords: ReadonlyArray<string> | null, readonly userCompletedVariantKeywordsTaskAt: any | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly organisationDescription: string | null, readonly organisationCareerPageUrl: string | null, readonly sectors: ReadonlyArray<string> | null, readonly salary: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> } } | null };

export type GptOrganisationFragment = { readonly __typename?: 'JobGptOrganisation', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly inputDescription: string | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null }> | null };

export type GptTaskFragment = { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null };

export type GptTaskRunFragment = { readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null };

export type GptVariantFragment = { readonly __typename?: 'JobGptVariant', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly title: string | null, readonly keywords: ReadonlyArray<string> | null, readonly jobDescription: string | null, readonly userInputs: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly refineTitle: boolean | null, readonly refineKeywords: boolean | null, readonly refineFirstParagraph: boolean | null, readonly refineDescription: boolean | null, readonly userCompletedVariantInputTaskAt: any | null, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> };

export type GptVariantMultiStepFragment = { readonly __typename?: 'JobGptVariantMultiStep', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly masterFirstParagraph: string | null, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly selectedFields: ReadonlyArray<string> | null, readonly selectedTitle: string | null, readonly userCompletedVariantTitleTaskAt: any | null, readonly generatedFirstParagraph: string | null, readonly masterDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantFirstParagraphTaskAt: any | null, readonly generatedJobDescription: string | null, readonly generatedJobDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantJobDescriptionTaskAt: any | null, readonly generatedKeywords: ReadonlyArray<string> | null, readonly userCompletedVariantKeywordsTaskAt: any | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly organisationDescription: string | null, readonly organisationCareerPageUrl: string | null, readonly sectors: ReadonlyArray<string> | null, readonly salary: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> };

export type GetGptObjectQueryVariables = Exact<{
  gptObjectId: Scalars['ID']['input'];
  gptObjectType: Scalars['String']['input'];
}>;


export type GetGptObjectQuery = { readonly __typename?: 'Query', readonly gptObject: { readonly __typename: 'JobGptJob', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly positionTitle: string | null, readonly educationRequirements: string | null, readonly specialCompetencies: string | null, readonly additionalAttributes: string | null, readonly jobType: string | null, readonly seniority: string | null, readonly locations: ReadonlyArray<string> | null, readonly sectors: ReadonlyArray<string> | null, readonly keywordsEducation: ReadonlyArray<string> | null, readonly keywordsCompetences: ReadonlyArray<string> | null, readonly keywordsJobDescription: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly salary: string | null, readonly title: string | null, readonly firstParagraph: string | null, readonly jobDescription: string | null, readonly userCompletedJobInputTaskAt: any | null, readonly userCompletedJobInformationTaskAt: any | null, readonly userCompletedJobKeywordsTaskAt: any | null, readonly userCompletedJobTitlesTaskAt: any | null, readonly userCompletedJobFirstParagraphTaskAt: any | null, readonly userCompletedJobDescriptionTaskAt: any | null, readonly userCompletedJobFromUrlTaskAt: any | null, readonly gptMode: string | null, readonly meta: any | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null, readonly size: number | null }> | null } | { readonly __typename: 'JobGptOrganisation', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly inputDescription: string | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null }> | null } | { readonly __typename: 'JobGptVariant', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly title: string | null, readonly keywords: ReadonlyArray<string> | null, readonly jobDescription: string | null, readonly userInputs: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly refineTitle: boolean | null, readonly refineKeywords: boolean | null, readonly refineFirstParagraph: boolean | null, readonly refineDescription: boolean | null, readonly userCompletedVariantInputTaskAt: any | null, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> } | { readonly __typename: 'JobGptVariantMultiStep', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly masterFirstParagraph: string | null, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly selectedFields: ReadonlyArray<string> | null, readonly selectedTitle: string | null, readonly userCompletedVariantTitleTaskAt: any | null, readonly generatedFirstParagraph: string | null, readonly masterDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantFirstParagraphTaskAt: any | null, readonly generatedJobDescription: string | null, readonly generatedJobDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantJobDescriptionTaskAt: any | null, readonly generatedKeywords: ReadonlyArray<string> | null, readonly userCompletedVariantKeywordsTaskAt: any | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly organisationDescription: string | null, readonly organisationCareerPageUrl: string | null, readonly sectors: ReadonlyArray<string> | null, readonly salary: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> } };

export type JobGptResetJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobGptResetJobMutation = { readonly __typename?: 'Mutation', readonly jobGptResetJob: { readonly __typename?: 'JobGptResetJobPayload', readonly gpt: { readonly __typename?: 'JobGptJob', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly positionTitle: string | null, readonly educationRequirements: string | null, readonly specialCompetencies: string | null, readonly additionalAttributes: string | null, readonly jobType: string | null, readonly seniority: string | null, readonly locations: ReadonlyArray<string> | null, readonly sectors: ReadonlyArray<string> | null, readonly keywordsEducation: ReadonlyArray<string> | null, readonly keywordsCompetences: ReadonlyArray<string> | null, readonly keywordsJobDescription: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly salary: string | null, readonly title: string | null, readonly firstParagraph: string | null, readonly jobDescription: string | null, readonly userCompletedJobInputTaskAt: any | null, readonly userCompletedJobInformationTaskAt: any | null, readonly userCompletedJobKeywordsTaskAt: any | null, readonly userCompletedJobTitlesTaskAt: any | null, readonly userCompletedJobFirstParagraphTaskAt: any | null, readonly userCompletedJobDescriptionTaskAt: any | null, readonly userCompletedJobFromUrlTaskAt: any | null, readonly gptMode: string | null, readonly meta: any | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null, readonly size: number | null }> | null } } | null };

export type JobGptRunTaskMutationVariables = Exact<{
  gptObjectId: Scalars['ID']['input'];
  gptObjectType: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
  userInputs: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type JobGptRunTaskMutation = { readonly __typename?: 'Mutation', readonly jobGptRunTask: { readonly __typename?: 'JobGptRunTaskPayload', readonly taskRun: { readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }, readonly gpt: { readonly __typename: 'JobGptJob', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly positionTitle: string | null, readonly educationRequirements: string | null, readonly specialCompetencies: string | null, readonly additionalAttributes: string | null, readonly jobType: string | null, readonly seniority: string | null, readonly locations: ReadonlyArray<string> | null, readonly sectors: ReadonlyArray<string> | null, readonly keywordsEducation: ReadonlyArray<string> | null, readonly keywordsCompetences: ReadonlyArray<string> | null, readonly keywordsJobDescription: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly salary: string | null, readonly title: string | null, readonly firstParagraph: string | null, readonly jobDescription: string | null, readonly userCompletedJobInputTaskAt: any | null, readonly userCompletedJobInformationTaskAt: any | null, readonly userCompletedJobKeywordsTaskAt: any | null, readonly userCompletedJobTitlesTaskAt: any | null, readonly userCompletedJobFirstParagraphTaskAt: any | null, readonly userCompletedJobDescriptionTaskAt: any | null, readonly userCompletedJobFromUrlTaskAt: any | null, readonly gptMode: string | null, readonly meta: any | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null, readonly size: number | null }> | null } | { readonly __typename: 'JobGptOrganisation', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly inputDescription: string | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null }> | null } | { readonly __typename: 'JobGptVariant', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly title: string | null, readonly keywords: ReadonlyArray<string> | null, readonly jobDescription: string | null, readonly userInputs: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly refineTitle: boolean | null, readonly refineKeywords: boolean | null, readonly refineFirstParagraph: boolean | null, readonly refineDescription: boolean | null, readonly userCompletedVariantInputTaskAt: any | null, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> } | { readonly __typename: 'JobGptVariantMultiStep', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly masterFirstParagraph: string | null, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly selectedFields: ReadonlyArray<string> | null, readonly selectedTitle: string | null, readonly userCompletedVariantTitleTaskAt: any | null, readonly generatedFirstParagraph: string | null, readonly masterDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantFirstParagraphTaskAt: any | null, readonly generatedJobDescription: string | null, readonly generatedJobDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantJobDescriptionTaskAt: any | null, readonly generatedKeywords: ReadonlyArray<string> | null, readonly userCompletedVariantKeywordsTaskAt: any | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly organisationDescription: string | null, readonly organisationCareerPageUrl: string | null, readonly sectors: ReadonlyArray<string> | null, readonly salary: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> } } | null };

export type JobGptSubmitFeedbackMutationVariables = Exact<{
  taskRunId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  text: InputMaybe<Scalars['String']['input']>;
}>;


export type JobGptSubmitFeedbackMutation = { readonly __typename?: 'Mutation', readonly jobGptSubmitFeedback: { readonly __typename?: 'JobGptSubmitFeedbackPayload', readonly success: boolean, readonly taskRun: { readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null } } | null };

export type JobGptUpdateJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: JobGptJobInput;
}>;


export type JobGptUpdateJobMutation = { readonly __typename?: 'Mutation', readonly jobGptUpdateJob: { readonly __typename?: 'JobGptUpdateJobPayload', readonly gpt: { readonly __typename?: 'JobGptJob', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly positionTitle: string | null, readonly educationRequirements: string | null, readonly specialCompetencies: string | null, readonly additionalAttributes: string | null, readonly jobType: string | null, readonly seniority: string | null, readonly locations: ReadonlyArray<string> | null, readonly sectors: ReadonlyArray<string> | null, readonly keywordsEducation: ReadonlyArray<string> | null, readonly keywordsCompetences: ReadonlyArray<string> | null, readonly keywordsJobDescription: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly salary: string | null, readonly title: string | null, readonly firstParagraph: string | null, readonly jobDescription: string | null, readonly userCompletedJobInputTaskAt: any | null, readonly userCompletedJobInformationTaskAt: any | null, readonly userCompletedJobKeywordsTaskAt: any | null, readonly userCompletedJobTitlesTaskAt: any | null, readonly userCompletedJobFirstParagraphTaskAt: any | null, readonly userCompletedJobDescriptionTaskAt: any | null, readonly userCompletedJobFromUrlTaskAt: any | null, readonly gptMode: string | null, readonly meta: any | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null, readonly size: number | null }> | null } } | null };

export type JobGptUpdateOrganisationMutationVariables = Exact<{
  input: JobGptOrganisationInput;
}>;


export type JobGptUpdateOrganisationMutation = { readonly __typename?: 'Mutation', readonly jobGptUpdateOrganisation: { readonly __typename?: 'JobGptUpdateOrganisationPayload', readonly gpt: { readonly __typename?: 'JobGptOrganisation', readonly id: string, readonly gptObjectType: string, readonly inputUrls: ReadonlyArray<string> | null, readonly inputDescription: string | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }>, readonly inputFiles: ReadonlyArray<{ readonly __typename?: 'JobGptFile', readonly id: string, readonly fileableType: string | null, readonly openaiFileId: string | null, readonly createdAt: any, readonly updatedAt: any, readonly url: string, readonly contentType: string | null, readonly name: string | null }> | null } } | null };

export type JobGptUpdateVariantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: JobGptVariantInput;
}>;


export type JobGptUpdateVariantMutation = { readonly __typename?: 'Mutation', readonly jobGptUpdateVariant: { readonly __typename?: 'JobGptUpdateVariantPayload', readonly gpt: { readonly __typename?: 'JobGptVariant', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly title: string | null, readonly keywords: ReadonlyArray<string> | null, readonly jobDescription: string | null, readonly userInputs: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly refineTitle: boolean | null, readonly refineKeywords: boolean | null, readonly refineFirstParagraph: boolean | null, readonly refineDescription: boolean | null, readonly userCompletedVariantInputTaskAt: any | null, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> } | null } | null };

export type JobGptUpdateVariantMultiStepMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: JobGptVariantMultiStepInput;
}>;


export type JobGptUpdateVariantMultiStepMutation = { readonly __typename?: 'Mutation', readonly jobGptUpdateVariantMultiStep: { readonly __typename?: 'JobGptUpdateVariantMultiStepPayload', readonly gpt: { readonly __typename?: 'JobGptVariantMultiStep', readonly id: string, readonly gptObjectType: string, readonly manualJobId: string | null, readonly organisationId: string, readonly masterTitle: string | null, readonly masterKeywords: ReadonlyArray<string> | null, readonly masterDescription: string | null, readonly masterFirstParagraph: string | null, readonly jobType: string | null, readonly homeofficeType: string | null, readonly locations: ReadonlyArray<string> | null, readonly benefits: ReadonlyArray<string> | null, readonly workConditions: ReadonlyArray<string> | null, readonly aiIntensity: number | null, readonly selectedFields: ReadonlyArray<string> | null, readonly selectedTitle: string | null, readonly userCompletedVariantTitleTaskAt: any | null, readonly generatedFirstParagraph: string | null, readonly masterDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantFirstParagraphTaskAt: any | null, readonly generatedJobDescription: string | null, readonly generatedJobDescriptionWithoutFirstParagraph: string | null, readonly userCompletedVariantJobDescriptionTaskAt: any | null, readonly generatedKeywords: ReadonlyArray<string> | null, readonly userCompletedVariantKeywordsTaskAt: any | null, readonly organisationName: string | null, readonly missionStatement: string | null, readonly numbersStatement: string | null, readonly organisationDescription: string | null, readonly organisationCareerPageUrl: string | null, readonly sectors: ReadonlyArray<string> | null, readonly salary: string | null, readonly seniorities: ReadonlyArray<string> | null, readonly tasks: ReadonlyArray<{ readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null }>, readonly runs: ReadonlyArray<{ readonly __typename?: 'JobGptTaskRun', readonly id: string, readonly taskId: string, readonly request: any | null, readonly response: any | null, readonly usage: any | null, readonly openaiResponse: any | null, readonly userInputs: any | null, readonly key: string | null, readonly label: string | null, readonly createdAt: any, readonly feedbackRating: number | null, readonly feedbackText: string | null, readonly feedbackAt: any | null, readonly hasFeedback: boolean, readonly task: { readonly __typename?: 'JobGptTask', readonly id: string, readonly key: string, readonly label: string, readonly prompt: string, readonly selectableGptAttributes: ReadonlyArray<string>, readonly userInputAttributes: ReadonlyArray<string>, readonly loadingTexts: ReadonlyArray<string>, readonly jobGptText: string | null } | null }> } | null } | null };

export type MatchingJobsForQuestionFilterQueryVariables = Exact<{
  filterKeywords: InputMaybe<Scalars['String']['input']>;
  filterLocations: InputMaybe<Scalars['String']['input']>;
  filterSubJobTypes: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MatchingJobsForQuestionFilterQuery = { readonly __typename?: 'Query', readonly matchingJobsForQuestionFilter: any };

export type OrganisationTourQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type OrganisationTourQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly tour: { readonly __typename?: 'Tour', readonly type: string, readonly items: ReadonlyArray<{ readonly __typename?: 'TourItem', readonly key: string, readonly title: string, readonly description: string | null, readonly attachTo: any }> } | null } | null } | null };

export type GetOrganisationNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationNotificationsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly hasSupport: boolean, readonly notifications: ReadonlyArray<{ readonly __typename?: 'Notification', readonly id: string, readonly identifier: string, readonly expiresAt: any | null, readonly createdAt: any, readonly message: string, readonly quickAction: any | null, readonly read: boolean, readonly sentAt: any, readonly severity: string, readonly subject: string, readonly personId: string | null }> } | null } | null };

export type OrganisationGetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationGetProfileQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly id: string, readonly username: string, readonly organisation: { readonly __typename?: 'Organisation', readonly id: string, readonly name: string | null, readonly logo: string | null, readonly logoDark: string | null, readonly description: string | null, readonly statement: string | null, readonly unsolicitedApplicationAllowed: boolean | null, readonly receivesNoMails: boolean | null, readonly subprofilesActive: boolean | null, readonly widgetNotUsed: boolean | null, readonly jobgptAccess: boolean, readonly widgetEmbeddedOnCareerPage: boolean | null, readonly hasBms: boolean, readonly jobIntegrationType: JobIntegration, readonly socialNetworkNames: any | null, readonly organizationType: OrganisationOrganizationTypeEnum | null, readonly bmsActivationLevel: string, readonly externalBmsHandling: OrganisationExternalBmsHandlingEnum, readonly baIgnored: boolean | null, readonly homeofficeByDefault: boolean, readonly indeedAtsActive: boolean | null, readonly employeeSurveysActive: boolean | null, readonly defaultLanguageLevelGerman: string | null, readonly subtitle: string | null, readonly sisaxProfileUrl: string | null, readonly personalforumMember: boolean | null, readonly showOnboarding: boolean | null, readonly talentsAccess: boolean, readonly showJobProgress: boolean | null, readonly warnEmailInJobDescription: boolean, readonly utmString: string | null, readonly ddfSponsor: boolean | null, readonly weight: number | null, readonly applicationMailType: OrganisationApplicationMailTypeEnum, readonly allowedHostsInJobs: string | null, readonly companyColor: string | null, readonly careerPageUrl: string | null, readonly bmsUrl: string | null, readonly applicationEntryMail: string | null, readonly pronoun: OrganisationPronounEnum, readonly newsfeedUrl: string | null, readonly feedimportActive: boolean | null, readonly anuLimited: boolean | null, readonly profileNotes: string | null, readonly euresExportBlocked: boolean, readonly hideRelatedJobs: boolean, readonly video: string | null, readonly baBranche: string | null, readonly mainUserAddressId: string | null, readonly applicationAddressId: string | null, readonly indeedAlias: string | null, readonly feedexportAlias: string | null, readonly feedexportActive: boolean | null, readonly linkedinExportEnabled: boolean | null, readonly linkedinCompanyId: string | null, readonly linkedinPostJobsToEbCompany: boolean | null, readonly descriptionPercentage: number | null, readonly aliasSuggestions: ReadonlyArray<string> | null, readonly hideKanaleoAward: boolean, readonly bmsActive: boolean, readonly jobwertActive: boolean | null, readonly fairekarriereActive: boolean | null, readonly coworkrActive: boolean | null, readonly userName: string, readonly applyBenefitsToAllJobs: boolean, readonly benefitIds: ReadonlyArray<number> | null, readonly descriptionEn: string | null, readonly statementEn: string | null, readonly hasApplicationMethod: boolean, readonly careerPageUrlEn: string | null, readonly bmsUrlEn: string | null, readonly userEvents: ReadonlyArray<{ readonly __typename?: 'UserEvent', readonly id: string, readonly eventTranslated: string, readonly event: UserEventEventEnum, readonly effective: boolean | null, readonly date: any }> | null, readonly rewardUsers: ReadonlyArray<{ readonly __typename?: 'RewardUser', readonly id: string, readonly link: string | null, readonly year: string | null, readonly reward: { readonly __typename?: 'Reward', readonly id: string, readonly description: string, readonly userLinkOptional: boolean, readonly name: string, readonly logo: string } }> | null, readonly portalTypes: ReadonlyArray<{ readonly __typename?: 'PortalType', readonly id: string, readonly name: string, readonly tagline: string | null, readonly upcase: string }> | null, readonly competences: ReadonlyArray<{ readonly __typename?: 'Competence', readonly id: string, readonly mainWord: string }> | null, readonly sectors: ReadonlyArray<{ readonly __typename?: 'Sector', readonly id: string, readonly name: string | null }> | null, readonly socialNetworks: ReadonlyArray<{ readonly __typename?: 'SocialNetwork', readonly id: string, readonly name: string | null, readonly url: string | null }> | null, readonly divisions: ReadonlyArray<{ readonly __typename?: 'JobsDivision', readonly id: string, readonly name: string, readonly nameEn: string | null }> | null, readonly logoQuality: { readonly __typename?: 'ImageQualityResult', readonly quality: number, readonly messages: ReadonlyArray<{ readonly __typename?: 'ImageQualityResultMessage', readonly name: string, readonly icon: string, readonly message: string | null, readonly quality: number }> } | null, readonly logoDarkQuality: { readonly __typename?: 'ImageQualityResult', readonly quality: number, readonly messages: ReadonlyArray<{ readonly __typename?: 'ImageQualityResultMessage', readonly name: string, readonly icon: string, readonly message: string | null, readonly quality: number }> } | null, readonly smartclickSetting: { readonly __typename?: 'SmartclickSetting', readonly feedimportMax: number | null, readonly ignore: boolean, readonly ignoreUntil: any | null, readonly statisticUnreliable: boolean, readonly comment: string | null, readonly communityManagerActivityBoost: number | null } | null, readonly communityQuote: { readonly __typename?: 'CommunityQuote', readonly id: string, readonly quote: string | null, readonly communityQuoteRelevance: CommunityQuoteCommunityQuoteRelevanceEnum | null, readonly quoteEn: string | null, readonly author: { readonly __typename?: 'Person', readonly id: string, readonly displayName: string | null, readonly photo: string | null } | null } | null, readonly people: ReadonlyArray<{ readonly __typename?: 'Person', readonly id: string, readonly displayName: string | null }>, readonly addresses: ReadonlyArray<{ readonly __typename?: 'UserAddress', readonly id: number, readonly displayName: string }>, readonly domains: ReadonlyArray<{ readonly __typename?: 'DomainBase', readonly id: string, readonly name: string | null, readonly logo: string, readonly favicon: string, readonly filterTags: ReadonlyArray<string>, readonly portalType: { readonly __typename?: 'PortalType', readonly name: string } }> | null, readonly memberships: ReadonlyArray<{ readonly __typename?: 'Membership', readonly id: number, readonly lastSuccessfulJobSyncAt: any | null, readonly lastSuccessfulProfileSyncAt: any | null, readonly domain: { readonly __typename?: 'DomainBase', readonly name: string | null, readonly logo: string, readonly portalType: { readonly __typename?: 'PortalType', readonly name: string } } }> | null } | null } | null };

export type OrganisationGetTierQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganisationGetTierQuery = { readonly __typename?: 'Query', readonly tier: { readonly __typename?: 'TierAbility', readonly id: string, readonly active: boolean, readonly tierLevel: string, readonly tierLevelKey: string, readonly currentAbilitySince: any | null, readonly bmsState: string, readonly coworkrState: string, readonly employeeSurveysState: string, readonly fairekarriereState: string, readonly jobwertState: string, readonly kanaleoState: string, readonly talentsState: string, readonly organisation: { readonly __typename?: 'Organisation', readonly id: string, readonly name: string | null }, readonly diff: ReadonlyArray<{ readonly __typename?: 'TierDiff', readonly key: string, readonly itemKey: string, readonly label: string, readonly current: string, readonly currentLabel: string, readonly default: string, readonly defaultLabel: string, readonly changed: boolean, readonly displayValue: string, readonly displayIcon: string, readonly displayClass: string, readonly hint: string | null }> | null, readonly events: ReadonlyArray<{ readonly __typename?: 'TierEvent', readonly id: string, readonly admin: string | null, readonly triggeredBy: string, readonly createdAt: any, readonly payload: any | null, readonly eventType: string, readonly eventTypeLabel: string, readonly fromAbility: { readonly __typename?: 'TierAbility', readonly id: string, readonly tierLevel: string } | null, readonly toAbility: { readonly __typename?: 'TierAbility', readonly id: string, readonly tierLevel: string } | null, readonly identity: { readonly __typename?: 'Identity', readonly id: string, readonly email: string } | null }> | null, readonly latestEvent: { readonly __typename?: 'TierEvent', readonly createdAt: any } | null } | null };

export type ActivateEbmsIdentityMutationVariables = Exact<{
  personId: Scalars['Int']['input'];
  ebmsIdentityType: Scalars['String']['input'];
}>;


export type ActivateEbmsIdentityMutation = { readonly __typename?: 'Mutation', readonly activateEbmsIdentity: { readonly __typename?: 'MutationPeopleMutations', readonly activateEbmsIdentity: { readonly __typename?: 'ActivateEbmsIdentityPayload', readonly person: { readonly __typename?: 'Person', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly identity: { readonly __typename?: 'Identity', readonly id: string, readonly hasEbmsIdentity: boolean } | null } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null } };

export type CreatePersonMutationVariables = Exact<{
  input: PersonFormInput;
}>;


export type CreatePersonMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'CreatePersonPayload', readonly person: { readonly __typename?: 'Person', readonly id: string } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type GetPeopleQueryVariables = Exact<{
  ids: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetPeopleQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly bmsActive: boolean, readonly memberships: ReadonlyArray<{ readonly __typename?: 'Membership', readonly id: number, readonly domain: { readonly __typename?: 'DomainBase', readonly name: string | null, readonly faviconUrl: string } }> | null, readonly people: ReadonlyArray<{ readonly __typename?: 'Person', readonly id: string, readonly position: string | null, readonly title: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly salutation: Salutation | null, readonly displayFormat: string | null, readonly sortPriority: number | null, readonly publicEmail: string | null, readonly email: string | null, readonly telephone: string | null, readonly xingUrl: string | null, readonly linkedinUrl: string | null, readonly officeId: number | null, readonly applicationAddressId: number | null, readonly subprofileId: number | null, readonly membershipIds: ReadonlyArray<number>, readonly photoUrl: string | null, readonly identity: { readonly __typename?: 'Identity', readonly id: string, readonly email: string, readonly verified: boolean, readonly lastLogin: any | null, readonly hasEbmsIdentity: boolean } | null, readonly communicationRoles: ReadonlyArray<{ readonly __typename?: 'PersonRole', readonly key: string, readonly title: string, readonly description: string | null, readonly short: string | null, readonly type: PersonRoleType, readonly validation: boolean, readonly validationText: string | null }>, readonly functionalRoles: ReadonlyArray<{ readonly __typename?: 'PersonRole', readonly key: string, readonly title: string, readonly description: string | null, readonly short: string | null, readonly type: PersonRoleType, readonly validation: boolean, readonly validationText: string | null }>, readonly displayRoles: ReadonlyArray<{ readonly __typename?: 'PersonRole', readonly key: string, readonly title: string, readonly description: string | null, readonly short: string | null, readonly type: PersonRoleType, readonly validation: boolean, readonly validationText: string | null }> }> } | null } | null };

export type GetPersonFormQueryVariables = Exact<{
  id: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetPersonFormQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly bmsActive: boolean, readonly memberships: ReadonlyArray<{ readonly __typename?: 'Membership', readonly id: number, readonly domain: { readonly __typename?: 'DomainBase', readonly name: string | null, readonly faviconUrl: string } }> | null, readonly addresses: ReadonlyArray<{ readonly __typename?: 'UserAddress', readonly value: number, readonly text: string }>, readonly subprofiles: ReadonlyArray<{ readonly __typename?: 'Subprofile', readonly value: string, readonly text: string }>, readonly availableRoles: ReadonlyArray<{ readonly __typename?: 'PersonRole', readonly key: string, readonly title: string, readonly description: string | null, readonly short: string | null, readonly type: PersonRoleType, readonly validation: boolean, readonly validationText: string | null, readonly available: boolean | null }>, readonly people: ReadonlyArray<{ readonly __typename?: 'Person', readonly id: string, readonly position: string | null, readonly title: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly salutation: Salutation | null, readonly translatedSalutation: string | null, readonly displayFormat: string | null, readonly sortPriority: number | null, readonly publicEmail: string | null, readonly email: string | null, readonly telephone: string | null, readonly xingUrl: string | null, readonly linkedinUrl: string | null, readonly officeId: number | null, readonly applicationAddressId: number | null, readonly subprofileId: number | null, readonly membershipIds: ReadonlyArray<number>, readonly photoUrl: string | null, readonly identity: { readonly __typename?: 'Identity', readonly id: string, readonly email: string, readonly verified: boolean, readonly lastLogin: any | null, readonly locale: string, readonly hasEbmsIdentity: boolean } | null, readonly communicationRoles: ReadonlyArray<{ readonly __typename?: 'PersonRole', readonly key: string, readonly title: string, readonly description: string | null, readonly short: string | null, readonly type: PersonRoleType, readonly validation: boolean, readonly validationText: string | null }>, readonly functionalRoles: ReadonlyArray<{ readonly __typename?: 'PersonRole', readonly key: string, readonly title: string, readonly description: string | null, readonly short: string | null, readonly type: PersonRoleType, readonly validation: boolean, readonly validationText: string | null }>, readonly displayRoles: ReadonlyArray<{ readonly __typename?: 'PersonRole', readonly key: string, readonly title: string, readonly description: string | null, readonly short: string | null, readonly type: PersonRoleType, readonly validation: boolean, readonly validationText: string | null }> }> } | null } | null };

export type UpdatePersonMutationVariables = Exact<{
  input: PersonFormInput;
  id: Scalars['Int']['input'];
}>;


export type UpdatePersonMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'UpdatePersonPayload', readonly person: { readonly __typename?: 'Person', readonly id: string } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsApplySettingsMutationVariables = Exact<{
  value: ApplyOptionAttributes;
}>;


export type ProfileFormsApplySettingsMutation = { readonly __typename?: 'Mutation', readonly profileFormsApplySettings: { readonly __typename?: 'ApplySettingsPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly applyOption: { readonly __typename?: 'OrganisationApplyOption', readonly id: string } | null } | null };

export type ProfileFormsBenefitsMutationVariables = Exact<{
  value: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProfileFormsBenefitsMutation = { readonly __typename?: 'Mutation', readonly profileFormsBenefits: { readonly __typename?: 'BenefitsPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly benefits: ReadonlyArray<{ readonly __typename?: 'JobsBenefit', readonly id: string, readonly titleDe: string, readonly titleEn: string | null }> | null } | null };

export type ProfileFormsBmsStateMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileFormsBmsStateMutation = { readonly __typename?: 'Mutation', readonly profileFormsBmsState: { readonly __typename?: 'BmsStatePayload', readonly bmsState: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsChangeUserNameMutationVariables = Exact<{
  value: Scalars['String']['input'];
}>;


export type ProfileFormsChangeUserNameMutation = { readonly __typename?: 'Mutation', readonly profileFormsChangeUserName: { readonly __typename?: 'ChangeUserNamePayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly organisation: { readonly __typename?: 'Organisation', readonly userName: string } } | null };

export type ProfileFormsCommunityManagementDomainActivationsMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileFormsCommunityManagementDomainActivationsMutation = { readonly __typename?: 'Mutation', readonly profileFormsCommunityManagementDomainActivations: { readonly __typename?: 'DomainActivationsPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly organisation: { readonly __typename?: 'Organisation', readonly id: string, readonly memberships: ReadonlyArray<{ readonly __typename?: 'Membership', readonly id: number, readonly createdAt: any, readonly domain: { readonly __typename?: 'DomainBase', readonly id: string, readonly name: string | null } }> | null } } | null };

export type ProfileFormsCommunityManagementDomainDeactivationsMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileFormsCommunityManagementDomainDeactivationsMutation = { readonly __typename?: 'Mutation', readonly profileFormsCommunityManagementDomainDeactivations: { readonly __typename?: 'DomainDeactivationsPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly organisation: { readonly __typename?: 'Organisation', readonly id: string, readonly domainDeactivations: ReadonlyArray<{ readonly __typename?: 'DomainDeactivation', readonly id: number, readonly createdAt: any, readonly domain: { readonly __typename?: 'DomainBase', readonly id: string, readonly name: string | null } }> } } | null };

export type ProfileFormsCommunityQuoteMutationVariables = Exact<{
  value: CommunityQuoteAttributes;
}>;


export type ProfileFormsCommunityQuoteMutation = { readonly __typename?: 'Mutation', readonly profileFormsCommunityQuote: { readonly __typename?: 'CommunityQuotePayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly communityQuote: { readonly __typename?: 'CommunityQuote', readonly id: string, readonly quote: string | null, readonly communityQuoteRelevance: CommunityQuoteCommunityQuoteRelevanceEnum | null, readonly quoteEn: string | null, readonly author: { readonly __typename?: 'Person', readonly id: string, readonly displayName: string | null, readonly photo: string | null } | null } | null } | null };

export type ProfileFormsCoworkrStateMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileFormsCoworkrStateMutation = { readonly __typename?: 'Mutation', readonly profileFormsCoworkrState: { readonly __typename?: 'CoworkrStatePayload', readonly coworkrState: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsDivisionsMutationVariables = Exact<{
  value: ReadonlyArray<DivisionAttributes> | DivisionAttributes;
}>;


export type ProfileFormsDivisionsMutation = { readonly __typename?: 'Mutation', readonly profileFormsDivisions: { readonly __typename?: 'DivisionsPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly divisions: ReadonlyArray<{ readonly __typename?: 'JobsDivision', readonly id: string }> | null } | null };

export type ProfileFormsEmployeeCountMutationVariables = Exact<{
  value: EmployeeCountAttributes;
}>;


export type ProfileFormsEmployeeCountMutation = { readonly __typename?: 'Mutation', readonly profileFormsEmployeeCount: { readonly __typename?: 'EmployeeCountPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly organisation: { readonly __typename?: 'Organisation', readonly id: string } | null } | null };

export type ProfileFormsEmployeeSurveysStateMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileFormsEmployeeSurveysStateMutation = { readonly __typename?: 'Mutation', readonly profileFormsEmployeeSurveysState: { readonly __typename?: 'EmployeeSurveysStatePayload', readonly employeeSurveysState: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsEmployerRatingPlatformsMutationVariables = Exact<{
  value: ReadonlyArray<EmployerRatingPlatformAttributes> | EmployerRatingPlatformAttributes;
}>;


export type ProfileFormsEmployerRatingPlatformsMutation = { readonly __typename?: 'Mutation', readonly profileFormsEmployerRatingPlatforms: { readonly __typename?: 'EmployerRatingPlatformsPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly employerRatingPlatforms: ReadonlyArray<{ readonly __typename?: 'EmployerRatingPlatform', readonly id: string }> | null } | null };

export type ProfileFormsFairekarriereStateMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileFormsFairekarriereStateMutation = { readonly __typename?: 'Mutation', readonly profileFormsFairekarriereState: { readonly __typename?: 'FairekarriereStatePayload', readonly fairekarriereState: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsInternationalsMutationVariables = Exact<{
  value: InternationalsAttributes;
}>;


export type ProfileFormsInternationalsMutation = { readonly __typename?: 'Mutation', readonly profileFormsInternationals: { readonly __typename?: 'InternationalsPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly applicantService: { readonly __typename?: 'OrganisationApplicantService', readonly id: string | null } | null } | null };

export type ProfileFormsJobwertStateMutationVariables = Exact<{
  value: ServiceState;
}>;


export type ProfileFormsJobwertStateMutation = { readonly __typename?: 'Mutation', readonly profileFormsJobwertState: { readonly __typename?: 'JobwertStatePayload', readonly jobwertState: ServiceState, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsKanaleoStateMutationVariables = Exact<{
  value: ServiceState;
}>;


export type ProfileFormsKanaleoStateMutation = { readonly __typename?: 'Mutation', readonly profileFormsKanaleoState: { readonly __typename?: 'KanaleoStatePayload', readonly kanaleoState: ServiceState, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsPageFeatureAccessMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
}>;


export type ProfileFormsPageFeatureAccessMutation = { readonly __typename?: 'Mutation', readonly profileFormsPageFeatureAccess: { readonly __typename?: 'PageFeatureAccessPayload', readonly feature: string, readonly value: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsQuoteRelevanceMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
}>;


export type ProfileFormsQuoteRelevanceMutation = { readonly __typename?: 'Mutation', readonly profileFormsQuoteRelevance: { readonly __typename?: 'QuoteRelevancePayload', readonly quoteRelevance: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsRewardsMutationVariables = Exact<{
  value: ReadonlyArray<RewardAttributes> | RewardAttributes;
}>;


export type ProfileFormsRewardsMutation = { readonly __typename?: 'Mutation', readonly profileFormsRewards: { readonly __typename?: 'RewardsPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly rewardUsers: ReadonlyArray<{ readonly __typename?: 'RewardUser', readonly id: string }> | null } | null };

export type ProfileFormsSmartclickSettingUpdateAttributeMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
}>;


export type ProfileFormsSmartclickSettingUpdateAttributeMutation = { readonly __typename?: 'Mutation', readonly profileFormsSmartclickSettingUpdateAttribute: { readonly __typename?: 'SmartclickSettingUpdateAttributePayload', readonly smartclickSetting: { readonly __typename?: 'SmartclickSetting', readonly ignore: boolean, readonly ignoreUntil: any | null, readonly feedimportMax: number | null, readonly statisticUnreliable: boolean, readonly comment: string | null, readonly communityManagerActivityBoost: number | null, readonly boostActive: boolean } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsSocialNetworksMutationVariables = Exact<{
  value: ReadonlyArray<SocialNetworkAttributes> | SocialNetworkAttributes;
}>;


export type ProfileFormsSocialNetworksMutation = { readonly __typename?: 'Mutation', readonly profileFormsSocialNetworks: { readonly __typename?: 'SocialNetworksPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly socialNetworks: ReadonlyArray<{ readonly __typename?: 'SocialNetwork', readonly id: string, readonly icon: string | null, readonly name: string | null, readonly url: string | null }> | null } | null };

export type ProfileFormsTalentsStateMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileFormsTalentsStateMutation = { readonly __typename?: 'Mutation', readonly profileFormsTalentsState: { readonly __typename?: 'TalentsStatePayload', readonly talentsState: string, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsTierAbilityUpdateAttributeMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
  membershipIds: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProfileFormsTierAbilityUpdateAttributeMutation = { readonly __typename?: 'Mutation', readonly profileFormsTierAbilityUpdateAttribute: { readonly __typename?: 'UpdateTierAbilityAttributePayload', readonly tierAbility: { readonly __typename?: 'TierAbility', readonly id: string } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsUpdateAttributeMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
  membershipIds: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProfileFormsUpdateAttributeMutation = { readonly __typename?: 'Mutation', readonly profileFormsUpdateAttribute: { readonly __typename?: 'UpdateAttributePayload', readonly organisation: { readonly __typename?: 'Organisation', readonly id: string } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsVideoMutationVariables = Exact<{
  value: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileFormsVideoMutation = { readonly __typename?: 'Mutation', readonly profileFormsVideo: { readonly __typename?: 'VideoPayload', readonly video: string | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type GetStatisticApplicationDetailsQueryVariables = Exact<{
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
  widget: InputMaybe<Scalars['Boolean']['input']>;
  onlyUnsolicited: InputMaybe<Scalars['Boolean']['input']>;
  onlyRecommended: InputMaybe<Scalars['Boolean']['input']>;
  onlyCoworkr: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetStatisticApplicationDetailsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly applicationStatistics: ReadonlyArray<{ readonly __typename?: 'ApplicationStatistic', readonly allowedReference: boolean | null, readonly applicationIdentifier: string | null, readonly coworkrRecommender: string | null, readonly id: string, readonly isUnsolicited: boolean, readonly jobNummer: string | null, readonly jobTitle: string | null, readonly origin: string, readonly recommendationType: Recommendation | null, readonly recommendedBy: string | null, readonly senddate: any | null }> } | null } | null };

export type GetStatisticClicksDetailsQueryVariables = Exact<{
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
  widget: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetStatisticClicksDetailsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly statistics: ReadonlyArray<{ readonly __typename?: 'ClicksStatistic', readonly clicksCount: number, readonly count: number, readonly id: string, readonly jobDomain: string | null, readonly jobNummer: string | null, readonly jobTitle: string | null, readonly onlineDays: string | null }> } | null } | null };

export type GetStatisticCoworkrDetailsQueryVariables = Exact<{
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
}>;


export type GetStatisticCoworkrDetailsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly jobStatistics: ReadonlyArray<{ readonly __typename?: 'StatisticApply', readonly year: number | null, readonly month: number | null, readonly coworkrSubscribersCount: number | null, readonly coworkrReceivedMails: number | null, readonly coworkrOpenedMails: number | null, readonly coworkrEventsPerJob: ReadonlyArray<{ readonly __typename?: 'StatisticCoworkrEventsPerJob', readonly nummer: string, readonly title: string, readonly clicks: number, readonly shares: number }> | null }> } | null } | null };

export type GetStatisticImpressionsDetailsQueryVariables = Exact<{
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
}>;


export type GetStatisticImpressionsDetailsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly statistics: ReadonlyArray<{ readonly __typename?: 'ClicksStatistic', readonly count: number, readonly id: string, readonly jobDomain: string | null, readonly jobNummer: string | null, readonly jobTitle: string | null, readonly onlineDays: string | null }> } | null } | null };

export type GetStatisticSmartclickDetailsQueryVariables = Exact<{
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
}>;


export type GetStatisticSmartclickDetailsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly all: number, readonly strong: number, readonly weak: number } | null } | null };

export type GetStatisticUsedCodesDetailsQueryVariables = Exact<{
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
}>;


export type GetStatisticUsedCodesDetailsQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly applicationStatistics: ReadonlyArray<{ readonly __typename?: 'ApplicationStatistic', readonly id: string, readonly allowedReference: boolean | null, readonly applicationIdentifier: string | null, readonly coworkrRecommender: string | null, readonly isUnsolicited: boolean, readonly organisation: string | null, readonly jobTitle: string | null, readonly origin: string, readonly recommendationType: Recommendation | null, readonly senddate: any | null }> } | null } | null };

export type UpdateYearApplyStatisticMutationVariables = Exact<{
  input: ReadonlyArray<ApplyAttributes> | ApplyAttributes;
}>;


export type UpdateYearApplyStatisticMutation = { readonly __typename?: 'Mutation', readonly updateApplyStatistics: { readonly __typename?: 'UpdateApplyStatisticsPayload', readonly jobStatistics: ReadonlyArray<{ readonly __typename?: 'StatisticApply', readonly id: string, readonly userApplicationTotalCount: number | null, readonly userApplicationEmpfehlungsbundCount: number | null, readonly userHiredEmpfehlungsbundCount: number | null, readonly userHiredTotalCount: number | null }> | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type TierFeatureMatrixQueryVariables = Exact<{ [key: string]: never; }>;


export type TierFeatureMatrixQuery = { readonly __typename?: 'Query', readonly tierFeatureMatrix: { readonly __typename?: 'TierFeatureMatrix', readonly tierLevels: ReadonlyArray<{ readonly __typename?: 'TierLevelInfo', readonly key: string, readonly title: string, readonly description: string, readonly features: any }>, readonly featureCategories: { readonly __typename?: 'FeatureCategories', readonly services: { readonly __typename?: 'FeatureCategory', readonly label: string, readonly features: ReadonlyArray<{ readonly __typename?: 'FeatureBasicInfo', readonly key: string, readonly label: string, readonly description: string }> }, readonly internalFeatures: { readonly __typename?: 'FeatureCategory', readonly label: string, readonly features: ReadonlyArray<{ readonly __typename?: 'FeatureBasicInfo', readonly key: string, readonly label: string, readonly description: string }> }, readonly pageFeatures: { readonly __typename?: 'FeatureCategory', readonly label: string, readonly features: ReadonlyArray<{ readonly __typename?: 'FeatureBasicInfo', readonly key: string, readonly label: string, readonly description: string }> } }, readonly allFeatures: ReadonlyArray<{ readonly __typename?: 'FeatureInfo', readonly key: string, readonly label: string, readonly category: string, readonly type: string, readonly possibleValues: ReadonlyArray<string> }> } | null };

export type TierHistoryQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type TierHistoryQuery = { readonly __typename?: 'Query', readonly tierHistory: ReadonlyArray<{ readonly __typename?: 'TierAbility', readonly id: string, readonly tierLevel: string, readonly active: boolean, readonly currentAbilitySince: any | null }> | null };

export type TierSettingsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  tierType: Scalars['String']['input'];
}>;


export type TierSettingsQuery = { readonly __typename?: 'Query', readonly tierSettings: { readonly __typename?: 'TierSettings', readonly hasExisting: boolean, readonly settings: ReadonlyArray<{ readonly __typename?: 'TierSettingItem', readonly key: string, readonly label: string, readonly currentValue: string, readonly newValue: string, readonly changed: boolean, readonly isIndividual: boolean, readonly defaultValue: string, readonly displayValue: string, readonly displayIcon: string, readonly displayClass: string, readonly hint: string | null }> } | null };

export type TranslateQueryVariables = Exact<{
  text: Scalars['String']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
  isHtml: Scalars['Boolean']['input'];
}>;


export type TranslateQuery = { readonly __typename?: 'Query', readonly translate: string | null };

export type GetBannerDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBannerDataQuery = { readonly __typename?: 'Query', readonly me: { readonly __typename?: 'User', readonly organisation: { readonly __typename?: 'Organisation', readonly banners: ReadonlyArray<{ readonly __typename?: 'BannerGeneratorBanner', readonly id: string, readonly ready: boolean, readonly url: string | null, readonly slots: ReadonlyArray<{ readonly __typename?: 'BannerGeneratorSlot', readonly position: number, readonly image: { readonly __typename?: 'BannerGeneratorImage', readonly id: string, readonly url: string, readonly nativeResolution: string | null } }>, readonly layout: { readonly __typename?: 'BannerGeneratorLayout', readonly resolution: string, readonly title: string, readonly slots: ReadonlyArray<{ readonly __typename?: 'BannerGeneratorSlotConfig', readonly aspect: number | null, readonly height: number, readonly width: number, readonly position: number | null, readonly slots: ReadonlyArray<{ readonly __typename?: 'BannerGeneratorSlotConfig', readonly height: number, readonly width: number, readonly aspect: number | null, readonly position: number | null }> | null }> } }>, readonly uploadedBannerImages: ReadonlyArray<{ readonly __typename?: 'BannerGeneratorImage', readonly id: string, readonly url: string, readonly nativeResolution: string | null }> } | null } | null };

export type UploadImageMutationVariables = Exact<{
  bannerId: Scalars['ID']['input'];
  input: BannerUpdateInput;
}>;


export type UploadImageMutation = { readonly __typename?: 'Mutation', readonly banners: { readonly __typename?: 'MutationBanners', readonly update: { readonly __typename?: 'UpdateBannerPayload', readonly banner: { readonly __typename?: 'BannerGeneratorBanner', readonly id: string, readonly url: string | null, readonly ready: boolean, readonly slots: ReadonlyArray<{ readonly __typename?: 'BannerGeneratorSlot', readonly position: number, readonly image: { readonly __typename?: 'BannerGeneratorImage', readonly id: string, readonly url: string, readonly nativeResolution: string | null } }> } | null } | null } };

export type EmployeeSurveysCreateDepartmentMutationVariables = Exact<{
  organisationSurveyId: Scalars['ID']['input'];
  input: DepartmentInput;
}>;


export type EmployeeSurveysCreateDepartmentMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'CreateDepartmentPayload', readonly department: { readonly __typename?: 'EmployeeSurveysDepartment', readonly id: string, readonly name: string, readonly nameWithPath: string, readonly ancestors: ReadonlyArray<string>, readonly parentId: string | null } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type EmployeeSurveysCreateParticipantMutationVariables = Exact<{
  organisationSurveyId: Scalars['ID']['input'];
  input: ParticipantInput;
}>;


export type EmployeeSurveysCreateParticipantMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'CreateParticipantPayload', readonly participant: { readonly __typename?: 'EmployeeSurveysParticipant', readonly id: string, readonly code: string, readonly departmentId: string | null, readonly status: EmployeeSurveysParticipantStatusEnum | null, readonly ageGroup: string | null, readonly location: string | null, readonly gender: string | null, readonly seniority: string | null } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly message: string, readonly field: string }> } | null };

export type EmployeeSurveysDeleteDepartmentMutationVariables = Exact<{
  departmentId: Scalars['ID']['input'];
}>;


export type EmployeeSurveysDeleteDepartmentMutation = { readonly __typename?: 'Mutation', readonly employeeSurveysDeleteDepartment: { readonly __typename?: 'DeleteDepartmentPayload', readonly department: { readonly __typename?: 'EmployeeSurveysDepartment', readonly id: string } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly message: string, readonly field: string }> } | null };

export type EmployeeSurveysDeleteParticipantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmployeeSurveysDeleteParticipantMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'DeleteParticipantPayload', readonly participant: { readonly __typename?: 'EmployeeSurveysParticipant', readonly id: string } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly message: string, readonly field: string }> } | null };

export type EmployeeSurveysDepartmentFragmentFragment = { readonly __typename?: 'EmployeeSurveysDepartment', readonly id: string, readonly name: string, readonly nameWithPath: string, readonly ancestors: ReadonlyArray<string>, readonly parentId: string | null };

export type EmployeeSurveysPartFragmentFragment = { readonly __typename?: 'EmployeeSurveysSurveyPart', readonly global: boolean | null, readonly id: string, readonly title: string | null, readonly descriptionEn: string | null, readonly descriptionDe: string | null, readonly surveyPartType: EmployeeSurveysSurveyPartSurveyPartTypeEnum | null, readonly explanation: string | null, readonly subject: EmployeeSurveysSurveyPartSubjectEnum | null, readonly position: number | null, readonly questions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysQuestion', readonly id: string, readonly position: number, readonly textDe: string, readonly textEn: string, readonly modelCode: string | null, readonly readOnly: boolean, readonly answerType: EmployeeSurveysQuestionAnswerTypeEnum | null, readonly answerOptions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysAnswerOption', readonly de: string, readonly en: string, readonly value: string | null }> | null }> };

export type EmployeeSurveysParticipantFragmentFragment = { readonly __typename?: 'EmployeeSurveysParticipant', readonly id: string, readonly code: string, readonly departmentId: string | null, readonly status: EmployeeSurveysParticipantStatusEnum | null, readonly ageGroup: string | null, readonly location: string | null, readonly gender: string | null, readonly seniority: string | null };

export type GetEmployeeSurveyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEmployeeSurveyQuery = { readonly __typename?: 'Query', readonly getOrganisationSurvey: { readonly __typename?: 'EmployeeSurveysOrganisationSurvey', readonly id: string | null, readonly greeting: string | null, readonly parts: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysSurveyPart', readonly global: boolean | null, readonly id: string, readonly title: string | null, readonly descriptionEn: string | null, readonly descriptionDe: string | null, readonly surveyPartType: EmployeeSurveysSurveyPartSurveyPartTypeEnum | null, readonly explanation: string | null, readonly subject: EmployeeSurveysSurveyPartSubjectEnum | null, readonly position: number | null, readonly questions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysQuestion', readonly id: string, readonly position: number, readonly textDe: string, readonly textEn: string, readonly modelCode: string | null, readonly readOnly: boolean, readonly answerType: EmployeeSurveysQuestionAnswerTypeEnum | null, readonly answerOptions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysAnswerOption', readonly de: string, readonly en: string, readonly value: string | null }> | null }> }> } | null };

export type GetGlobalOrganisationSurveyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetGlobalOrganisationSurveyQuery = { readonly __typename?: 'Query', readonly getOrganisationSurvey: { readonly __typename?: 'EmployeeSurveysOrganisationSurvey', readonly id: string | null, readonly greeting: string | null, readonly internalName: string, readonly parts: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysSurveyPart', readonly global: boolean | null, readonly id: string, readonly title: string | null, readonly descriptionEn: string | null, readonly descriptionDe: string | null, readonly surveyPartType: EmployeeSurveysSurveyPartSurveyPartTypeEnum | null, readonly explanation: string | null, readonly subject: EmployeeSurveysSurveyPartSubjectEnum | null, readonly position: number | null, readonly questions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysQuestion', readonly id: string, readonly position: number, readonly textDe: string, readonly textEn: string, readonly modelCode: string | null, readonly readOnly: boolean, readonly answerType: EmployeeSurveysQuestionAnswerTypeEnum | null, readonly answerOptions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysAnswerOption', readonly de: string, readonly en: string, readonly value: string | null }> | null }> }> } | null, readonly models: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysModel', readonly id: string, readonly name: string, readonly description: string | null, readonly year: number | null, readonly author: string | null, readonly updatedYear: number | null, readonly shortCode: string, readonly variables: string | null, readonly instrument: string | null, readonly asHtml: string }> };

export type GetGlobalOrganisationSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalOrganisationSurveysQuery = { readonly __typename?: 'Query', readonly surveys: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysOrganisationSurvey', readonly id: string | null, readonly internalName: string, readonly parts: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysSurveyPart', readonly global: boolean | null, readonly id: string, readonly title: string | null, readonly descriptionEn: string | null, readonly descriptionDe: string | null, readonly surveyPartType: EmployeeSurveysSurveyPartSurveyPartTypeEnum | null, readonly explanation: string | null, readonly subject: EmployeeSurveysSurveyPartSubjectEnum | null, readonly position: number | null, readonly questions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysQuestion', readonly id: string, readonly position: number, readonly textDe: string, readonly textEn: string, readonly modelCode: string | null, readonly readOnly: boolean, readonly answerType: EmployeeSurveysQuestionAnswerTypeEnum | null, readonly answerOptions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysAnswerOption', readonly de: string, readonly en: string, readonly value: string | null }> | null }> }> }> | null, readonly models: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysModel', readonly id: string, readonly name: string, readonly description: string | null, readonly year: number | null, readonly author: string | null, readonly updatedYear: number | null, readonly shortCode: string, readonly variables: string | null, readonly instrument: string | null, readonly asHtml: string }> };

export type EmployeSurveysGetParticipantsQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
}>;


export type EmployeSurveysGetParticipantsQuery = { readonly __typename?: 'Query', readonly getOrganisationSurvey: { readonly __typename?: 'EmployeeSurveysOrganisationSurvey', readonly ageGroupOptions: ReadonlyArray<{ readonly __typename?: 'FormOption', readonly text: string, readonly value: string }>, readonly seniorityOptions: ReadonlyArray<{ readonly __typename?: 'FormOption', readonly text: string, readonly value: string }>, readonly genderOptions: ReadonlyArray<{ readonly __typename?: 'FormOption', readonly text: string, readonly value: string }>, readonly locationOptions: ReadonlyArray<{ readonly __typename?: 'FormOption', readonly text: string, readonly value: string }>, readonly participants: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysParticipant', readonly id: string, readonly code: string, readonly departmentId: string | null, readonly status: EmployeeSurveysParticipantStatusEnum | null, readonly ageGroup: string | null, readonly location: string | null, readonly gender: string | null, readonly seniority: string | null }>, readonly departments: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysDepartment', readonly id: string, readonly name: string, readonly nameWithPath: string, readonly ancestors: ReadonlyArray<string>, readonly parentId: string | null }> } | null };

export type EmployeeSurveysGetSurveyQuestionsForParticipantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  participantId: InputMaybe<Scalars['ID']['input']>;
}>;


export type EmployeeSurveysGetSurveyQuestionsForParticipantQuery = { readonly __typename?: 'Query', readonly survey: { readonly __typename?: 'EmployeeSurveysOrganisationSurvey', readonly parts: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysSurveyPart', readonly id: string, readonly description: string | null, readonly position: number | null, readonly surveyPartType: EmployeeSurveysSurveyPartSurveyPartTypeEnum | null, readonly questions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysQuestion', readonly id: string, readonly position: number, readonly modelCode: string | null, readonly text: string, readonly answerType: EmployeeSurveysQuestionAnswerTypeEnum | null, readonly answerOptionsLocalized: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysAnswerOptionLocalized', readonly text: string, readonly value: any }> }> }> } | null };

export type EmployeeSurveysUpdateDepartmentMutationVariables = Exact<{
  departmentId: Scalars['ID']['input'];
  input: DepartmentInput;
}>;


export type EmployeeSurveysUpdateDepartmentMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'UpdateDepartmentPayload', readonly department: { readonly __typename?: 'EmployeeSurveysDepartment', readonly id: string, readonly name: string, readonly nameWithPath: string, readonly ancestors: ReadonlyArray<string>, readonly parentId: string | null } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type EmployeeSurveyUpdateOrganisationSurveyQuestionsMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  parts: ReadonlyArray<PartInput> | PartInput;
  adminMode: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EmployeeSurveyUpdateOrganisationSurveyQuestionsMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'OrganisationSurveyUpdateQuestionsPayload', readonly survey: { readonly __typename?: 'EmployeeSurveysOrganisationSurvey', readonly id: string | null, readonly greeting: string | null, readonly internalName: string, readonly parts: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysSurveyPart', readonly global: boolean | null, readonly id: string, readonly title: string | null, readonly descriptionDe: string | null, readonly descriptionEn: string | null, readonly surveyPartType: EmployeeSurveysSurveyPartSurveyPartTypeEnum | null, readonly position: number | null, readonly questions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysQuestion', readonly id: string, readonly position: number, readonly textDe: string, readonly textEn: string, readonly readOnly: boolean, readonly modelCode: string | null, readonly answerType: EmployeeSurveysQuestionAnswerTypeEnum | null, readonly answerOptions: ReadonlyArray<{ readonly __typename?: 'EmployeeSurveysAnswerOption', readonly de: string, readonly en: string, readonly value: string | null }> | null }> }> } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type EmployeeSurveysUpdateParticipantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateParticipantInput;
}>;


export type EmployeeSurveysUpdateParticipantMutation = { readonly __typename?: 'Mutation', readonly result: { readonly __typename?: 'UpdateParticipantPayload', readonly participant: { readonly __typename?: 'EmployeeSurveysParticipant', readonly id: string, readonly code: string, readonly departmentId: string | null, readonly status: EmployeeSurveysParticipantStatusEnum | null, readonly ageGroup: string | null, readonly location: string | null, readonly gender: string | null, readonly seniority: string | null } | null, readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly message: string, readonly field: string }> } | null };

export type ProfileFormsKanaleoDepartmentSelectionsMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: ReadonlyArray<DepartmentSelectionArgument> | DepartmentSelectionArgument;
}>;


export type ProfileFormsKanaleoDepartmentSelectionsMutation = { readonly __typename?: 'Mutation', readonly profileFormsKanaleoDepartmentSelections: { readonly __typename?: 'DepartmentSelectionsPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export type ProfileFormsKanaleoServiceProvidersMutationVariables = Exact<{
  key: InputMaybe<Scalars['String']['input']>;
  value: ReadonlyArray<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ProfileFormsKanaleoServiceProvidersMutation = { readonly __typename?: 'Mutation', readonly profileFormsKanaleoServiceProviders: { readonly __typename?: 'ServiceProvidersPayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }>, readonly serviceProviders: ReadonlyArray<{ readonly __typename?: 'KanaleoServiceProvider', readonly id: string }> } | null };

export type KanaleoUpdateAttributeMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
}>;


export type KanaleoUpdateAttributeMutation = { readonly __typename?: 'Mutation', readonly kanaleoUpdateAttribute: { readonly __typename?: 'SurveySettingUpdateAttributePayload', readonly errors: ReadonlyArray<{ readonly __typename?: 'ValidationErrors', readonly field: string, readonly message: string }> } | null };

export const GptTaskFragmentDoc = gql`
    fragment GptTask on JobGptTask {
  id
  key
  label
  prompt
  selectableGptAttributes
  userInputAttributes
  loadingTexts
  jobGptText
}
    `;
export const GptTaskRunFragmentDoc = gql`
    fragment GptTaskRun on JobGptTaskRun {
  id
  taskId
  request
  response
  usage
  openaiResponse
  userInputs
  key
  label
  createdAt
  feedbackRating
  feedbackText
  feedbackAt
  hasFeedback
  task {
    ...GptTask
  }
}
    ${GptTaskFragmentDoc}`;
export const GptJobFragmentDoc = gql`
    fragment GptJob on JobGptJob {
  id
  gptObjectType
  tasks {
    ...GptTask
  }
  runs {
    ...GptTaskRun
  }
  inputUrls
  positionTitle
  educationRequirements
  specialCompetencies
  additionalAttributes
  inputFiles {
    id
    fileableType
    openaiFileId
    createdAt
    updatedAt
    url
    contentType
    name
    size
  }
  jobType
  seniority
  locations
  sectors
  keywordsEducation
  keywordsCompetences
  keywordsJobDescription
  workConditions
  benefits
  salary
  title
  firstParagraph
  jobDescription
  userCompletedJobInputTaskAt
  userCompletedJobInformationTaskAt
  userCompletedJobKeywordsTaskAt
  userCompletedJobTitlesTaskAt
  userCompletedJobFirstParagraphTaskAt
  userCompletedJobDescriptionTaskAt
  userCompletedJobFromUrlTaskAt
  gptMode
  meta
}
    ${GptTaskFragmentDoc}
${GptTaskRunFragmentDoc}`;
export const GptOrganisationFragmentDoc = gql`
    fragment GptOrganisation on JobGptOrganisation {
  id
  gptObjectType
  tasks {
    ...GptTask
  }
  runs {
    ...GptTaskRun
  }
  inputUrls
  inputDescription
  inputFiles {
    id
    fileableType
    openaiFileId
    createdAt
    updatedAt
    url
    contentType
    name
  }
  organisationName
  missionStatement
  numbersStatement
}
    ${GptTaskFragmentDoc}
${GptTaskRunFragmentDoc}`;
export const GptVariantFragmentDoc = gql`
    fragment GptVariant on JobGptVariant {
  id
  gptObjectType
  tasks {
    ...GptTask
  }
  runs {
    ...GptTaskRun
  }
  manualJobId
  organisationId
  jobType
  seniorities: seniority
  homeofficeType
  locations
  benefits
  workConditions
  title
  keywords
  jobDescription
  userInputs
  aiIntensity
  refineTitle
  refineKeywords
  refineFirstParagraph
  refineDescription
  userCompletedVariantInputTaskAt
  masterTitle
  masterKeywords
  masterDescription
}
    ${GptTaskFragmentDoc}
${GptTaskRunFragmentDoc}`;
export const GptVariantMultiStepFragmentDoc = gql`
    fragment GptVariantMultiStep on JobGptVariantMultiStep {
  id
  gptObjectType
  tasks {
    ...GptTask
  }
  runs {
    ...GptTaskRun
  }
  manualJobId
  organisationId
  masterTitle
  masterKeywords
  masterDescription
  masterFirstParagraph
  jobType
  seniorities: seniority
  homeofficeType
  locations
  benefits
  workConditions
  aiIntensity
  selectedFields
  selectedTitle
  userCompletedVariantTitleTaskAt
  generatedFirstParagraph
  masterDescriptionWithoutFirstParagraph
  userCompletedVariantFirstParagraphTaskAt
  generatedJobDescription
  generatedJobDescriptionWithoutFirstParagraph
  userCompletedVariantJobDescriptionTaskAt
  generatedKeywords
  userCompletedVariantKeywordsTaskAt
  organisationName
  missionStatement
  numbersStatement
  organisationDescription
  organisationCareerPageUrl
  sectors
  salary
}
    ${GptTaskFragmentDoc}
${GptTaskRunFragmentDoc}`;
export const EmployeeSurveysDepartmentFragmentFragmentDoc = gql`
    fragment EmployeeSurveysDepartmentFragment on EmployeeSurveysDepartment {
  id
  name
  nameWithPath
  ancestors
  parentId
}
    `;
export const EmployeeSurveysPartFragmentFragmentDoc = gql`
    fragment EmployeeSurveysPartFragment on EmployeeSurveysSurveyPart {
  global
  id
  title
  descriptionEn
  descriptionDe
  surveyPartType
  explanation
  subject
  position
  questions {
    id
    position
    textDe
    textEn
    modelCode
    readOnly
    answerType
    answerOptions {
      de
      en
      value
    }
  }
}
    `;
export const EmployeeSurveysParticipantFragmentFragmentDoc = gql`
    fragment EmployeeSurveysParticipantFragment on EmployeeSurveysParticipant {
  id
  code
  departmentId
  status
  ageGroup
  location
  gender
  seniority
}
    `;
export const ChangeTierLevelDocument = gql`
    mutation ChangeTierLevel($organisationId: ID!, $toTier: String!) {
  changeTierLevel(organisationId: $organisationId, toTier: $toTier) {
    success
    tier {
      id
      tierLevel
      currentAbilitySince
    }
    errors
  }
}
    `;
export const GetCmBubblePeopleDocument = gql`
    query getCmBubblePeople {
  me {
    id
    organisation {
      id
      people {
        id
        name: displayName
        telephone
        email
      }
    }
  }
}
    `;
export const GetDomainsDocument = gql`
    query getDomains {
  domains(notEmpfehlungsbund: true) {
    id
    name
    linkColor
    logo(variant: thumb)
  }
}
    `;
export const UpdateDashboardLayoutDocument = gql`
    mutation updateDashboardLayout($input: DashboardLayoutAttributes!) {
  updateDashboardLayout(input: $input) {
    layout {
      faved
      collapsed
    }
  }
}
    `;
export const FkCreateMetascoreProfileDocument = gql`
    mutation fkCreateMetascoreProfile($source: String!, $url: String!, $ratingValue: Float, $reviewCount: Int) {
  fkCreateMetascoreProfile: fkMutations {
    createMetascoreProfile(
      source: $source
      url: $url
      ratingValue: $ratingValue
      reviewCount: $reviewCount
    ) {
      metascoreProfile {
        id
        source
        url
        ratingValue
        bestRating
        reviewCount
        status
        lastRetrievedAt
      }
      errors {
        field
        message
      }
    }
  }
}
    `;
export const FkDeleteMetascoreProfileDocument = gql`
    mutation fkDeleteMetascoreProfile($id: ID!) {
  fkDeleteMetascoreProfile: fkMutations {
    deleteMetascoreProfile(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
}
    `;
export const FkUpdateMetascoreProfileDocument = gql`
    mutation fkUpdateMetascoreProfile($id: ID!, $url: String, $ratingValue: Float, $reviewCount: Int, $refresh: Boolean) {
  fkUpdateMetascoreProfile: fkMutations {
    updateMetascoreProfile(
      id: $id
      url: $url
      ratingValue: $ratingValue
      reviewCount: $reviewCount
      refresh: $refresh
    ) {
      metascoreProfile {
        id
        source
        url
        ratingValue
        bestRating
        reviewCount
        status
        lastRetrievedAt
      }
      errors {
        field
        message
      }
    }
  }
}
    `;
export const FkUpdateOrganisationSettingDocument = gql`
    mutation fkUpdateOrganisationSetting($key: String!, $value: JSON!) {
  fkUpdateOrganisationSetting: fkMutations {
    updateOrganisationSetting(key: $key, value: $value) {
      errors {
        field
        message
      }
      fkOrganisationSetting {
        quote
        quoteAuthor
        feedbackActive
        separateSites
        doesNotTakePartInFeedbackProcess
      }
    }
  }
}
    `;
export const GenerateRejectionFeedbackDocument = gql`
    query generateRejectionFeedback($questionDe: String!, $questionEn: String!, $answers: JSON!) {
  generateRejectionFeedback(
    questionDe: $questionDe
    questionEn: $questionEn
    answers: $answers
  ) {
    de
    en
  }
}
    `;
export const GetApplyStatisticsDocument = gql`
    query getApplyStatistics($from: ISO8601Date!, $to: ISO8601Date!) {
  me {
    organisation {
      bmsActivationLevel
      bmsActive
      bmsApplicationRouting
      coworkrActive
      hasBms
      currentTierAbility {
        tierLevelKey
      }
      jobStatistics(from: $from, to: $to) {
        id
        applicationCount
        applicationCoworkrCount
        applicationRecommendedCount
        applicationUnsolicitedCount
        applicationWidgetCount
        clicksCount
        impressionsCount
        computedApplicationEmpfehlungsbundCount
        computedApplicationTotalCount
        computedHiredEmpfehlungsbundCount
        computedHiredTotalCount
        estimatedApplicationEmpfehlungsbundCount
        estimatedApplicationTotalCount
        estimatedHiredEmpfehlungsbundCount
        estimatedHiredTotalCount
        createdAt
        date
        internCount
        isEditable
        isUntouched
        jobsCount
        month
        smartclicks
        smartclicksCompliant
        smartclicksPerApplications
        usedCodesCount
        userApplicationEmpfehlungsbundCount
        userApplicationTotalCount
        userHiredEmpfehlungsbundCount
        userHiredTotalCount
        widgetClicks
        year
        coworkrClicks
        shouldWarnMissingData
      }
    }
  }
}
    `;
export const GetAppointmentReviewModalDataDocument = gql`
    query getAppointmentReviewModalData {
  me {
    organisation {
      communityManager {
        id
        image
        teamsBookingsUrl
        telephone
        email
        name {
          displayName
        }
      }
      people {
        displayName
        telephone
      }
      addresses(active: true) {
        displayName
        hidden
      }
    }
  }
}
    `;
export const GetGlobalProfileInfoDocument = gql`
    query getGlobalProfileInfo {
  allRewards {
    id
    logo(variant: thumb)
    description
    userLinkOptional
    name
    year
  }
  allCompetences {
    id
    mainWord
    keywords
    portalTypes {
      id
      name
    }
  }
  allSectors {
    id
    name
    description
  }
  domains(notEmpfehlungsbund: true) {
    id
    name
    linkColor
    logo(variant: thumb)
  }
  allPortalTypes {
    id
    name
    tagline
    upcase
  }
}
    `;
export const GetOrganisationApplicantServicesDocument = gql`
    query getOrganisationApplicantServices {
  me {
    organisation {
      people {
        displayName
        id
      }
      applicantService {
        bureaucracyService
        bureaucracyServiceDescriptionEn
        bureaucracyServiceDescriptionDe
        companyLanguages
        companyLanguagesDescriptionEn
        companyLanguagesDescriptionDe
        familyService
        familyServiceDescriptionEn
        familyServiceDescriptionDe
        germanEducation
        germanEducationDescriptionEn
        germanEducationDescriptionDe
        housingService
        housingServiceDescriptionEn
        housingServiceDescriptionDe
        id
        personId
        recognitionService
        recognitionServiceDescriptionEn
        recognitionServiceDescriptionDe
        socialService
        socialServiceDescriptionEn
        socialServiceDescriptionDe
        videoUsed
        videoUsedDescriptionEn
        videoUsedDescriptionDe
        visaService
        visaServiceDescriptionEn
        visaServiceDescriptionDe
        visitPossible
        visitPossibleDescriptionEn
        visitPossibleDescriptionDe
      }
    }
  }
}
    `;
export const GetOrganisationApplyOptionDocument = gql`
    query getOrganisationApplyOption {
  me {
    organisation {
      externalBmsHandling
      hasApplicationMethod: hasExternalBmsDelivery
      bmsActivationLevel
      applicationQuestions {
        organisationId
        questionDe
        id
        answerType
        visibleByWatchers
        questionEn
        answers
        remoteId
        screenerEnabled
        screenerRejectionFeedbackDe
        screenerRejectionFeedbackEn
      }
      applyOption {
        id
        files
        gender
        lastName
        firstName
        telephone
        applicationQuestionIds
        postalAddress
        requiredDocumentsDe
        requiredDocumentsEn
        screenerActive
        screenerKeepForDays
        screenerTemplateDe
        screenerTemplateEn
        ebmsScreenerEnabled
        jobsWithDifferentApplicationQuestions {
          id
          title
          applicationQuestions {
            id
            questionDe
          }
        }
      }
    }
  }
}
    `;
export const OrganisationGetEmployeeCountDocument = gql`
    query organisationGetEmployeeCount {
  me {
    organisation {
      lastEmployeeStatistic {
        employeeCount
        employeeCountForBilling
        canUpdate
        hasBillingCount
        createdAt
      }
    }
  }
}
    `;
export const GetOrganisationForCertificateGeneratorDocument = gql`
    query getOrganisationForCertificateGenerator {
  me {
    id
    organisation {
      id
      name
      addresses(active: true) {
        id
        location
      }
      mainUserAddressId
      recommendationReceivers {
        id
        name
        email
        createdAt
      }
      empfehlungscodes(active: true) {
        id
        code
        title
      }
      people {
        id
        displayName
        name {
          title
          firstName
          lastName
        }
        email
      }
      domains {
        id
        name
        url
        accentColor
        logo(variant: medium)
      }
    }
  }
}
    `;
export const OrganisationKarmaHistoryDocument = gql`
    query organisationKarmaHistory {
  me {
    organisation {
      karmaHistory
      smartlinkFeedbackEntries {
        id
        status
        createdAt
        date
        severity
        title
        recipients
      }
    }
  }
}
    `;
export const GetOrganisationNewsfeedStatusDocument = gql`
    query getOrganisationNewsfeedStatus {
  me {
    organisation {
      newsfeed {
        url
        status
        error
        lastRefresh
        items(limit: 1) {
          title
          link
          localPostImagePath
          publishedAt
        }
      }
    }
  }
}
    `;
export const OrganisationGetPortalTypesDocument = gql`
    query organisationGetPortalTypes {
  me {
    organisation {
      portalTypes {
        id
        name
        tagline
        upcase
      }
    }
  }
}
    `;
export const CreateJobDocument = gql`
    mutation createJob($input: CreateJobInput!) {
  result: createJob(input: $input) {
    manualJob {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export const CreateOrganisationAddressDocument = gql`
    mutation createOrganisationAddress($input: OrganisationAddressAttributes!) {
  createOrganisationAddress(input: $input) {
    errors {
      field
      message
    }
    organisationAddress {
      id
      displayName
      subprofiles {
        id
      }
      fullDisplayName
      domainIds
      latitude
      longitude
      ort: city
    }
  }
}
    `;
export const DeleteJobDocument = gql`
    mutation deleteJob($id: Int!) {
  result: deleteJob(id: $id) {
    manualJob {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export const GetAllCompetencesDocument = gql`
    query getAllCompetences {
  allCompetences {
    id
    mainWord
    portalTypes {
      id
      name
    }
    words {
      id
      main
      keywords
      competenceTypes
    }
  }
}
    `;
export const GetCompetenceInfoDocument = gql`
    query getCompetenceInfo($jobId: ID!) {
  competenceInfo(jobId: $jobId) {
    id
    jobId
    userCompetenceWords {
      id
      main
    }
    deactivatedCompetences
    automaticCompetenceWords {
      id
      main
      competenceTypes
    }
  }
}
    `;
export const GetJobFormDataDocument = gql`
    query getJobFormData {
  tarifvertraege {
    id
    name
    year
    tarifvertragSalaryEntries {
      id
      salary
      salaryGroup
      level
    }
  }
  domains(visible: true) {
    id
    name
    filterTags
    logo(variant: same_height)
    linkColor
    hostname
    bereich
    cities(lang: de)
    importLocations
    region
  }
  me {
    organisation {
      benefitIds
      applyBenefitsToAllJobs
      externalJobboardParticipations {
        id
        title
        description
        active
        logoPath
        iconPath
      }
      applicantService {
        bureaucracyService
        companyLanguages
        familyService
        germanEducation
        housingService
        recognitionService
        socialService
        videoUsed
        visaService
        visitPossible
      }
      applyOption {
        screenerActive
        applicationQuestionIds
      }
      remoteIdEnabled: hasExternalBmsDelivery
      bmsTeams {
        id
        name
      }
      hasBms
      widgetNotUsed
      jobgptAccess
      widgetEmbeddedOnCareerPage
      bmsRecruiterIdentities {
        fullName
        email
      }
      applicationEntryMail
      bmsActive
      jobwertActive
      careerPageUrl
      careerPageUrlEn
      bmsUrl
      people(roleJobs: true) {
        displayName
        id
        name {
          lastName
          firstName
        }
        email
        publicEmail
        roleJobs
        photo(variant: medium)
        domainIds
        subprofileId
      }
      subprofiles {
        id
        name
      }
      memberships {
        domain {
          id
          name
          logo(variant: medium)
          portalType {
            name
          }
          filterTags
        }
      }
      addresses {
        id
        displayName
        subprofiles {
          id
        }
        fullDisplayName
        domainIds
        latitude
        longitude
        ort
      }
    }
  }
}
    `;
export const GetKeywordInfoDocument = gql`
    query getKeywordInfo($masterJobId: ID!) {
  keywordInfo(masterJobId: $masterJobId) {
    id
    userKeywords {
      name
      position
      searchCount
      searchLevel
    }
    suggestRunAt
    suggestDisabled
    keywordSuggestions {
      id
      searchCount
      searchLevel
      name
      source
      keywordResultId
      hiddenByUser
    }
    addedSuggestions {
      id
      searchCount
      searchLevel
      name
      source
      keywordResultId
      hiddenByUser
    }
    visibleKeywords
    maxKeywordCount
    minKeywordCount
    feedType
    userKeywordsStrong
    userKeywordsEnough
    masterJobId
    addSuggestions
  }
}
    `;
export const GetKeywordSuggestionsDocument = gql`
    query getKeywordSuggestions($source: String, $masterJobId: ID!) {
  keywordSuggestions(source: $source, masterJobId: $masterJobId) {
    id
    name
    searchCount
    hiddenByUser
  }
}
    `;
export const PreviewJobDocument = gql`
    mutation previewJob($input: PreviewJobInput!, $id: Int!) {
  previewJob(input: $input, id: $id) {
    html
  }
}
    `;
export const UpdateJobDocument = gql`
    mutation updateJob($input: UpdateJobInput!, $id: Int!) {
  result: updateJob(input: $input, id: $id) {
    manualJob {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export const JobGptResetDocument = gql`
    mutation JobGptReset($gptObjectId: ID!, $gptObjectType: String!) {
  jobGptReset(gptObjectId: $gptObjectId, gptObjectType: $gptObjectType) {
    gpt {
      __typename
      ... on JobGptOrganisation {
        ...GptOrganisation
      }
      ... on JobGptJob {
        ...GptJob
      }
      ... on JobGptVariant {
        ...GptVariant
      }
      ... on JobGptVariantMultiStep {
        ...GptVariantMultiStep
      }
    }
  }
}
    ${GptOrganisationFragmentDoc}
${GptJobFragmentDoc}
${GptVariantFragmentDoc}
${GptVariantMultiStepFragmentDoc}`;
export const JobGptResetTaskDocument = gql`
    mutation JobGptResetTask($gptObjectId: ID!, $gptObjectType: String!, $taskKey: String!) {
  jobGptResetTask(
    gptObjectId: $gptObjectId
    gptObjectType: $gptObjectType
    taskKey: $taskKey
  ) {
    gpt {
      __typename
      ... on JobGptOrganisation {
        ...GptOrganisation
      }
      ... on JobGptJob {
        ...GptJob
      }
      ... on JobGptVariant {
        ...GptVariant
      }
      ... on JobGptVariantMultiStep {
        ...GptVariantMultiStep
      }
    }
  }
}
    ${GptOrganisationFragmentDoc}
${GptJobFragmentDoc}
${GptVariantFragmentDoc}
${GptVariantMultiStepFragmentDoc}`;
export const GetGptObjectDocument = gql`
    query getGptObject($gptObjectId: ID!, $gptObjectType: String!) {
  gptObject(gptObjectId: $gptObjectId, gptObjectType: $gptObjectType) {
    __typename
    ... on JobGptOrganisation {
      ...GptOrganisation
    }
    ... on JobGptJob {
      ...GptJob
    }
    ... on JobGptVariant {
      ...GptVariant
    }
    ... on JobGptVariantMultiStep {
      ...GptVariantMultiStep
    }
  }
}
    ${GptOrganisationFragmentDoc}
${GptJobFragmentDoc}
${GptVariantFragmentDoc}
${GptVariantMultiStepFragmentDoc}`;
export const JobGptResetJobDocument = gql`
    mutation JobGptResetJob($id: ID!) {
  jobGptResetJob(id: $id) {
    gpt {
      ...GptJob
    }
  }
}
    ${GptJobFragmentDoc}`;
export const JobGptRunTaskDocument = gql`
    mutation jobGptRunTask($gptObjectId: ID!, $gptObjectType: String!, $taskId: ID!, $userInputs: [String!]) {
  jobGptRunTask(
    gptObjectId: $gptObjectId
    gptObjectType: $gptObjectType
    taskId: $taskId
    userInputs: $userInputs
  ) {
    taskRun {
      ...GptTaskRun
    }
    gpt {
      __typename
      ... on JobGptOrganisation {
        ...GptOrganisation
      }
      ... on JobGptJob {
        ...GptJob
      }
      ... on JobGptVariant {
        ...GptVariant
      }
      ... on JobGptVariantMultiStep {
        ...GptVariantMultiStep
      }
    }
  }
}
    ${GptTaskRunFragmentDoc}
${GptOrganisationFragmentDoc}
${GptJobFragmentDoc}
${GptVariantFragmentDoc}
${GptVariantMultiStepFragmentDoc}`;
export const JobGptSubmitFeedbackDocument = gql`
    mutation JobGptSubmitFeedback($taskRunId: ID!, $rating: Int!, $text: String) {
  jobGptSubmitFeedback(taskRunId: $taskRunId, rating: $rating, text: $text) {
    success
    taskRun {
      ...GptTaskRun
    }
  }
}
    ${GptTaskRunFragmentDoc}`;
export const JobGptUpdateJobDocument = gql`
    mutation jobGptUpdateJob($id: ID!, $input: JobGptJobInput!) {
  jobGptUpdateJob(id: $id, input: $input) {
    gpt {
      ...GptJob
    }
  }
}
    ${GptJobFragmentDoc}`;
export const JobGptUpdateOrganisationDocument = gql`
    mutation jobGptUpdateOrganisation($input: JobGptOrganisationInput!) {
  jobGptUpdateOrganisation(input: $input) {
    gpt {
      ...GptOrganisation
    }
  }
}
    ${GptOrganisationFragmentDoc}`;
export const JobGptUpdateVariantDocument = gql`
    mutation jobGptUpdateVariant($id: ID!, $input: JobGptVariantInput!) {
  jobGptUpdateVariant(id: $id, input: $input) {
    gpt {
      ...GptVariant
    }
  }
}
    ${GptVariantFragmentDoc}`;
export const JobGptUpdateVariantMultiStepDocument = gql`
    mutation jobGptUpdateVariantMultiStep($id: ID!, $input: JobGptVariantMultiStepInput!) {
  jobGptUpdateVariantMultiStep(id: $id, input: $input) {
    gpt {
      ...GptVariantMultiStep
    }
  }
}
    ${GptVariantMultiStepFragmentDoc}`;
export const MatchingJobsForQuestionFilterDocument = gql`
    query matchingJobsForQuestionFilter($filterKeywords: String, $filterLocations: String, $filterSubJobTypes: [String!]) {
  matchingJobsForQuestionFilter(
    filterKeywords: $filterKeywords
    filterLocations: $filterLocations
    filterSubJobTypes: $filterSubJobTypes
  )
}
    `;
export const OrganisationTourDocument = gql`
    query organisationTour($type: String!) {
  me {
    organisation {
      tour(type: $type) {
        items {
          key
          title
          description
          attachTo
        }
        type
      }
    }
  }
}
    `;
export const GetOrganisationNotificationsDocument = gql`
    query getOrganisationNotifications {
  me {
    organisation {
      hasSupport
      notifications {
        id
        identifier
        expiresAt
        createdAt
        message
        quickAction
        read
        sentAt
        severity
        subject
        personId
      }
    }
  }
}
    `;
export const OrganisationGetProfileDocument = gql`
    query organisationGetProfile {
  me {
    id
    username
    organisation {
      userEvents {
        id
        eventTranslated
        event
        effective
        date
      }
      rewardUsers {
        id
        link
        reward {
          id
          description
          userLinkOptional
          name
          logo(variant: medium)
        }
        year
      }
      portalTypes {
        id
        name
        tagline
        upcase
      }
      competences {
        id
        mainWord
      }
      sectors {
        id
        name
      }
      socialNetworks {
        id
        name
        url
      }
      divisions {
        id
        name
        nameEn
      }
      id
      name
      logo(variant: original)
      logoDark(variant: original)
      logoQuality {
        quality
        messages {
          name
          icon
          message
          quality
        }
      }
      logoDarkQuality {
        quality
        messages {
          name
          icon
          message
          quality
        }
      }
      description
      descriptionEn: description(lang: en)
      statement
      statementEn: statement(lang: en)
      unsolicitedApplicationAllowed
      receivesNoMails
      subprofilesActive
      widgetNotUsed
      jobgptAccess
      widgetEmbeddedOnCareerPage
      hasBms
      jobIntegrationType
      socialNetworkNames
      organizationType
      bmsActivationLevel
      hasApplicationMethod: hasExternalBmsDelivery
      externalBmsHandling
      baIgnored
      homeofficeByDefault
      indeedAtsActive
      employeeSurveysActive
      defaultLanguageLevelGerman
      subtitle
      sisaxProfileUrl
      personalforumMember
      showOnboarding
      talentsAccess
      showJobProgress
      warnEmailInJobDescription
      utmString
      ddfSponsor
      weight
      applicationMailType
      allowedHostsInJobs
      companyColor
      careerPageUrl
      careerPageUrlEn: careerPageUrl(lang: en)
      bmsUrl
      bmsUrlEn: bmsUrl(lang: en)
      applicationEntryMail
      pronoun
      newsfeedUrl
      feedimportActive
      anuLimited
      profileNotes
      euresExportBlocked
      hideRelatedJobs
      video
      baBranche
      mainUserAddressId
      applicationAddressId
      indeedAlias
      feedexportAlias
      feedexportActive
      linkedinExportEnabled
      linkedinCompanyId
      linkedinPostJobsToEbCompany
      descriptionPercentage
      aliasSuggestions
      hideKanaleoAward
      smartclickSetting {
        feedimportMax
        ignore
        ignoreUntil
        statisticUnreliable
        comment
        communityManagerActivityBoost
      }
      communityQuote {
        id
        quote
        quoteEn: quote(lang: en)
        communityQuoteRelevance
        author {
          id
          displayName
          photo(variant: portal)
        }
      }
      people {
        id
        displayName
      }
      addresses {
        id
        displayName
      }
      domains {
        id
        name
        logo(variant: thumb)
        favicon(variant: medium)
        filterTags
        portalType {
          name
        }
      }
      memberships {
        id
        lastSuccessfulJobSyncAt
        lastSuccessfulProfileSyncAt
        domain {
          name
          logo(variant: same_height)
          portalType {
            name
          }
        }
      }
      bmsActive
      jobwertActive
      fairekarriereActive
      coworkrActive
      userName
      applyBenefitsToAllJobs
      benefitIds
    }
  }
}
    `;
export const OrganisationGetTierDocument = gql`
    query organisationGetTier {
  tier {
    id
    organisation {
      id
      name
    }
    active
    tierLevel
    tierLevelKey
    currentAbilitySince
    bmsState
    coworkrState
    employeeSurveysState
    fairekarriereState
    jobwertState
    kanaleoState
    talentsState
    diff {
      key
      itemKey
      label
      current
      currentLabel
      default
      defaultLabel
      changed
      displayValue
      displayIcon
      displayClass
      hint
    }
    events {
      id
      admin
      triggeredBy
      eventType: type
      eventTypeLabel: typeLabel
      createdAt
      payload
      fromAbility {
        id
        tierLevel
      }
      toAbility {
        id
        tierLevel
      }
      identity {
        id
        email
      }
    }
    latestEvent {
      createdAt
    }
  }
}
    `;
export const ActivateEbmsIdentityDocument = gql`
    mutation activateEbmsIdentity($personId: Int!, $ebmsIdentityType: String!) {
  activateEbmsIdentity: peopleMutations {
    activateEbmsIdentity(personId: $personId, ebmsIdentityType: $ebmsIdentityType) {
      person {
        id
        firstName
        lastName
        identity {
          id
          hasEbmsIdentity
        }
      }
      errors {
        field
        message
      }
    }
  }
}
    `;
export const CreatePersonDocument = gql`
    mutation createPerson($input: PersonFormInput!) {
  result: createPerson(input: $input) {
    person {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export const GetPeopleDocument = gql`
    query getPeople($ids: [ID!]) {
  me {
    organisation {
      bmsActive
      memberships {
        id
        domain {
          name
          faviconUrl: favicon(variant: medium)
        }
      }
      people(ids: $ids) {
        id
        position
        title
        firstName
        lastName
        salutation
        displayFormat
        sortPriority
        publicEmail
        email
        telephone
        xingUrl
        linkedinUrl
        officeId
        applicationAddressId
        subprofileId
        membershipIds
        identity {
          id
          email
          verified
          lastLogin
          hasEbmsIdentity
        }
        photoUrl: photo(variant: portal)
        communicationRoles: roles(type: communication) {
          key
          title
          description
          short
          type
          validation
          validationText
        }
        functionalRoles: roles(type: functional) {
          key
          title
          description
          short
          type
          validation
          validationText
        }
        displayRoles: roles(type: display) {
          key
          title
          description
          short
          type
          validation
          validationText
        }
      }
    }
  }
}
    `;
export const GetPersonFormDocument = gql`
    query getPersonForm($id: [ID!]) {
  me {
    organisation {
      bmsActive
      memberships {
        id
        domain {
          name
          faviconUrl: favicon(variant: medium)
        }
      }
      addresses {
        value: id
        text: displayName
      }
      subprofiles {
        value: id
        text: name
      }
      availableRoles {
        key
        title
        description
        short
        type
        validation
        validationText
        available
      }
      people(ids: $id) {
        id
        position
        title
        firstName
        lastName
        salutation
        translatedSalutation
        displayFormat
        sortPriority
        publicEmail
        email
        telephone
        xingUrl
        linkedinUrl
        identity {
          id
          email
          verified
          lastLogin
          locale
          hasEbmsIdentity
        }
        officeId
        applicationAddressId
        subprofileId
        membershipIds
        photoUrl: photo(variant: bms_large)
        communicationRoles: roles(type: communication) {
          key
          title
          description
          short
          type
          validation
          validationText
        }
        functionalRoles: roles(type: functional) {
          key
          title
          description
          short
          type
          validation
          validationText
        }
        displayRoles: roles(type: display) {
          key
          title
          description
          short
          type
          validation
          validationText
        }
      }
    }
  }
}
    `;
export const UpdatePersonDocument = gql`
    mutation updatePerson($input: PersonFormInput!, $id: Int!) {
  result: updatePerson(input: $input, id: $id) {
    person {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export const ProfileFormsApplySettingsDocument = gql`
    mutation profileFormsApplySettings($value: ApplyOptionAttributes!) {
  profileFormsApplySettings(value: $value) {
    errors {
      field
      message
    }
    applyOption {
      id
    }
  }
}
    `;
export const ProfileFormsBenefitsDocument = gql`
    mutation profileFormsBenefits($value: [ID!]!) {
  profileFormsBenefits(value: $value) {
    errors {
      field
      message
    }
    benefits {
      id
      titleDe
      titleEn
    }
  }
}
    `;
export const ProfileFormsBmsStateDocument = gql`
    mutation profileFormsBmsState($key: String, $value: String) {
  profileFormsBmsState(key: $key, value: $value) {
    errors {
      field
      message
    }
    bmsState
  }
}
    `;
export const ProfileFormsChangeUserNameDocument = gql`
    mutation profileFormsChangeUserName($value: String!) {
  profileFormsChangeUserName(value: $value) {
    errors {
      field
      message
    }
    organisation {
      userName
    }
  }
}
    `;
export const ProfileFormsCommunityManagementDomainActivationsDocument = gql`
    mutation profileFormsCommunityManagementDomainActivations($key: String, $value: String) {
  profileFormsCommunityManagementDomainActivations(key: $key, value: $value) {
    errors {
      field
      message
    }
    organisation {
      id
      memberships(communitiesOnly: true) {
        id
        domain {
          id
          name
        }
        createdAt
      }
    }
  }
}
    `;
export const ProfileFormsCommunityManagementDomainDeactivationsDocument = gql`
    mutation profileFormsCommunityManagementDomainDeactivations($key: String, $value: String) {
  profileFormsCommunityManagementDomainDeactivations(key: $key, value: $value) {
    errors {
      field
      message
    }
    organisation {
      id
      domainDeactivations {
        id
        domain {
          id
          name
        }
        createdAt
      }
    }
  }
}
    `;
export const ProfileFormsCommunityQuoteDocument = gql`
    mutation profileFormsCommunityQuote($value: CommunityQuoteAttributes!) {
  profileFormsCommunityQuote(value: $value) {
    errors {
      field
      message
    }
    communityQuote {
      id
      quote
      quoteEn: quote(lang: en)
      author {
        id
        displayName
        photo(variant: portal)
      }
      communityQuoteRelevance
    }
  }
}
    `;
export const ProfileFormsCoworkrStateDocument = gql`
    mutation profileFormsCoworkrState($key: String, $value: String) {
  profileFormsCoworkrState(key: $key, value: $value) {
    errors {
      field
      message
    }
    coworkrState
  }
}
    `;
export const ProfileFormsDivisionsDocument = gql`
    mutation profileFormsDivisions($value: [DivisionAttributes!]!) {
  profileFormsDivisions(value: $value) {
    errors {
      field
      message
    }
    divisions {
      id
    }
  }
}
    `;
export const ProfileFormsEmployeeCountDocument = gql`
    mutation profileFormsEmployeeCount($value: EmployeeCountAttributes!) {
  profileFormsEmployeeCount(value: $value) {
    errors {
      field
      message
    }
    organisation {
      id
    }
  }
}
    `;
export const ProfileFormsEmployeeSurveysStateDocument = gql`
    mutation profileFormsEmployeeSurveysState($key: String, $value: String) {
  profileFormsEmployeeSurveysState(key: $key, value: $value) {
    errors {
      field
      message
    }
    employeeSurveysState
  }
}
    `;
export const ProfileFormsEmployerRatingPlatformsDocument = gql`
    mutation profileFormsEmployerRatingPlatforms($value: [EmployerRatingPlatformAttributes!]!) {
  profileFormsEmployerRatingPlatforms(value: $value) {
    errors {
      field
      message
    }
    employerRatingPlatforms {
      id
    }
  }
}
    `;
export const ProfileFormsFairekarriereStateDocument = gql`
    mutation profileFormsFairekarriereState($key: String, $value: String) {
  profileFormsFairekarriereState(key: $key, value: $value) {
    errors {
      field
      message
    }
    fairekarriereState
  }
}
    `;
export const ProfileFormsInternationalsDocument = gql`
    mutation profileFormsInternationals($value: InternationalsAttributes!) {
  profileFormsInternationals(value: $value) {
    errors {
      field
      message
    }
    applicantService {
      id
    }
  }
}
    `;
export const ProfileFormsJobwertStateDocument = gql`
    mutation profileFormsJobwertState($value: ServiceState!) {
  profileFormsJobwertState(value: $value) {
    errors {
      field
      message
    }
    jobwertState
  }
}
    `;
export const ProfileFormsKanaleoStateDocument = gql`
    mutation profileFormsKanaleoState($value: ServiceState!) {
  profileFormsKanaleoState(value: $value) {
    errors {
      field
      message
    }
    kanaleoState
  }
}
    `;
export const ProfileFormsPageFeatureAccessDocument = gql`
    mutation profileFormsPageFeatureAccess($key: String, $value: String!) {
  profileFormsPageFeatureAccess(key: $key, value: $value) {
    errors {
      field
      message
    }
    feature
    value
  }
}
    `;
export const ProfileFormsQuoteRelevanceDocument = gql`
    mutation profileFormsQuoteRelevance($key: String, $value: String!) {
  profileFormsQuoteRelevance(key: $key, value: $value) {
    errors {
      field
      message
    }
    quoteRelevance
  }
}
    `;
export const ProfileFormsRewardsDocument = gql`
    mutation profileFormsRewards($value: [RewardAttributes!]!) {
  profileFormsRewards(value: $value) {
    errors {
      field
      message
    }
    rewardUsers {
      id
    }
  }
}
    `;
export const ProfileFormsSmartclickSettingUpdateAttributeDocument = gql`
    mutation profileFormsSmartclickSettingUpdateAttribute($key: String!, $value: JSON!) {
  profileFormsSmartclickSettingUpdateAttribute(key: $key, value: $value) {
    smartclickSetting {
      ignore
      ignoreUntil
      feedimportMax
      statisticUnreliable
      comment
      communityManagerActivityBoost
      boostActive
    }
    errors {
      field
      message
    }
  }
}
    `;
export const ProfileFormsSocialNetworksDocument = gql`
    mutation profileFormsSocialNetworks($value: [SocialNetworkAttributes!]!) {
  profileFormsSocialNetworks(value: $value) {
    errors {
      field
      message
    }
    socialNetworks {
      id
      icon
      name
      url
    }
  }
}
    `;
export const ProfileFormsTalentsStateDocument = gql`
    mutation profileFormsTalentsState($key: String, $value: String) {
  profileFormsTalentsState(key: $key, value: $value) {
    errors {
      field
      message
    }
    talentsState
  }
}
    `;
export const ProfileFormsTierAbilityUpdateAttributeDocument = gql`
    mutation profileFormsTierAbilityUpdateAttribute($key: String!, $value: JSON!, $membershipIds: [ID!]) {
  profileFormsTierAbilityUpdateAttribute(
    key: $key
    value: $value
    membershipIds: $membershipIds
  ) {
    tierAbility {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export const ProfileFormsUpdateAttributeDocument = gql`
    mutation profileFormsUpdateAttribute($key: String!, $value: JSON!, $membershipIds: [ID!]) {
  profileFormsUpdateAttribute(
    key: $key
    value: $value
    membershipIds: $membershipIds
  ) {
    organisation {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export const ProfileFormsVideoDocument = gql`
    mutation profileFormsVideo($value: String) {
  profileFormsVideo(value: $value) {
    errors {
      field
      message
    }
    video
  }
}
    `;
export const GetStatisticApplicationDetailsDocument = gql`
    query getStatisticApplicationDetails($from: ISO8601Date!, $to: ISO8601Date!, $widget: Boolean, $onlyUnsolicited: Boolean, $onlyRecommended: Boolean, $onlyCoworkr: Boolean) {
  me {
    organisation {
      applicationStatistics(
        from: $from
        to: $to
        widget: $widget
        onlyUnsolicited: $onlyUnsolicited
        onlyRecommended: $onlyRecommended
        onlyCoworkr: $onlyCoworkr
      ) {
        allowedReference
        applicationIdentifier
        coworkrRecommender
        id
        isUnsolicited
        jobNummer
        jobTitle
        origin
        recommendationType
        recommendedBy
        senddate
      }
    }
  }
}
    `;
export const GetStatisticClicksDetailsDocument = gql`
    query getStatisticClicksDetails($from: ISO8601Date!, $to: ISO8601Date!, $widget: Boolean) {
  me {
    organisation {
      statistics: clicksStatistics(from: $from, to: $to, widget: $widget) {
        clicksCount
        count
        id
        jobDomain
        jobNummer
        jobTitle
        onlineDays
      }
    }
  }
}
    `;
export const GetStatisticCoworkrDetailsDocument = gql`
    query getStatisticCoworkrDetails($from: ISO8601Date!, $to: ISO8601Date!) {
  me {
    organisation {
      jobStatistics(from: $from, to: $to) {
        year
        month
        coworkrSubscribersCount
        coworkrReceivedMails
        coworkrOpenedMails
        coworkrEventsPerJob {
          nummer
          title
          clicks
          shares
        }
      }
    }
  }
}
    `;
export const GetStatisticImpressionsDetailsDocument = gql`
    query getStatisticImpressionsDetails($from: ISO8601Date!, $to: ISO8601Date!) {
  me {
    organisation {
      statistics: impressionStatistics(from: $from, to: $to) {
        count
        id
        jobDomain
        jobNummer
        jobTitle
        onlineDays
      }
    }
  }
}
    `;
export const GetStatisticSmartclickDetailsDocument = gql`
    query getStatisticSmartclickDetails($from: ISO8601Date!, $to: ISO8601Date!) {
  me {
    organisation {
      all: smartclicks(from: $from, to: $to, type: ALL)
      strong: smartclicks(from: $from, to: $to, type: STRONG)
      weak: smartclicks(from: $from, to: $to, type: WEAK)
    }
  }
}
    `;
export const GetStatisticUsedCodesDetailsDocument = gql`
    query getStatisticUsedCodesDetails($from: ISO8601Date!, $to: ISO8601Date!) {
  me {
    organisation {
      applicationStatistics: usedCodes(from: $from, to: $to) {
        id
        allowedReference
        applicationIdentifier
        coworkrRecommender
        isUnsolicited
        organisation
        jobTitle
        origin
        recommendationType
        senddate
      }
    }
  }
}
    `;
export const UpdateYearApplyStatisticDocument = gql`
    mutation updateYearApplyStatistic($input: [ApplyAttributes!]!) {
  updateApplyStatistics(input: $input) {
    jobStatistics {
      id
      userApplicationTotalCount
      userApplicationEmpfehlungsbundCount
      userHiredEmpfehlungsbundCount
      userHiredTotalCount
    }
    errors {
      field
      message
    }
  }
}
    `;
export const TierFeatureMatrixDocument = gql`
    query TierFeatureMatrix {
  tierFeatureMatrix {
    tierLevels {
      key
      title
      description
      features
    }
    featureCategories {
      services {
        label
        features {
          key
          label
          description
        }
      }
      internalFeatures {
        label
        features {
          key
          label
          description
        }
      }
      pageFeatures {
        label
        features {
          key
          label
          description
        }
      }
    }
    allFeatures {
      key
      label
      category
      type
      possibleValues
    }
  }
}
    `;
export const TierHistoryDocument = gql`
    query TierHistory($organisationId: ID!) {
  tierHistory(organisationId: $organisationId) {
    id
    tierLevel
    active
    currentAbilitySince
  }
}
    `;
export const TierSettingsDocument = gql`
    query TierSettings($organisationId: ID!, $tierType: String!) {
  tierSettings(organisationId: $organisationId, tierType: $tierType) {
    hasExisting
    settings {
      key
      label
      currentValue
      newValue
      changed
      isIndividual
      defaultValue
      displayValue
      displayIcon
      displayClass
      hint
    }
  }
}
    `;
export const TranslateDocument = gql`
    query translate($text: String!, $from: String!, $to: String!, $isHtml: Boolean!) {
  translate(text: $text, from: $from, to: $to, isHtml: $isHtml, engine: DEEPL)
}
    `;
export const GetBannerDataDocument = gql`
    query getBannerData($id: ID!) {
  me {
    organisation {
      banners(id: $id) {
        id
        ready
        url
        slots {
          position
          image {
            id
            url
            nativeResolution
          }
        }
        layout {
          resolution
          title
          slots {
            aspect
            height
            width
            position
            slots {
              height
              width
              aspect
              position
            }
          }
        }
      }
      uploadedBannerImages {
        id
        url
        nativeResolution
      }
    }
  }
}
    `;
export const UploadImageDocument = gql`
    mutation uploadImage($bannerId: ID!, $input: BannerUpdateInput!) {
  banners {
    update(bannerId: $bannerId, input: $input) {
      banner {
        id
        url
        ready
        slots {
          position
          image {
            id
            url
            nativeResolution
          }
        }
      }
    }
  }
}
    `;
export const EmployeeSurveysCreateDepartmentDocument = gql`
    mutation employeeSurveysCreateDepartment($organisationSurveyId: ID!, $input: DepartmentInput!) {
  result: employeeSurveysCreateDepartment(
    organisationSurveyId: $organisationSurveyId
    input: $input
  ) {
    department {
      ...EmployeeSurveysDepartmentFragment
    }
    errors {
      field
      message
    }
  }
}
    ${EmployeeSurveysDepartmentFragmentFragmentDoc}`;
export const EmployeeSurveysCreateParticipantDocument = gql`
    mutation employeeSurveysCreateParticipant($organisationSurveyId: ID!, $input: ParticipantInput!) {
  result: employeeSurveysCreateParticipant(
    organisationSurveyId: $organisationSurveyId
    input: $input
  ) {
    participant {
      ...EmployeeSurveysParticipantFragment
    }
    errors {
      message
      field
    }
  }
}
    ${EmployeeSurveysParticipantFragmentFragmentDoc}`;
export const EmployeeSurveysDeleteDepartmentDocument = gql`
    mutation employeeSurveysDeleteDepartment($departmentId: ID!) {
  employeeSurveysDeleteDepartment(departmentId: $departmentId) {
    department {
      id
    }
    errors {
      message
      field
    }
  }
}
    `;
export const EmployeeSurveysDeleteParticipantDocument = gql`
    mutation employeeSurveysDeleteParticipant($id: ID!) {
  result: employeeSurveysDeleteParticipant(id: $id) {
    participant {
      id
    }
    errors {
      message
      field
    }
  }
}
    `;
export const GetEmployeeSurveyDocument = gql`
    query getEmployeeSurvey($id: ID!) {
  getOrganisationSurvey(id: $id) {
    id
    greeting
    parts {
      ...EmployeeSurveysPartFragment
    }
  }
}
    ${EmployeeSurveysPartFragmentFragmentDoc}`;
export const GetGlobalOrganisationSurveyDocument = gql`
    query getGlobalOrganisationSurvey($id: ID!) {
  getOrganisationSurvey(id: $id) {
    id
    greeting
    internalName
    parts {
      ...EmployeeSurveysPartFragment
    }
  }
  models: employeeSurveyModels {
    id
    name
    description
    year
    author
    updatedYear
    shortCode
    variables
    instrument
    asHtml
  }
}
    ${EmployeeSurveysPartFragmentFragmentDoc}`;
export const GetGlobalOrganisationSurveysDocument = gql`
    query getGlobalOrganisationSurveys {
  surveys: globalSurveys {
    id
    internalName
    parts {
      ...EmployeeSurveysPartFragment
    }
  }
  models: employeeSurveyModels {
    id
    name
    description
    year
    author
    updatedYear
    shortCode
    variables
    instrument
    asHtml
  }
}
    ${EmployeeSurveysPartFragmentFragmentDoc}`;
export const EmployeSurveysGetParticipantsDocument = gql`
    query employeSurveysGetParticipants($surveyId: ID!) {
  getOrganisationSurvey(id: $surveyId) {
    ageGroupOptions {
      text
      value
    }
    seniorityOptions {
      text
      value
    }
    genderOptions {
      text
      value
    }
    locationOptions {
      text
      value
    }
    participants {
      ...EmployeeSurveysParticipantFragment
    }
    departments {
      ...EmployeeSurveysDepartmentFragment
    }
  }
}
    ${EmployeeSurveysParticipantFragmentFragmentDoc}
${EmployeeSurveysDepartmentFragmentFragmentDoc}`;
export const EmployeeSurveysGetSurveyQuestionsForParticipantDocument = gql`
    query employeeSurveysGetSurveyQuestionsForParticipant($id: ID!, $participantId: ID) {
  survey: getOrganisationSurvey(id: $id) {
    parts {
      id
      description
      position
      surveyPartType
      questions(forParticipantId: $participantId) {
        id
        position
        modelCode
        text
        answerType
        answerOptionsLocalized {
          text
          value
        }
      }
    }
  }
}
    `;
export const EmployeeSurveysUpdateDepartmentDocument = gql`
    mutation employeeSurveysUpdateDepartment($departmentId: ID!, $input: DepartmentInput!) {
  result: employeeSurveysUpdateDepartment(
    departmentId: $departmentId
    input: $input
  ) {
    department {
      ...EmployeeSurveysDepartmentFragment
    }
    errors {
      field
      message
    }
  }
}
    ${EmployeeSurveysDepartmentFragmentFragmentDoc}`;
export const EmployeeSurveyUpdateOrganisationSurveyQuestionsDocument = gql`
    mutation employeeSurveyUpdateOrganisationSurveyQuestions($surveyId: ID!, $parts: [PartInput!]!, $adminMode: Boolean) {
  result: organisationSurveyUpdateQuestions(
    surveyId: $surveyId
    parts: $parts
    adminMode: $adminMode
  ) {
    survey {
      id
      greeting
      internalName
      parts {
        global
        id
        title
        descriptionDe
        descriptionEn
        surveyPartType
        position
        questions {
          id
          position
          textDe
          textEn
          readOnly
          modelCode
          answerType
          answerOptions {
            de
            en
            value
          }
        }
      }
    }
    errors {
      field
      message
    }
  }
}
    `;
export const EmployeeSurveysUpdateParticipantDocument = gql`
    mutation employeeSurveysUpdateParticipant($id: ID!, $input: UpdateParticipantInput!) {
  result: employeeSurveysUpdateParticipant(id: $id, input: $input) {
    participant {
      ...EmployeeSurveysParticipantFragment
    }
    errors {
      message
      field
    }
  }
}
    ${EmployeeSurveysParticipantFragmentFragmentDoc}`;
export const ProfileFormsKanaleoDepartmentSelectionsDocument = gql`
    mutation profileFormsKanaleoDepartmentSelections($key: String, $value: [DepartmentSelectionArgument!]!) {
  profileFormsKanaleoDepartmentSelections(key: $key, value: $value) {
    errors {
      field
      message
    }
  }
}
    `;
export const ProfileFormsKanaleoServiceProvidersDocument = gql`
    mutation profileFormsKanaleoServiceProviders($key: String, $value: [Int!]!) {
  profileFormsKanaleoServiceProviders(key: $key, value: $value) {
    errors {
      field
      message
    }
    serviceProviders {
      id
    }
  }
}
    `;
export const KanaleoUpdateAttributeDocument = gql`
    mutation kanaleoUpdateAttribute($key: String!, $value: JSON!) {
  kanaleoUpdateAttribute: kanaleoSurveySettingUpdateAttribute(
    key: $key
    value: $value
  ) {
    errors {
      field
      message
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    ChangeTierLevel(variables: ChangeTierLevelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangeTierLevelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeTierLevelMutation>(ChangeTierLevelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangeTierLevel', 'mutation');
    },
    getCmBubblePeople(variables?: GetCmBubblePeopleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCmBubblePeopleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCmBubblePeopleQuery>(GetCmBubblePeopleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCmBubblePeople', 'query');
    },
    getDomains(variables?: GetDomainsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDomainsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDomainsQuery>(GetDomainsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDomains', 'query');
    },
    updateDashboardLayout(variables: UpdateDashboardLayoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDashboardLayoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDashboardLayoutMutation>(UpdateDashboardLayoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDashboardLayout', 'mutation');
    },
    fkCreateMetascoreProfile(variables: FkCreateMetascoreProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FkCreateMetascoreProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FkCreateMetascoreProfileMutation>(FkCreateMetascoreProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fkCreateMetascoreProfile', 'mutation');
    },
    fkDeleteMetascoreProfile(variables: FkDeleteMetascoreProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FkDeleteMetascoreProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FkDeleteMetascoreProfileMutation>(FkDeleteMetascoreProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fkDeleteMetascoreProfile', 'mutation');
    },
    fkUpdateMetascoreProfile(variables: FkUpdateMetascoreProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FkUpdateMetascoreProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FkUpdateMetascoreProfileMutation>(FkUpdateMetascoreProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fkUpdateMetascoreProfile', 'mutation');
    },
    fkUpdateOrganisationSetting(variables: FkUpdateOrganisationSettingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FkUpdateOrganisationSettingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FkUpdateOrganisationSettingMutation>(FkUpdateOrganisationSettingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fkUpdateOrganisationSetting', 'mutation');
    },
    generateRejectionFeedback(variables: GenerateRejectionFeedbackQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateRejectionFeedbackQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateRejectionFeedbackQuery>(GenerateRejectionFeedbackDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateRejectionFeedback', 'query');
    },
    getApplyStatistics(variables: GetApplyStatisticsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetApplyStatisticsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetApplyStatisticsQuery>(GetApplyStatisticsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getApplyStatistics', 'query');
    },
    getAppointmentReviewModalData(variables?: GetAppointmentReviewModalDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAppointmentReviewModalDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAppointmentReviewModalDataQuery>(GetAppointmentReviewModalDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAppointmentReviewModalData', 'query');
    },
    getGlobalProfileInfo(variables?: GetGlobalProfileInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetGlobalProfileInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGlobalProfileInfoQuery>(GetGlobalProfileInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGlobalProfileInfo', 'query');
    },
    getOrganisationApplicantServices(variables?: GetOrganisationApplicantServicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrganisationApplicantServicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrganisationApplicantServicesQuery>(GetOrganisationApplicantServicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrganisationApplicantServices', 'query');
    },
    getOrganisationApplyOption(variables?: GetOrganisationApplyOptionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrganisationApplyOptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrganisationApplyOptionQuery>(GetOrganisationApplyOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrganisationApplyOption', 'query');
    },
    organisationGetEmployeeCount(variables?: OrganisationGetEmployeeCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganisationGetEmployeeCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganisationGetEmployeeCountQuery>(OrganisationGetEmployeeCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organisationGetEmployeeCount', 'query');
    },
    getOrganisationForCertificateGenerator(variables?: GetOrganisationForCertificateGeneratorQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrganisationForCertificateGeneratorQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrganisationForCertificateGeneratorQuery>(GetOrganisationForCertificateGeneratorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrganisationForCertificateGenerator', 'query');
    },
    organisationKarmaHistory(variables?: OrganisationKarmaHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganisationKarmaHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganisationKarmaHistoryQuery>(OrganisationKarmaHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organisationKarmaHistory', 'query');
    },
    getOrganisationNewsfeedStatus(variables?: GetOrganisationNewsfeedStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrganisationNewsfeedStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrganisationNewsfeedStatusQuery>(GetOrganisationNewsfeedStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrganisationNewsfeedStatus', 'query');
    },
    organisationGetPortalTypes(variables?: OrganisationGetPortalTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganisationGetPortalTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganisationGetPortalTypesQuery>(OrganisationGetPortalTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organisationGetPortalTypes', 'query');
    },
    createJob(variables: CreateJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateJobMutation>(CreateJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createJob', 'mutation');
    },
    createOrganisationAddress(variables: CreateOrganisationAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrganisationAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrganisationAddressMutation>(CreateOrganisationAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrganisationAddress', 'mutation');
    },
    deleteJob(variables: DeleteJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteJobMutation>(DeleteJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteJob', 'mutation');
    },
    getAllCompetences(variables?: GetAllCompetencesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllCompetencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllCompetencesQuery>(GetAllCompetencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllCompetences', 'query');
    },
    getCompetenceInfo(variables: GetCompetenceInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCompetenceInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCompetenceInfoQuery>(GetCompetenceInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCompetenceInfo', 'query');
    },
    getJobFormData(variables?: GetJobFormDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetJobFormDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetJobFormDataQuery>(GetJobFormDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getJobFormData', 'query');
    },
    getKeywordInfo(variables: GetKeywordInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetKeywordInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetKeywordInfoQuery>(GetKeywordInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getKeywordInfo', 'query');
    },
    getKeywordSuggestions(variables: GetKeywordSuggestionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetKeywordSuggestionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetKeywordSuggestionsQuery>(GetKeywordSuggestionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getKeywordSuggestions', 'query');
    },
    previewJob(variables: PreviewJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewJobMutation>(PreviewJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewJob', 'mutation');
    },
    updateJob(variables: UpdateJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateJobMutation>(UpdateJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateJob', 'mutation');
    },
    JobGptReset(variables: JobGptResetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobGptResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobGptResetMutation>(JobGptResetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'JobGptReset', 'mutation');
    },
    JobGptResetTask(variables: JobGptResetTaskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobGptResetTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobGptResetTaskMutation>(JobGptResetTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'JobGptResetTask', 'mutation');
    },
    getGptObject(variables: GetGptObjectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetGptObjectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGptObjectQuery>(GetGptObjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGptObject', 'query');
    },
    JobGptResetJob(variables: JobGptResetJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobGptResetJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobGptResetJobMutation>(JobGptResetJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'JobGptResetJob', 'mutation');
    },
    jobGptRunTask(variables: JobGptRunTaskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobGptRunTaskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobGptRunTaskMutation>(JobGptRunTaskDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'jobGptRunTask', 'mutation');
    },
    JobGptSubmitFeedback(variables: JobGptSubmitFeedbackMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobGptSubmitFeedbackMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobGptSubmitFeedbackMutation>(JobGptSubmitFeedbackDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'JobGptSubmitFeedback', 'mutation');
    },
    jobGptUpdateJob(variables: JobGptUpdateJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobGptUpdateJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobGptUpdateJobMutation>(JobGptUpdateJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'jobGptUpdateJob', 'mutation');
    },
    jobGptUpdateOrganisation(variables: JobGptUpdateOrganisationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobGptUpdateOrganisationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobGptUpdateOrganisationMutation>(JobGptUpdateOrganisationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'jobGptUpdateOrganisation', 'mutation');
    },
    jobGptUpdateVariant(variables: JobGptUpdateVariantMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobGptUpdateVariantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobGptUpdateVariantMutation>(JobGptUpdateVariantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'jobGptUpdateVariant', 'mutation');
    },
    jobGptUpdateVariantMultiStep(variables: JobGptUpdateVariantMultiStepMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<JobGptUpdateVariantMultiStepMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<JobGptUpdateVariantMultiStepMutation>(JobGptUpdateVariantMultiStepDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'jobGptUpdateVariantMultiStep', 'mutation');
    },
    matchingJobsForQuestionFilter(variables?: MatchingJobsForQuestionFilterQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MatchingJobsForQuestionFilterQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatchingJobsForQuestionFilterQuery>(MatchingJobsForQuestionFilterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchingJobsForQuestionFilter', 'query');
    },
    organisationTour(variables: OrganisationTourQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganisationTourQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganisationTourQuery>(OrganisationTourDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organisationTour', 'query');
    },
    getOrganisationNotifications(variables?: GetOrganisationNotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrganisationNotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrganisationNotificationsQuery>(GetOrganisationNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrganisationNotifications', 'query');
    },
    organisationGetProfile(variables?: OrganisationGetProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganisationGetProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganisationGetProfileQuery>(OrganisationGetProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organisationGetProfile', 'query');
    },
    organisationGetTier(variables?: OrganisationGetTierQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganisationGetTierQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganisationGetTierQuery>(OrganisationGetTierDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organisationGetTier', 'query');
    },
    activateEbmsIdentity(variables: ActivateEbmsIdentityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivateEbmsIdentityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivateEbmsIdentityMutation>(ActivateEbmsIdentityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'activateEbmsIdentity', 'mutation');
    },
    createPerson(variables: CreatePersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePersonMutation>(CreatePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPerson', 'mutation');
    },
    getPeople(variables?: GetPeopleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPeopleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPeopleQuery>(GetPeopleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPeople', 'query');
    },
    getPersonForm(variables?: GetPersonFormQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPersonFormQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPersonFormQuery>(GetPersonFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPersonForm', 'query');
    },
    updatePerson(variables: UpdatePersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePersonMutation>(UpdatePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePerson', 'mutation');
    },
    profileFormsApplySettings(variables: ProfileFormsApplySettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsApplySettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsApplySettingsMutation>(ProfileFormsApplySettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsApplySettings', 'mutation');
    },
    profileFormsBenefits(variables: ProfileFormsBenefitsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsBenefitsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsBenefitsMutation>(ProfileFormsBenefitsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsBenefits', 'mutation');
    },
    profileFormsBmsState(variables?: ProfileFormsBmsStateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsBmsStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsBmsStateMutation>(ProfileFormsBmsStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsBmsState', 'mutation');
    },
    profileFormsChangeUserName(variables: ProfileFormsChangeUserNameMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsChangeUserNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsChangeUserNameMutation>(ProfileFormsChangeUserNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsChangeUserName', 'mutation');
    },
    profileFormsCommunityManagementDomainActivations(variables?: ProfileFormsCommunityManagementDomainActivationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsCommunityManagementDomainActivationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsCommunityManagementDomainActivationsMutation>(ProfileFormsCommunityManagementDomainActivationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsCommunityManagementDomainActivations', 'mutation');
    },
    profileFormsCommunityManagementDomainDeactivations(variables?: ProfileFormsCommunityManagementDomainDeactivationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsCommunityManagementDomainDeactivationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsCommunityManagementDomainDeactivationsMutation>(ProfileFormsCommunityManagementDomainDeactivationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsCommunityManagementDomainDeactivations', 'mutation');
    },
    profileFormsCommunityQuote(variables: ProfileFormsCommunityQuoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsCommunityQuoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsCommunityQuoteMutation>(ProfileFormsCommunityQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsCommunityQuote', 'mutation');
    },
    profileFormsCoworkrState(variables?: ProfileFormsCoworkrStateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsCoworkrStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsCoworkrStateMutation>(ProfileFormsCoworkrStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsCoworkrState', 'mutation');
    },
    profileFormsDivisions(variables: ProfileFormsDivisionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsDivisionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsDivisionsMutation>(ProfileFormsDivisionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsDivisions', 'mutation');
    },
    profileFormsEmployeeCount(variables: ProfileFormsEmployeeCountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsEmployeeCountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsEmployeeCountMutation>(ProfileFormsEmployeeCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsEmployeeCount', 'mutation');
    },
    profileFormsEmployeeSurveysState(variables?: ProfileFormsEmployeeSurveysStateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsEmployeeSurveysStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsEmployeeSurveysStateMutation>(ProfileFormsEmployeeSurveysStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsEmployeeSurveysState', 'mutation');
    },
    profileFormsEmployerRatingPlatforms(variables: ProfileFormsEmployerRatingPlatformsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsEmployerRatingPlatformsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsEmployerRatingPlatformsMutation>(ProfileFormsEmployerRatingPlatformsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsEmployerRatingPlatforms', 'mutation');
    },
    profileFormsFairekarriereState(variables?: ProfileFormsFairekarriereStateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsFairekarriereStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsFairekarriereStateMutation>(ProfileFormsFairekarriereStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsFairekarriereState', 'mutation');
    },
    profileFormsInternationals(variables: ProfileFormsInternationalsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsInternationalsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsInternationalsMutation>(ProfileFormsInternationalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsInternationals', 'mutation');
    },
    profileFormsJobwertState(variables: ProfileFormsJobwertStateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsJobwertStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsJobwertStateMutation>(ProfileFormsJobwertStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsJobwertState', 'mutation');
    },
    profileFormsKanaleoState(variables: ProfileFormsKanaleoStateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsKanaleoStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsKanaleoStateMutation>(ProfileFormsKanaleoStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsKanaleoState', 'mutation');
    },
    profileFormsPageFeatureAccess(variables: ProfileFormsPageFeatureAccessMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsPageFeatureAccessMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsPageFeatureAccessMutation>(ProfileFormsPageFeatureAccessDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsPageFeatureAccess', 'mutation');
    },
    profileFormsQuoteRelevance(variables: ProfileFormsQuoteRelevanceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsQuoteRelevanceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsQuoteRelevanceMutation>(ProfileFormsQuoteRelevanceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsQuoteRelevance', 'mutation');
    },
    profileFormsRewards(variables: ProfileFormsRewardsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsRewardsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsRewardsMutation>(ProfileFormsRewardsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsRewards', 'mutation');
    },
    profileFormsSmartclickSettingUpdateAttribute(variables: ProfileFormsSmartclickSettingUpdateAttributeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsSmartclickSettingUpdateAttributeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsSmartclickSettingUpdateAttributeMutation>(ProfileFormsSmartclickSettingUpdateAttributeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsSmartclickSettingUpdateAttribute', 'mutation');
    },
    profileFormsSocialNetworks(variables: ProfileFormsSocialNetworksMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsSocialNetworksMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsSocialNetworksMutation>(ProfileFormsSocialNetworksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsSocialNetworks', 'mutation');
    },
    profileFormsTalentsState(variables?: ProfileFormsTalentsStateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsTalentsStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsTalentsStateMutation>(ProfileFormsTalentsStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsTalentsState', 'mutation');
    },
    profileFormsTierAbilityUpdateAttribute(variables: ProfileFormsTierAbilityUpdateAttributeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsTierAbilityUpdateAttributeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsTierAbilityUpdateAttributeMutation>(ProfileFormsTierAbilityUpdateAttributeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsTierAbilityUpdateAttribute', 'mutation');
    },
    profileFormsUpdateAttribute(variables: ProfileFormsUpdateAttributeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsUpdateAttributeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsUpdateAttributeMutation>(ProfileFormsUpdateAttributeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsUpdateAttribute', 'mutation');
    },
    profileFormsVideo(variables?: ProfileFormsVideoMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsVideoMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsVideoMutation>(ProfileFormsVideoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsVideo', 'mutation');
    },
    getStatisticApplicationDetails(variables: GetStatisticApplicationDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStatisticApplicationDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStatisticApplicationDetailsQuery>(GetStatisticApplicationDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStatisticApplicationDetails', 'query');
    },
    getStatisticClicksDetails(variables: GetStatisticClicksDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStatisticClicksDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStatisticClicksDetailsQuery>(GetStatisticClicksDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStatisticClicksDetails', 'query');
    },
    getStatisticCoworkrDetails(variables: GetStatisticCoworkrDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStatisticCoworkrDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStatisticCoworkrDetailsQuery>(GetStatisticCoworkrDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStatisticCoworkrDetails', 'query');
    },
    getStatisticImpressionsDetails(variables: GetStatisticImpressionsDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStatisticImpressionsDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStatisticImpressionsDetailsQuery>(GetStatisticImpressionsDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStatisticImpressionsDetails', 'query');
    },
    getStatisticSmartclickDetails(variables: GetStatisticSmartclickDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStatisticSmartclickDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStatisticSmartclickDetailsQuery>(GetStatisticSmartclickDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStatisticSmartclickDetails', 'query');
    },
    getStatisticUsedCodesDetails(variables: GetStatisticUsedCodesDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetStatisticUsedCodesDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetStatisticUsedCodesDetailsQuery>(GetStatisticUsedCodesDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getStatisticUsedCodesDetails', 'query');
    },
    updateYearApplyStatistic(variables: UpdateYearApplyStatisticMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateYearApplyStatisticMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateYearApplyStatisticMutation>(UpdateYearApplyStatisticDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateYearApplyStatistic', 'mutation');
    },
    TierFeatureMatrix(variables?: TierFeatureMatrixQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TierFeatureMatrixQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TierFeatureMatrixQuery>(TierFeatureMatrixDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TierFeatureMatrix', 'query');
    },
    TierHistory(variables: TierHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TierHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TierHistoryQuery>(TierHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TierHistory', 'query');
    },
    TierSettings(variables: TierSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TierSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TierSettingsQuery>(TierSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TierSettings', 'query');
    },
    translate(variables: TranslateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TranslateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TranslateQuery>(TranslateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'translate', 'query');
    },
    getBannerData(variables: GetBannerDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetBannerDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBannerDataQuery>(GetBannerDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBannerData', 'query');
    },
    uploadImage(variables: UploadImageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UploadImageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UploadImageMutation>(UploadImageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uploadImage', 'mutation');
    },
    employeeSurveysCreateDepartment(variables: EmployeeSurveysCreateDepartmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeeSurveysCreateDepartmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeeSurveysCreateDepartmentMutation>(EmployeeSurveysCreateDepartmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeeSurveysCreateDepartment', 'mutation');
    },
    employeeSurveysCreateParticipant(variables: EmployeeSurveysCreateParticipantMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeeSurveysCreateParticipantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeeSurveysCreateParticipantMutation>(EmployeeSurveysCreateParticipantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeeSurveysCreateParticipant', 'mutation');
    },
    employeeSurveysDeleteDepartment(variables: EmployeeSurveysDeleteDepartmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeeSurveysDeleteDepartmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeeSurveysDeleteDepartmentMutation>(EmployeeSurveysDeleteDepartmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeeSurveysDeleteDepartment', 'mutation');
    },
    employeeSurveysDeleteParticipant(variables: EmployeeSurveysDeleteParticipantMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeeSurveysDeleteParticipantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeeSurveysDeleteParticipantMutation>(EmployeeSurveysDeleteParticipantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeeSurveysDeleteParticipant', 'mutation');
    },
    getEmployeeSurvey(variables: GetEmployeeSurveyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEmployeeSurveyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEmployeeSurveyQuery>(GetEmployeeSurveyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getEmployeeSurvey', 'query');
    },
    getGlobalOrganisationSurvey(variables: GetGlobalOrganisationSurveyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetGlobalOrganisationSurveyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGlobalOrganisationSurveyQuery>(GetGlobalOrganisationSurveyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGlobalOrganisationSurvey', 'query');
    },
    getGlobalOrganisationSurveys(variables?: GetGlobalOrganisationSurveysQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetGlobalOrganisationSurveysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGlobalOrganisationSurveysQuery>(GetGlobalOrganisationSurveysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGlobalOrganisationSurveys', 'query');
    },
    employeSurveysGetParticipants(variables: EmployeSurveysGetParticipantsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeSurveysGetParticipantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeSurveysGetParticipantsQuery>(EmployeSurveysGetParticipantsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeSurveysGetParticipants', 'query');
    },
    employeeSurveysGetSurveyQuestionsForParticipant(variables: EmployeeSurveysGetSurveyQuestionsForParticipantQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeeSurveysGetSurveyQuestionsForParticipantQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeeSurveysGetSurveyQuestionsForParticipantQuery>(EmployeeSurveysGetSurveyQuestionsForParticipantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeeSurveysGetSurveyQuestionsForParticipant', 'query');
    },
    employeeSurveysUpdateDepartment(variables: EmployeeSurveysUpdateDepartmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeeSurveysUpdateDepartmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeeSurveysUpdateDepartmentMutation>(EmployeeSurveysUpdateDepartmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeeSurveysUpdateDepartment', 'mutation');
    },
    employeeSurveyUpdateOrganisationSurveyQuestions(variables: EmployeeSurveyUpdateOrganisationSurveyQuestionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeeSurveyUpdateOrganisationSurveyQuestionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeeSurveyUpdateOrganisationSurveyQuestionsMutation>(EmployeeSurveyUpdateOrganisationSurveyQuestionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeeSurveyUpdateOrganisationSurveyQuestions', 'mutation');
    },
    employeeSurveysUpdateParticipant(variables: EmployeeSurveysUpdateParticipantMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmployeeSurveysUpdateParticipantMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmployeeSurveysUpdateParticipantMutation>(EmployeeSurveysUpdateParticipantDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'employeeSurveysUpdateParticipant', 'mutation');
    },
    profileFormsKanaleoDepartmentSelections(variables: ProfileFormsKanaleoDepartmentSelectionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsKanaleoDepartmentSelectionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsKanaleoDepartmentSelectionsMutation>(ProfileFormsKanaleoDepartmentSelectionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsKanaleoDepartmentSelections', 'mutation');
    },
    profileFormsKanaleoServiceProviders(variables: ProfileFormsKanaleoServiceProvidersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProfileFormsKanaleoServiceProvidersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileFormsKanaleoServiceProvidersMutation>(ProfileFormsKanaleoServiceProvidersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'profileFormsKanaleoServiceProviders', 'mutation');
    },
    kanaleoUpdateAttribute(variables: KanaleoUpdateAttributeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<KanaleoUpdateAttributeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<KanaleoUpdateAttributeMutation>(KanaleoUpdateAttributeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'kanaleoUpdateAttribute', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;